import type { Dict } from '../types';

export const it: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Questo workspace non ha più posti disponibili. Aggiungi posti per invitare i colleghi.",
  "workspaceInvite.seatsExhaustedAction": "Vedi posti e piano",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Questa email è già un membro del team.",
  "workspaceInvite.errorPendingInvite": "Questa email ha già un invito in sospeso.",
  "workspaceInvite.errorNoSession": "Accedi al tuo account Vela prima di invitare membri.",
  "workspaceInvite.errorNoWorkspace": "Non c'è ancora uno spazio del team a cui invitare membri.",
  "workspaceInvite.errorUnreachable": "Impossibile inviare l'invito. Riprova più tardi.",
  'chat.amrCard.switchTitle': 'Chiamata al modello fallita — questa esecuzione è in pausa',
  'chat.amrCard.switchBody': 'Passa al servizio modelli OpenDesign Cloud ufficiale di OpenDesign Cloud — nessuna chiave API da configurare. Dopo accesso, autorizzazione e ricarica, questa esecuzione verrà ritentata automaticamente.',
  'chat.amrCard.chipOfficial': 'Hosting ufficiale',
  'chat.amrCard.chipNoKey': 'Senza chiave API',
  'chat.amrCard.chipAutoRetry': 'Ritenta automatico dopo l\'accesso',
  'chat.amrCard.switchCta': 'Passa a OpenDesign Cloud',
  "chat.amrCard.switchedResend": "Passaggio a OpenDesign Cloud completato. Invia di nuovo la richiesta.",
  'chat.amrError.authMessage': 'Il tuo account OpenDesign Cloud non è ancora autorizzato. Autorizzalo e questa esecuzione verrà ritentata automaticamente.',
  'chat.amrError.balanceMessage': 'Il tuo saldo OpenDesign Cloud è esaurito. Ricarica per continuare questa esecuzione.',
  'chat.amrError.authorizeCta': 'Autorizza e riprova',
  'chat.amrError.rechargeCta': 'Ricarica',
  'chat.amrBalanceGate.title': 'Fai l’upgrade e continua a creare',
  'chat.amrBalanceGate.message': 'Crediti insufficienti (restano {balance}). Aggiorna il piano o ricarica e l’attività potrà partire subito.',
  'chat.amrBalanceGate.benefitsTitle': 'Cosa ti offre OpenDesign Cloud',
  'chat.amrBalanceGate.benefit1': 'Niente chiavi API, ampia scelta di modelli',
  'chat.amrBalanceGate.benefit2': 'Agente di design SOTA integrato, zero configurazione',
  'chat.amrBalanceGate.benefit3': 'Servizio ufficiale e affidabile',
  'chat.amrBalanceGate.benefit4': 'In continua evoluzione: deploy in 1 clic, multimodale, team e altro',
  'chat.amrBalanceGate.laterCta': 'Non ora',
  'chat.amrBalanceGate.plansCta': 'Aggiorna piano',
  'chat.amrBalanceGate.signedOutTitle': 'Accedi per iniziare a creare',
  'chat.amrBalanceGate.signedOutMessage': 'Stai usando l’agente OpenDesign Cloud: accedi e questa attività potrà partire subito.',
  'chat.amrBalanceGate.signInCta': 'Accedi',
  'chat.amrBalanceGate.watchingWallet': 'Continueremo automaticamente non appena il saldo verrà aggiornato.',
  'chat.amrArtifactUpgrade.title': 'Continua a perfezionare con modelli più potenti',
  'chat.amrArtifactUpgrade.message': 'Sblocca modelli avanzati, più attività in parallelo e più crediti mensili.',
  'chat.amrArtifactUpgrade.benefit1': 'Più modelli avanzati, tra cui Fable 5 e GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Fino a 10 volte più attività in parallelo',
  'chat.amrArtifactUpgrade.benefit3': 'Fino a 300 volte più crediti mensili',
  'chat.amrArtifactUpgrade.benefit4': 'Coda prioritaria nelle ore di punta per generazioni più rapide',
  'chat.amrArtifactUpgrade.promoBanner': 'Offerta limitata: risparmia fino al 67% sugli abbonamenti',
  'chat.amrArtifactUpgrade.countdownLabel': 'Termina tra',
  'chat.amrArtifactUpgrade.plansCta': 'Passa ora a un piano superiore, fino al 67% di sconto',
  'chat.amrArtifactUpgrade.homePlansCta': 'Risparmia il 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Continua con Free e invia',
  'chat.amrArtifactUpgrade.homeTitle': 'La tua creazione è pronta. Porta più lontano la prossima idea.',
  'chat.amrArtifactUpgrade.homeMessage': 'Passa a modelli più potenti, più attività in parallelo e più crediti mensili.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Vedi creazione',
  'chat.antigravityError.launchTerminalCta': 'Accedi tramite terminale',
  'chat.antigravityError.launchSwitchModelCta': 'Cambia modello nel terminale',
  'chat.connectionDropped': 'Verifica che la connessione di rete funzioni, quindi riprova.',
  'chat.runError.title.authRequired': 'Autorizzazione richiesta',
  'chat.runError.title.balance': 'Saldo insufficiente',
  'chat.runError.title.connectionDropped': 'Connessione di rete interrotta',
  'chat.runError.title.signInRequired.other': '{agent} non ha effettuato l’accesso',
  'chat.runError.title.signInRequired.amr': 'Open Design non ha effettuato l’accesso',
  'chat.runError.title.rateLimited': 'Servizio del modello congestionato',
  'chat.runError.title.modelWindowLimit': 'Traffico elevato',
  'chat.runError.title.membershipConcurrencyLimit': 'Limite di attività simultanee raggiunto',
  'chat.runError.title.strategyTaskHalted': "Attività fermata dal controllo qualità",
  "chat.runError.title.agentReplyIncomplete": "Impossibile completare l’attività",
  'chat.runError.title.noDeliverable': "Da questo giro non è uscito nessun file",
  'chat.runError.title.clarificationRepeated': "L'agente ha fatto un'altra domanda",
  "chat.runError.title.regionNotSupported": "Questo servizio non è attualmente disponibile nella tua regione",
  'chat.runError.title.clientEnvironment': 'Problema con l’ambiente di rete',
  "chat.runError.title.certificateFailure": "Impossibile connettersi al servizio in modo sicuro",
  "chat.runError.certificateFailureMessage": "La connessione al servizio non ha superato la verifica di sicurezza. Prova a usare un’altra rete.",
  "chat.runError.title.proxyConfiguration": "Impossibile connettersi al proxy",
  "chat.runError.proxyConfigurationMessage": "Il proxy configurato non è raggiungibile. Verifica che sia attivo e configurato correttamente, poi riprova.",
  "chat.runError.title.networkConfiguration": "Impossibile connettersi al servizio",
  "chat.runError.networkConfigurationMessage": "Il servizio è temporaneamente irraggiungibile. Controlla la connessione di rete e riprova.",
  "chat.runError.title.hostPolicyBlock": "Avvio del programma bloccato",
  "chat.runError.hostPolicyBlockMessage": "Windows ha impedito l’avvio del programma. Controlla le impostazioni di sicurezza del sistema.",
  "chat.runError.title.localStorageFailure": "Impossibile salvare il file",
  "chat.runError.localStorageFailureMessage": "Non è stato possibile scrivere il file sul disco. Verifica che ci sia spazio libero sufficiente e di avere il permesso di salvare nella cartella attuale.",
  "chat.runError.title.tierUpgradeRequired": "Il piano attuale non supporta questa attività",
  "chat.runError.tierUpgradeRequiredMessage": "Il piano attuale non consente di continuare questa attività. Passa a un piano superiore e riprova.",
  "chat.runError.title.generic": "Impossibile completare l’attività",
  'chat.runError.title.artifactMissing': "Nessun file da visualizzare in anteprima",
  'chat.runError.artifactMissingMessage': "Questa attività non ha prodotto file da visualizzare in anteprima. Aggiungi ciò che vuoi generare e riprova.",
  'chat.runError.signInMessage.amr': 'Accedi per vedere i tuoi progetti e continuare la conversazione.',
  'chat.runError.signInMessage.other': 'Accedi prima a {agent}, poi riprova.',
  'chat.runError.agentFallback': 'l\'agente',
  'chat.runError.sourceLabel': "Dettagli dell'errore",
  'chat.runError.sourceExpandAria': "Espandi l'origine dell'errore",
  'chat.runError.sourceCollapseAria': "Comprimi l'origine dell'errore",
  'chat.runError.title.cliMissing': '{agent} non rilevato',
  'chat.runError.title.promptTooLarge': 'Conversazione troppo lunga',
  'chat.runError.title.modelUnavailable': "Il modello attuale non è disponibile",
  'chat.runError.title.modelCapabilityUnsupported': "Il modello attuale non supporta questa attività",
  'chat.runError.title.upstreamUnavailable': 'Servizio del modello non disponibile',
  "chat.runError.title.toolLoop": "L’attività non può continuare",
  'chat.runError.title.outputInvalid': 'Nessuna risposta valida generata',
  'chat.runError.title.runtimeConfig': "Errore di esecuzione di Open Design",
  'chat.runError.title.apiKeyInvalid': 'Impostazioni del modello incomplete',
  'chat.runError.cliMissingMessage': "Verifica che {agent} sia installato su questo computer, quindi riprova.",
  "chat.runError.promptTooLargeMessage": "Il contesto attuale supera la lunghezza che il modello può elaborare. Crea una nuova conversazione e riprova.",
  'chat.runError.modelUnavailableMessage': "Scegli un altro modello disponibile e riprova.",
  'chat.runError.modelCapabilityUnsupportedMessage': "Questo modello non supporta le funzioni richieste dall’attività. Cambia modello e riprova.",
  'chat.runError.rateLimitedMessage': "In questo momento ci sono molte richieste a questo servizio del modello ed è stato raggiunto il limite di frequenza del fornitore. Riprova più tardi oppure prova a passare a un altro modello.",
  'chat.runError.modelWindowLimitMessage': 'Al momento il traffico è elevato. Riprova dopo le {retryAt}. Questa richiesta non è stata addebitata.',
  'chat.runError.modelWindowLimitMessageNoTime': 'Al momento il traffico è elevato. Riprova tra poco. Questa richiesta non è stata addebitata.',
  'chat.runError.membershipConcurrencyLimitMessage': 'Il limite di attività simultanee del tuo abbonamento è stato raggiunto. Attendi fino alle {retryAt}, poi riprova, oppure cambia agente. Riprovare subito non aiuta.',
  'chat.runError.membershipConcurrencyLimitMessageNoTime': 'Il limite di attività simultanee del tuo abbonamento è stato raggiunto. Attendi la fine di un’altra attività, poi riprova, oppure cambia agente.',
  'chat.runError.upstreamUnavailableMessage': "Il modello attuale è temporaneamente non disponibile. Riprova più tardi oppure cambia modello.",
  "chat.runError.toolLoopMessage": "L’IA si è bloccata sullo stesso passaggio e non è riuscita a continuare dopo diversi tentativi. Riprova oppure cambia modello e riprova.",
  'chat.runError.outputInvalidMessage': "Prova a rigenerare, oppure cambia modello e riprova. Se il problema persiste, contatta l’assistenza.",
  'chat.runError.runtimeConfigMessage': "Prova a rigenerare, oppure cambia modello e riprova. Se il problema persiste, contatta l’assistenza.",
  'chat.runError.apiKeyInvalidMessage': 'La chiave API è configurata in modo errato. Inseriscila di nuovo, quindi riprova.',
  'chat.runError.title.quotaExhausted': "Quota esaurita",
  'chat.runError.title.timedOut': "Tempo di attesa della risposta scaduto",
  "chat.runError.title.emptyOutput": "Impossibile generare contenuti",
  "chat.runError.title.sessionExpired": "Impossibile riprendere l’attività precedente",
  'chat.runError.title.gitBashMissing': "Git Bash mancante",
  "chat.runError.title.cpuUnsupported": "Questo dispositivo non può eseguire il programma",
  'chat.runError.title.cliSessionRefused': "Versione dell’agente incompatibile",
  'chat.runError.quotaExhaustedMessage': "La quota o il limite di fatturazione del tuo servizio di modello è esaurito, quindi riprovare non servirà. Ricarica presso il tuo provider o passa a un altro modello o servizio.",
  'chat.runError.workspaceCreditsMessage': "Il tuo spazio di lavoro ha esaurito i crediti. Aggiungi crediti (o chiedi al proprietario dello spazio di ricaricare) oppure passa a un altro modello o servizio.",
  'chat.runError.timedOutMessage': "Da molto tempo non arriva una nuova risposta dall’IA, quindi questa esecuzione è stata interrotta. Riprova più tardi.",
  'chat.runError.inactivityTimeoutMessage': "Da molto tempo non arriva una nuova risposta dall’IA, quindi questa esecuzione è stata interrotta. Riprova più tardi.",
  "chat.runError.emptyOutputMessage": "L’IA non è riuscita a generare contenuti. Avvia nuovamente l’attività oppure cambia modello e riprova.",
  "chat.runError.sessionExpiredMessage": "L’attività precedente non può più continuare. Avvia nuovamente l’attività.",
  'chat.runError.gitBashMissingMessage': "Per eseguire questo agente su Windows è necessario Git Bash, ma non è stato trovato. Installa Git per Windows e riprova.",
  "chat.runError.cpuUnsupportedMessage": "Il processore di questo computer non supporta le funzionalità richieste dal programma. Usa un dispositivo che soddisfi i requisiti di sistema.",
  "chat.runError.title.agentCrashed": "Attività interrotta in modo imprevisto",
  'chat.runError.agentCrashedMessage': 'Prova a rigenerare, oppure cambia modello e riprova. Se il problema persiste, contatta l’assistenza.',
  'chat.runError.title.accountSuspended': 'Account sospeso',
  'chat.runError.accountSuspendedMessage': 'Per conoscere il motivo o chiedere il ripristino, contatta l’assistenza.',
  "chat.runError.fallbackMessage": "L'esecuzione di questa attività non è riuscita. Riprova. Se non riesce di nuovo, contatta l'assistenza.",
  "chat.runError.cliSessionRefusedMessage": "Open Design non supporta ancora questa versione dell’agente. Passa a una versione supportata e riprova.",
  'chat.runError.strategyTaskStateMismatchMessage': "Questa attività è già stata fermata dal controllo qualità della strategia, quindi questo giro del modulo non può continuare. Riprova la richiesta o avviane una nuova.",
  "chat.runError.agentReplyIncompleteMessage": "L'esecuzione di questa attività non è riuscita. Riprova. Se non riesce di nuovo, contatta l'assistenza.",
  'chat.runError.noDeliverableMessage': "L'agente ha finito, ma nel progetto non c'è ancora un file apribile, quindi l'attività non è stata registrata come consegnata. Nulla di ciò che hai inviato è andato perso: riprova, o aggiungi una riga su cosa vuoi.",
  'chat.runError.clarificationRepeatedMessage': "L'agente ha chiesto altri dettagli una seconda volta, ma un'attività prevede un solo giro di domande, quindi si è fermato qui. Le tue risposte restano nella conversazione: riprovare fa ripartire la richiesta da capo e, inserendo subito quei dettagli, di solito basta un solo giro.",
  "chat.runError.regionNotSupportedMessage": "Il fornitore al momento non offre il servizio nella tua area geografica. L’attività corrente non può proseguire.",
  'chat.runError.clientEnvironmentMessage': 'Sembra che la richiesta sia passata da un proxy o da una rete aziendale e {agent} l’ha rifiutata ({cause}). Prova un’altra uscita di rete oppure regola il proxy nelle Impostazioni.',
  'chat.runError.clientEnvironmentCause.certificate': 'verifica del certificato non riuscita',
  'chat.runError.clientEnvironmentCause.proxy': 'problema di configurazione del proxy',
  'chat.runError.clientEnvironmentCause.network': 'rete irraggiungibile',
  'chat.runError.clientEnvironmentCause.hostPolicy': 'bloccato da un criterio di sistema',
  'chat.runError.clientEnvironmentCause.localStorage': 'lettura/scrittura dell’archivio locale non riuscita',
  'common.cancel': 'Annulla',
  'chat.selectFromLibrary': 'Importa dalla libreria',
  'chat.importFigma': 'Importa da Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Importa dalla libreria',
  'designFiles.library.title': 'Importa dalla libreria',
  'libraryPicker.title': 'Importa dalla libreria',
  'libraryPicker.searchPlaceholder': 'Cerca nella libreria…',
  'libraryPicker.empty': 'Nessuna risorsa nella tua libreria',
  'libraryPicker.allKinds': 'Tutti',
  'libraryPicker.add': 'Importa',
  'libraryPicker.loading': 'Caricamento…',
  'common.save': 'Salva',
  'common.close': 'Chiudi',
  'common.clear': 'Cancella',
  'common.delete': 'Elimina',
  'common.rename': 'Rinomina',
  'common.edit': 'Modifica',
  'common.preview': 'Anteprima',
  'common.share': 'Condividi',
  'common.search': 'Cerca',
  'common.searchEllipsis': 'Cerca…',
  'common.loading': 'Caricamento…',
  'common.all': 'Tutto',
  'common.none': 'Nessuno',
  'common.default': 'Predefinito',
  'common.installed': 'installato',
  'common.notInstalled': 'non installato',
  'common.active': 'attivo',
  'common.inactive': 'inattivo',
  'common.offline': 'offline',
  'common.selected': 'selezionato',
  'common.create': 'Crea',
  'common.openPreview': 'Apri anteprima',
  'common.exitFullscreen': 'Esci da schermo intero',
  'common.fullscreen': 'Schermo intero',
  'common.openInNewTab': 'Apri in una nuova scheda',
  'common.exportPdf': 'Esporta in PDF',
  'common.exportZip': 'Scarica come .zip',
  'common.exportHtml': 'Esporta in HTML autonomo',
  'common.exportImage': 'Esporta come immagine',
  'common.exportImageFailed': 'Acquisizione immagine fallita. Riprova o usa lo strumento di screenshot del browser.',
  'common.justNow': 'proprio ora',
  'common.minutesAgo': '{n} min fa',
  'common.hoursAgo': '{n} h fa',
  'common.daysAgo': '{n} g fa',
  'common.weeksAgo': '{n} sett. fa',
  'common.now': 'ora',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} g',
  'common.untitled': 'Senza titolo',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'Desktop',
  'designBrowser.viewport.desktopTitle': 'Usa le dimensioni complete della scheda del browser',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Anteprima a 820px di larghezza',
  'designBrowser.viewport.mobile': 'Cellulare',
  'designBrowser.viewport.mobileTitle': 'Anteprima a 390px di larghezza',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Aggiungi alla chat',
  'designBrowser.status.imageAddedToChat': 'Immagine aggiunta alla chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Provenienza',
  'plugins.availableDetails.provenanceLine': 'da {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'da {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Installa',
  'plugins.availableDetails.version': 'Versione',
  'plugins.availableDetails.pluginVersion': 'Versione plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copia comando di installazione',
  'plugins.availableDetails.copied': 'Copiato',
  'plugins.availableDetails.deprecatedPrefix': 'Obsoleto: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Questa versione è stata contrassegnata come obsoleta.',
  'plugins.availableDetails.yanked': 'Ritirata.',
  'plugins.availableDetails.yankedWithReason': 'Ritirata: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (obsoleto)',
  'plugins.availableDetails.versionYankedSuffix': ' (ritirato)',
  'plugins.availableDetails.ref': 'Rif.',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Autorizzazioni',
  'plugins.availableDetails.capabilitySummary': 'Riepilogo delle capacità',
  'plugins.actions.copyInstallCommand': 'Copia comando di installazione',
  'plugins.actions.copyPluginId': 'Copia ID plugin',
  'plugins.actions.copyReadmeBadge': 'Copia badge README',
  'plugins.actions.openSourceGithub': 'Apri sorgente su GitHub',
  'plugins.actions.openSource': 'Apri sorgente',
  'plugins.actions.openHomepage': 'Apri homepage',
  'plugins.actions.openMarketplace': 'Apri nel marketplace',
  'app.brand': 'WEBART',
  'app.brandPill': 'Anteprima di ricerca',
  'app.brandSubtitle': 'di Nexu Labs',
  'app.welcomeLoading': 'Caricamento dello spazio di lavoro…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Ti diamo il benvenuto in OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Inizia da un brief',
  'settings.onboardingCreateBody': 'Descrivi il sito, l\'app, la presentazione, l\'immagine o il video che desideri. OpenDesign creerà un progetto e manterrà il lavoro modificabile.',
  'settings.onboardingMemoryTitle': 'Salva il contesto di lavoro',
  'settings.onboardingMemoryBody': 'Aggiungi preferenze, informazioni sul progetto e regole ricorrenti affinché le chat future utilizzino il contesto corretto.',
  'settings.onboardingMemoryCalloutTitle': 'Salvato nella tua Memoria',
  'settings.onboardingMemoryCalloutBody': 'Queste risposte costituiscono la base del tuo profilo di Memoria. OpenDesign la riutilizza in ogni attività e continua a imparare mentre lavori.',
  'settings.onboardingMemoryBenefitIntent': 'Capisce cosa intendi da una richiesta breve',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Salta le domande di configurazione ripetute',
  'settings.onboardingMemoryBenefitPersonalized': 'Adatta i risultati al tuo ruolo, al tuo pubblico e ai tuoi gusti',
  'settings.onboardingSystemsTitle': 'Porta il tuo design system',
  'settings.onboardingSystemsBody': 'Scegli o crea un sistema di brand affinché il lavoro generato segua colori, tipografia e linguaggio di prodotto reali.',
  'settings.onboardingExecutionTitle': 'Scegli l’origine del modello',
  'settings.onboardingExecutionBody': 'Usa OpenDesign Hosted, collega un agente locale oppure utilizza la tua chiave del modello.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Consigliato ufficialmente',
  'settings.onboardingAmrCloudBenefitReady': 'Senza deploy',
  'settings.onboardingAmrCloudBenefitModels': 'Accedi a Claude, GPT, Fable 5 e 5.6 sol con uno sconto a tempo limitato e alta concorrenza.',
  'settings.onboardingAmrCloudBenefitPricing': 'Harness SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'In arrivo',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Immagini e video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills in massa',
  'settings.onboardingAmrCloudUpcomingRouting': 'Routing intelligente',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autorizza OpenDesign Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorizzato',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Crea un design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Resta aggiornato',
  'settings.onboardingNewsletterTitle': 'Resta aggiornato',
  'settings.onboardingNewsletterBody': 'Ricevi novità di prodotto, nuovi template, design system e attività degli ambassador nella tua casella. Opzionale — puoi saltare.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Accedi a OpenDesign',
  'settings.onboardingCloudBody': 'Accedi e inizia subito a progettare con l’IA nel cloud, senza configurazioni complesse.',
  'settings.onboardingCloudSignIn': 'Accedi a OpenDesign',
  'settings.onboardingCloudContinue': 'Continua (accesso effettuato)',
  'settings.onboardingCloudAlternative': 'Usa una CLI locale o la tua chiave API',
  'settings.onboardingCloudRights': 'Tutti i diritti riservati.',
  'settings.onboardingCloudOr': 'o',
  'settings.onboardingGateTooltipNoRuntime': 'I passaggi successivi vengono eseguiti tramite IA — scegli un runtime per continuare.',
  'settings.onboardingGateTooltipAmr': 'I passaggi successivi vengono eseguiti tramite IA — accedi a OpenDesign Cloud per continuare.',
  'settings.onboardingGateTooltipLocal': 'I passaggi successivi vengono eseguiti tramite IA — seleziona una CLI locale disponibile per continuare.',
  'settings.onboardingGateTooltipByok': 'I passaggi successivi vengono eseguiti tramite IA — aggiungi e testa la tua chiave del modello per continuare.',
  'settings.onboardingRecommended': 'Consigliato',
  'settings.onboardingAmrCloudOfficialBadge': 'Ufficiale',
  'settings.onboardingLocalTitle': 'Agente locale',
  'settings.onboardingLocalBody': 'Usa Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro e altri.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Usa la tua chiave',
  'settings.onboardingByokBody': 'Collega in sicurezza il provider di modelli preferito con la tua chiave API.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'Informazioni su di te',
  'settings.onboardingProfileBody': 'Dettagli facoltativi per impostazioni predefinite migliori.',
  'settings.onboardingRoleLabel': 'Il tuo ruolo',
  'settings.onboardingOrgSizeLabel': 'Dimensioni dell\'organizzazione',
  'settings.onboardingUseCaseLabel': 'Caso d\'uso',
  'settings.onboardingSourceLabel': 'Come ci hai conosciuti?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Motori di ricerca (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Strumenti AI (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Amico o collega',
  'settings.onboardingSourceCommunity': '💬 Discord / community',
  'settings.onboardingSourceEmail': '✉️ Email / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / articolo',
  'settings.onboardingSourceOther': '✨ Altro',
  'settings.onboardingSourceOtherPlaceholder': 'Dicci dove (facoltativo)',
  'settings.onboardingSelectPlaceholder': 'Seleziona un\'opzione',
  'settings.onboardingSelectMultiplePlaceholder': 'Seleziona una o più opzioni',
  'settings.onboardingOrgSolo': 'Individuale / personale (1)',
  'settings.onboardingOrgTeam': 'Piccolo team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / PMI (11-50)',
  'settings.onboardingOrgGrowth': 'Azienda in crescita (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Sviluppatore',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Agenzia di marketing',
  'settings.onboardingRoleGrowth': '📈 Crescita',
  'settings.onboardingRoleOps': '⚙️ Operazioni',
  'settings.onboardingRoleFounder': '🚀 Fondatore / dirigente',
  'settings.onboardingRoleStudent': '🎓 Studente / docente',
  'settings.onboardingRoleOther': '✨ Altro',
  'settings.onboardingUseProduct': '🎨 Design di prodotto',
  'settings.onboardingUseDesignSystem': '🧩 Sistema di design',
  'settings.onboardingUsePrototype': '📱 Prototipo / UI dell\'app',
  'settings.onboardingUseLanding': '🌐 Landing page',
  'settings.onboardingUseAds': '📣 Annunci / contenuti social',
  'settings.onboardingUseDashboard': '📊 Dashboard / strumenti interni',
  'settings.onboardingUseDeck': '🖥️ Presentazione / slide',
  'settings.onboardingUseMarketing': '📈 Marketing / crescita',
  'settings.onboardingUseEngineering': '🤝 Handoff allo sviluppo',
  'settings.onboardingUseAgency': '💼 Lavoro per agenzia / cliente',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Impostazioni',
  'settings.title': 'Modelli e provider',
  'settings.subtitle': 'Scegli tra CLI locale e BYOK.',
  'settings.general': 'Generali',
  'settings.generalHint': 'Lingua, aspetto, notifiche, posizioni dei progetti, privacy e dettagli dell’app.',
  'settings.modeAria': 'Modalità di esecuzione',
  'settings.protocolAria': 'Protocollo API',
  'settings.modeDaemon': 'CLI locale',
  'settings.modeDaemonHelp': 'Esegui tramite un agente CLI sulla tua macchina',
  'settings.modeDaemonOffline': 'Il daemon non è in esecuzione',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} installato/i',
  'settings.modeApi': 'Provider API',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'Provider API',
  'settings.byokNoFileToolsNotice': 'BYOK non può leggere, scrivere o modificare i file del progetto. Usa la Local CLI quando hai bisogno di modifiche al codice.',
  'settings.byokDraftNotice': 'Completa i campi obbligatori per salvare questo provider. La configurazione attuale rimarrà attiva.',
  'settings.codeAgent': 'Agente di codice',
  'settings.codeAgentHint': 'Rilevato analizzando il tuo PATH. Scegli la CLI attraverso cui verranno eseguite le generazioni.',
  'settings.rescan': '↻ Rianalizza',
  'settings.rescanTitle': 'Rianalizza il PATH',
  'settings.rescanRunning': 'Analisi in corso...',
  'settings.rescanSuccess': 'Analisi completata. {count} disponibile/i.',
  'settings.designSystemRenameFailed': 'Rinomina non riuscita. Controlla il daemon e riprova.',
  'settings.rescanFailed': 'Analisi fallita. Controlla il daemon e riprova.',
  'settings.test': 'Testa',
  'settings.testTitle': 'Invia un piccolo messaggio di test per verificare la connessione',
  'settings.testRunning': 'Test della connessione…',
  'settings.byokReadyToTest': 'Pronto per il test',
  'settings.testCancel': 'Annulla',
  'settings.testRetry': 'Riprova il test',
  'settings.required': 'obbligatorio',
  'settings.testMissingFields': 'Compila {fields} per testare la connessione.',
  'settings.testSuccessApi': 'Connesso. Risposto in {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ha risposto in {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Autenticazione fallita. Controlla la tua chiave API.',
  'settings.testForbidden': 'Accesso negato. Controlla account, regione o organizzazione.',
  'settings.testNotFoundModel': 'Modello \'{model}\' non trovato su questo endpoint.',
  'settings.testInvalidModelId': 'L\'id del modello \'{model}\' non è valido. Gli id personalizzati devono iniziare con una lettera o un numero e non contenere spazi.',
  'settings.testInvalidBaseUrl': 'L\'URL di base non è valido o non è accessibile.',
  'settings.testRateLimited': 'Il provider ha limitato il test. La configurazione sembra valida.',
  'settings.testUpstream': 'Il provider ha restituito {status}. Riprova tra un momento.',
  'settings.testTimeout': 'Il test è scaduto dopo {ms} ms.',
  'settings.testAgentMissing': '{agentName} non è installato o non è nel PATH.',
  'settings.testAgentSpawn': 'Impossibile avviare {agentName}: {detail}.',
  'settings.testUnknown': 'Test fallito: {detail}',
  'settings.agentInstall.install': 'Installa',
  'settings.agentInstall.docs': 'Documentazione',
  'settings.agentInstall.pathHint': 'Se hai installato una CLI con npm o Homebrew e appare ancora come non installata, verifica che la cartella bin dello strumento sia nel PATH ereditato dal daemon OpenDesign (Terminale e app GUI possono differire su macOS). Vedi QUICKSTART.md (sezione "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Apri Installa o Documentazione per l\'agente desiderato.',
  'settings.agentInstall.stepAuth': 'Autenticati con la CLI del provider (login o aggiunta delle credenziali API) prima di tornare in OpenDesign.',
  'settings.agentInstall.stepRescan': 'Clicca su Rianalizza in questa sezione.',
  'settings.agentInstall.stepSelect': 'Seleziona la scheda dell\'agente una volta che appare come installato.',
  'settings.noAgentsDetected': 'Nessun agente rilevato per ora. Installa Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen o GitHub Copilot CLI, poi clicca su Rianalizza.',
  'settings.agentInstalledGroup': 'Le tue CLI ({count})',
  'settings.agentInstallGroup': 'Disponibili per l\'installazione ({count})',
  'settings.agentAuthRequired': 'Autenticazione richiesta',
  'settings.agentAuthUnknown': 'Stato di autenticazione sconosciuto',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'Autorizza',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Molti modelli',
  'settings.amrPromoBonus': 'Bonus limitato: +100%',
  'settings.amrSignInToContinue': 'Accedi per continuare',
  'settings.amrSignIn': 'Accedi',
  'settings.amrSignedIn': 'Accesso effettuato',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'Accesso non effettuato',
  'settings.amrSigningIn': 'Accesso in corso…',
  'settings.amrActivationHint': 'La pagina di accesso non si è aperta? Tocca il pulsante qui sotto per riaprirla.',
  'settings.amrActivationBrowserFailed': 'Impossibile aprire il browser automaticamente. Apri la pagina di accesso qui sotto per continuare.',
  'settings.amrActivationOpen': 'Apri la pagina di accesso',
  'settings.amrCancelSignIn': 'Annulla accesso',
  'settings.amrAccountStatus': 'Stato account OpenDesign Cloud',
  'settings.amrConsole': 'Gestisci',
  'settings.amrBalance': 'Quota',
  'settings.amrPlan': 'Piano',
  'settings.amrUpgrade': 'Esegui upgrade',
  'settings.amrModelUpgradeHint': 'Esegui upgrade per usarlo',
  'settings.amrLoginErrorCompact': 'Accesso OpenDesign Cloud non riuscito.',
  'settings.advanced': 'Avanzate',
  'settings.amrLogin': 'Accedi',
  'settings.amrLogout': 'Esci',
  'settings.amrLoggingIn': 'Accesso in corso…',
  'settings.amrLoggingOut': 'Disconnessione in corso…',
  'settings.amrLoggedInAs': 'Accesso effettuato come {email}',
  'settings.amrLoggedInWithPlan': 'Connesso come {email} · {plan}',
  'settings.amrLoggedInPill': 'Accesso effettuato',
  'settings.amrNotLoggedIn': 'Accesso non effettuato',
  'settings.apiSection': 'API Anthropic',
  'settings.quickFillProvider': 'Compilazione rapida del provider',
  'settings.providerPreset': 'Preset provider',
  'settings.protocolGroupProtocols': 'Protocolli',
  'settings.protocolGroupGateways': 'Gateway',
  'settings.customProvider': 'Provider personalizzato',
  'settings.apiKey': 'Chiave API',
  'settings.apiKeyGetLink': 'Ottieni chiave ↗',
  'settings.showKey': 'Mostra chiave',
  'settings.hideKey': 'Nascondi chiave',
  'settings.show': 'Mostra',
  'settings.hide': 'Nascondi',
  'settings.model': 'Modello',
  'settings.apiKeyInvalid': 'API key non valida.',
  'settings.apiKeyCleaned': 'Spazi vuoti aggiuntivi rimossi dalla API key.',
  'settings.modelsLoadedFromAccount': '✓ Caricati {count} modelli dal tuo account.',
  'settings.modelsLoadedCount': '✓ Caricati {count} modelli.',
  'settings.modelSourceAccount': 'Dal tuo account',
  'settings.modelSourceSuggested': 'Suggerito',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Costo basso',
  'modelCost.halfToOne': 'Costo medio',
  'modelCost.oneToFour': 'Costo alto',
  'modelCost.overFour': 'Costo massimo',
  'settings.fetchModels': 'Recupera modelli',
  'settings.fetchModelsTitle': 'Recupera i modelli disponibili da questo provider',
  'settings.fetchModelsRunning': 'Recupero dei modelli…',
  'settings.fetchModelsMissingFields': 'Compila {fields} per recuperare i modelli.',
  'settings.fetchModelsInvalidBaseUrl': 'Inserisci un Base URL valido per recuperare i modelli.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI usa i nomi di deployment, quindi l\'individuazione dei modelli non è disponibile qui.',
  'settings.fetchModelsUnsupportedOllama': 'L\'individuazione dei modelli di Ollama Cloud non è ancora disponibile. Scegli o digita un modello.',
  'settings.fetchModelsSuccess': 'Recuperati {count} modelli.',
  'settings.fetchModelsEmpty': 'Nessun modello di testo compatibile restituito.',
  'settings.fetchModelsUnsupported': 'L\'individuazione dei modelli non è disponibile per questo protocollo.',
  'settings.fetchModelsFailed': 'Impossibile recuperare i modelli: {detail}',
  'settings.suggestedModelsHint': 'Questi sono modelli suggeriti per questo protocollo. Il tuo provider potrebbe supportare altri modelli.',
  'settings.baseUrl': 'URL di base',
  'settings.baseUrlInvalid': 'Usa un URL pubblico http:// o https://.',
  'settings.baseUrlCustomize': 'Personalizza URL',
  'settings.baseUrlDefaultHint': 'Modificalo solo se usi un proxy o un gateway compatibile.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Lo trovi nel portale Azure → la tua risorsa → Endpoint.',
  'settings.azureDeploymentModel': 'Nome del deployment',
  'settings.azureCustomDeploymentName': 'Nome di deployment personalizzato',
  'settings.azureDeploymentModelHint': 'Per Azure OpenAI, questo campo viene utilizzato come nome del deployment in /openai/deployments/<model>. Inserisci il nome del deployment creato in Azure.',
  'settings.azureModelFetchHint': 'Inserisci il nome del deployment dalla tua risorsa Azure. I deployment Azure non possono essere recuperati automaticamente.',
  'settings.apiVersion': 'Versione API',
  'settings.byokImageModel': 'Modello di generazione immagini',
  'settings.byokVideoModel': 'Modello di generazione video',
  'settings.byokVideoI2vHint': 'Modello immagine-in-video: è richiesta un’immagine di riferimento (altrimenti viene usata l’ultima immagine del progetto)',
  'settings.byokSpeechModel': 'Modello vocale',
  'settings.byokSpeechVoice': 'Voce',
  'settings.byokModelDefaultOption': 'Predefinito',
  'settings.maxTokens': 'Token massimi (opzionale)',
  'settings.maxTokensHint': 'Lunghezza massima della risposta. Lascia vuoto per usare il valore predefinito del modello.',
  'settings.apiHint': 'Memorizzata localmente su questo dispositivo.',
  'settings.skipForNow': 'Salta per ora',
  'settings.getStarted': 'Inizia',
  'settings.envConfigure': 'Modelli e provider',
  'settings.localCli': 'CLI locale',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'API Anthropic',
  'settings.noAgentSelected': 'nessun agente selezionato',
  'settings.language': 'Lingua',
  'settings.languageHint': 'Cambia la lingua dell\'interfaccia. Salvato in questo browser.',
  'settings.agentModelHead': 'Modello per:',
  'settings.modelPicker': 'Modello',
  'settings.modelSourceLive': 'Live dalla CLI',
  'settings.modelUsesCliDefault': 'Predefinito CLI',
  'settings.modelSourceFallback': 'Elenco integrato',
  'settings.reasoningPicker': 'Sforzo di ragionamento',
  'settings.serviceTierPicker': 'Livello di servizio',
  'settings.modelPickerHint': 'Recuperato dalla CLI quando espone un comando `models`. "Predefinito" lascia la scelta alla configurazione della CLI; "Personalizzato…" ti permette di inserire qualsiasi identificatore di modello accettato dalla CLI.',
  'settings.modelPickerLiveHint': 'I modelli sono stati aggiornati dalla CLI installata. Predefinito usa ancora la configurazione della CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'I modelli sono stati aggiornati dalla CLI installata.',
  'settings.modelPickerFallbackHint': 'Mostra i valori predefiniti integrati. Clicca su Rianalizza per recuperare i modelli live dalla CLI.',
  'settings.cliEnvTitle': 'Avanzate: proxy e percorsi personalizzati',
  'settings.cliEnvHint': 'Usa questi campi per sovrascrivere l’ambiente della CLI selezionata: API key, base URL proxy, home personalizzate o percorsi di binari non standard. Senza base URL, la CLI usa il proprio endpoint predefinito. I segreti restano nella configurazione locale dell’app e li vede solo la CLI selezionata.',
  'settings.cliEnvClaudeConfigDir': 'Directory di configurazione Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL del proxy Claude',
  'settings.cliEnvClaudeApiKey': 'API key Claude CLI',
  'settings.cliEnvCodexHome': 'Home di Codex',
  'settings.cliEnvCodexBin': 'Percorso eseguibile Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL del proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key Codex/OpenAI CLI',
  'settings.modelCustom': 'Personalizzato (inserisci sotto)…',
  'settings.modelCustomLabel': 'Identificatore del modello personalizzato',
  'settings.modelCustomPlaceholder': 'es. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Provider di media',
  'settings.mediaProvidersHint': 'Chiavi API per la generazione di immagini, video e audio. Memorizzate localmente e sincronizzate con il daemon locale.',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'Esponi OpenDesign come server MCP per il tuo agente di codice.',
  'settings.externalMcpTitle': 'MCP esterno',
  'settings.externalMcpHint': 'Aggiungi strumenti MCP da servizi esterni (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Chiave API',
  'settings.mediaProviderBaseUrl': 'URL di base',
  'settings.mediaProviderConfigured': 'Configurato',
  'settings.mediaProviderUnset': 'Non impostato',
  'settings.mediaProviderClear': 'Cancella',
  'settings.mediaProviderClearConfirm': 'Cancellare le impostazioni salvate per {name}? Dovrai inserirle di nuovo per usare {name}.',
  'settings.mediaProviderPlaceholder': 'Incolla la chiave API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Sostituisci l\'URL di base predefinito',
  'settings.mediaProviderReload': 'Ricarica dal daemon',
  'settings.mediaProviderReloadError': 'Impossibile ricaricare le impostazioni dei provider di media dal daemon locale.',
  'settings.mediaProviderReloadSuccess': 'Impostazioni dei provider di media ricaricate dal daemon locale.',
  'settings.mediaProviderLoadError': 'Impossibile caricare le impostazioni dei provider di media dal daemon locale. Uso temporaneo delle impostazioni salvate nel browser.',
  'settings.mediaProviderComingSoonHint': 'Teniamo traccia di questi per la roadmap; il daemon non fornisce ancora un client, quindi non c\'è nulla da configurare.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'Quali dati vengono condivisi con il team di OpenDesign',
  'settings.privacyConsentKicker': 'Aiutaci a migliorare OpenDesign',
  'settings.privacyConsentLead': 'Condividere i dati di utilizzo ci aiuta a capire come si comporta OpenDesign nei flussi di lavoro reali, così possiamo migliorare le parti che contano di più per la tua esperienza.',
  'settings.privacyConsentFooter': 'Puoi modificare queste opzioni in qualsiasi momento in Impostazioni → Privacy.',
  'settings.privacyConsentShare': 'Condividi',
  'settings.privacyConsentDecline': 'Non condividere',
  'settings.privacyConsentAccept': 'Ho capito',
  'settings.privacyConsentBannerFooter': 'La condivisione dei dati è attiva per impostazione predefinita. Puoi disattivarla in qualsiasi momento in Impostazioni → Privacy.',
  'settings.privacyConsentPolicyLink': 'Leggi l\'informativa sulla privacy',
  'settings.privacyMetrics': 'Metriche anonime',
  'settings.privacyMetricsHint': 'Conteggi di esecuzione, utilizzo di token, tasso di errore e durata come metriche di utilizzo di base.',
  'settings.privacyContent': 'Contenuto della conversazione',
  'settings.privacyContentHint': 'Dopo aver rimosso segreti e altre informazioni sensibili, usiamo prompt, risposte dell’assistente, input/output degli strumenti e il contesto necessario per la revisione della qualità.',
  'settings.privacyInstallationId': 'ID anonimo',
  'settings.privacyOptedOut': 'escluso',
  'settings.privacyDataDeletion': 'Elimina i miei dati',
  'settings.privacyDataDeletionHint': 'Ruota il tuo ID anonimo e interrompe l\'invio. Le tracce esistenti scadono secondo la nostra politica di conservazione.',
  'settings.about': 'Informazioni',
  'settings.aboutHint': 'Versione e informazioni di esecuzione',
  'settings.appVersion': 'Versione',
  'settings.appChannel': 'Canale',
  'settings.appRuntime': 'Ambiente',
  'settings.appPlatform': 'Piattaforma',
  'settings.appArchitecture': 'Architettura',
  'settings.runtimePackaged': 'Applicazione impacchettata',
  'settings.runtimeDevelopment': 'Sviluppo',
  'settings.versionUnavailable': 'Le informazioni sulla versione non sono disponibili quando il daemon è offline.',
  "settings.allowSilentUpdates": "Consenti l’installazione automatica dei futuri aggiornamenti in-app",
  "settings.allowSilentUpdatesDesc": "Quando un aggiornamento in-app è pronto, installalo automaticamente al prossimo avvio. Non aggiorna la sessione corrente. Gli aggiornamenti con installer chiedono ancora conferma.",
  'settings.installLatest': 'Installa l\'ultima versione',
  'settings.alreadyLatest': 'Stai usando l\'ultima versione',
  'settings.updateCheck': 'Controlla aggiornamenti',
  'settings.updateNow': 'Aggiorna ora',
  'settings.updateRecheck': 'Controlla di nuovo',
  'settings.updateRetry': 'Riprova',
  'settings.updateViewReleases': 'Note di rilascio',
  'settings.updateActionFailed': 'Impossibile completare l\'azione di aggiornamento.',
  'settings.updateQuitFailed': 'Il programma di installazione è stato aperto, ma OpenDesign non è riuscito a chiudersi automaticamente.',
  'settings.updateStatusNotChecked': 'Non ancora controllato',
  'settings.updateStatusDevelopment': 'Le build di sviluppo non supportano gli aggiornamenti in-app.',
  'settings.updateStatusUnsupported': 'Questo ambiente non supporta gli aggiornamenti in-app.',
  'settings.updateStatusChecking': 'Controllo aggiornamenti...',
  'settings.updateStatusUpToDate': 'Hai già l\'ultima versione.',
  'settings.updateStatusAvailable': 'Trovata la versione {version}. Preparazione download.',
  'settings.updateStatusAvailableUnknown': 'Trovata una nuova versione. Preparazione download.',
  'settings.updateStatusDownloading': 'Download aggiornamento...',
  'settings.updateStatusDownloadingPercent': 'Download aggiornamento {percent}%.',
  'settings.updateStatusReady': 'La versione {version} è pronta per l\'installazione.',
  'settings.updateStatusReadyUnknown': 'Aggiornamento pronto per l\'installazione.',
  'settings.updateStatusInstalling': 'Installazione aggiornamento...',
  'settings.updateStatusFailed': 'Controllo non riuscito. Riprova.',
  'settings.mcpTitle': 'Server MCP',
  'settings.mcpHint': 'Consenti agli agent di coding (Cursor, Claude Code, VS Code…) di leggere direttamente i tuoi progetti OpenDesign.',
  'settings.mcpDaemonError': 'Impossibile raggiungere il daemon locale per risolvere i percorsi di installazione ({error}). Assicurati che OpenDesign sia in esecuzione, quindi riapri questo pannello.',
  'settings.mcpBuildDaemon': 'Compila prima il daemon.',
  'settings.mcpNodeMissing': 'Il binario Node è mancante.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js è mancante. Esegui `pnpm --filter @open-design/daemon build` e aggiorna.',
  'settings.mcpMethodCli': 'Comando CLI',
  'settings.mcpInstructionCli': 'Esegui questo nel tuo terminale.',
  'settings.mcpMethodToml': 'Configurazione TOML',
  'settings.mcpInstructionCodex': 'Aggiungi questa tabella a {path}. La stessa configurazione è condivisa tra la CLI Codex e l\'estensione IDE Codex.',
  'settings.mcpMethodOneClick': 'Installazione con un clic',
  'settings.mcpInstructionCursor': 'Fai clic su "Install in Cursor" per installare con una finestra di approvazione, oppure unisci questo JSON in {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Installa in Cursor',
  'settings.mcpMethodJson': 'Configurazione JSON',
  'settings.mcpInstructionKiro': 'Apri {path} e unisci questo JSON. Per la configurazione a livello di workspace, usa .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Apri la Command Palette ({shortcut}), esegui "MCP: Open User Configuration" e unisci questo JSON. Copilot Chat deve essere in modalità Agent affinché gli strumenti vengano visualizzati.',
  'settings.mcpInstructionAntigravity': 'In Antigravity: pannello Agent, menu "..." → MCP Servers → Manage MCP Servers → View raw config. Unisci questo JSON.',
  'settings.mcpInstructionZed': 'Apri le impostazioni di Zed ({shortcut}) e unisci questo nell\'oggetto di livello superiore. Zed usa "context_servers", non "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Apri {path} (oppure usa l\'icona MCP in Cascade → Configure) e unisci:',
  'settings.mcpCopyAria': 'Copia lo snippet di configurazione MCP',
  'settings.mcpResolvingFailed': '# risoluzione dei percorsi non riuscita, vedi l\'errore sopra',
  'settings.mcpLoadingPaths': '# caricamento dei percorsi di installazione dal daemon locale…',
  'settings.mcpCopied': 'Copiato',
  'settings.mcpCopy': 'Copia',
  'settings.mcpCursorApproval': 'Cursor mostra una finestra di approvazione prima di scrivere la configurazione.',
  'settings.mcpCodexOneClickInstall': 'Installa in Codex',
  'settings.mcpCodexOneClickUninstall': 'Rimuovi da Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI non trovato nel PATH — installa Codex o incolla lo snippet manualmente.',
  'settings.mcpCodexInstallSuccess': 'Installato. Riavvia Codex per caricare il nuovo server.',
  'settings.mcpCodexUninstallSuccess': 'Rimosso da Codex.',
  'settings.mcpCodexBusy': 'In corso…',
  'settings.mcpCodexInstallError': 'Operazione non riuscita: {error}',
  'settings.mcpRestartNote': 'Riavvia il tuo client per rilevare il nuovo server.',
  'settings.mcpRestartDetail': 'La maggior parte degli editor carica i server MCP solo all\'avvio. In Cursor / VS Code / Antigravity / Windsurf puoi eseguire `Developer: Reload Window` dalla command palette invece di un riavvio completo. Zed e Claude Code richiedono di chiudere e riaprire.',
  'settings.mcpCapabilitiesTitle': 'Cosa può fare il tuo agent',
  'settings.mcpCapabilityRead': 'Leggere o cercare qualsiasi file in un progetto (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Recuperare un bundle di design in una sola chiamata: il file di ingresso più ogni variabile CSS, componente e font a cui fa riferimento.',
  'settings.mcpCapabilityDefault': 'Utilizzare per impostazione predefinita il progetto e il file che hai aperto in OpenDesign, così puoi dire "build this in my app" senza dover ripetere quale design.',
  'settings.mcpRunningNote': 'OpenDesign deve essere in esecuzione affinché le chiamate agli strumenti MCP abbiano successo. Se hai avviato il tuo coding agent prima di aprire OpenDesign, riavvia l\'agent in modo che possa raggiungere il daemon attivo.',
  'entry.tabDesigns': 'Design',
  'entry.tabTemplates': 'Modelli',
  'entry.tabDesignSystems': 'Design system',
  'entry.tabConnectors': 'Connettori',
  'entry.openSettingsTitle': 'Impostazioni',
  'entry.openSettingsAria': 'Apri impostazioni',
  'entry.discordLabel': 'Unisciti a Discord',
  'entry.discordAria': 'Unisciti al Discord e ricevi crediti',
  'entry.discordAriaWithOnline': 'Unisciti al Discord di OpenDesign - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.xAria': 'Segui @OpenDesignHQ per gli aggiornamenti',
  'entry.mailAria': 'Domande? Scrivici un\'email',
  'entry.accountSettings': 'Impostazioni',
  'chat.collapsePane': 'Comprimi il pannello della conversazione',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Segui @OpenDesignHQ su X',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'Segui @opendesign.ai su Instagram',
  'entry.followLinkedinLabel': 'Segui OpenDesign su LinkedIn',
  'entry.followXiaohongshuLabel': 'Segui OpenDesign su Xiaohongshu',
  'entry.resizeAria': 'Ridimensiona la barra laterale',
  'entry.loadingWorkspace': 'Caricamento dello spazio di lavoro…',
  'entry.useEverywhereTitle': 'Usa ovunque',
  'entry.useEverywhereAria': 'Apri la guida Usa ovunque (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Tutti i progetti",
  "workspaceSwitcher.allProjectsTooltip": "Progetti del team",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingTierPlus": "Plus",
  "entry.billingTierMax": "Max",
  "entry.billingFamilyCreator": "Creator",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Esegui upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Quota",
  "entry.creditsUsage": "Vedi utilizzo",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Cambia tema",
  "entry.accountSwitchLanguage": "Cambia lingua",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Ottieni aiuto",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountBilling": "Fatturazione",
  "entry.accountAddAccount": "Aggiungi account",
  "entry.accountSignOut": "Esci",
  "signOut.confirmTitle": "Esci",
  "signOut.confirmMessage": "Vuoi davvero uscire?",
  "signOut.confirmAction": "Esci",
  "entry.navRecents": "Home",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace per i team — dicci di cosa ha bisogno il tuo team',
  'entry.workspaceTeamsAria': 'Apri la pagina Workspace per i team',
  'entry.navExpand': 'Espandi la barra laterale',
  'entry.navCollapse': 'Comprimi la barra laterale',
  'entry.navNewProject': 'Nuovo progetto',
  'entry.navHome': 'Home',
  'entry.navProjects': 'Progetti',
  'entry.navTasks': 'Automazioni',
  'entry.navPlugins': 'Plugin',
  'entry.navDesignSystems': 'Design system',
  'entry.navBrands': 'Kit del brand',
  'entry.navIntegrations': 'Integrazioni',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Tutti i progetti',
  'entry.navAllProjects': 'Progetti del team',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Your sign-in has expired. Sign in to continue using OpenDesign Cloud.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Local service connection interrupted. Recovering automatically…',
  'home.createTimedOut': 'La preparazione del progetto è scaduta prima di iniziare. Prova a inviare di nuovo.',
  'home.amrGateUnavailable': 'Impossibile confermare il saldo OpenDesign Cloud. Riprova a inviare.',
  'home.bundledScenarioMissing': 'Bundled scenario "{scenarioId}" is not installed. Reinstall the daemon to restore the default plugin set.',
  "entry.cloudCalloutBody": "Accedi per usare OpenDesign Cloud e collaborare nel cloud",
  "entry.localAccountName": "Modalità locale",
  "entry.cloudCalloutDismissAria": "Chiudi l'avviso di OpenDesign Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.archive': 'Archivia',
  'messageCenter.unarchive': 'Riporta nella posta in arrivo',
  'messageCenter.archivedTitle': 'Archiviati',
  'messageCenter.emptyArchivedTitle': 'Nessun messaggio archiviato',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'goPlanSunset.closeAria': 'Close announcement',
  'goPlanSunset.title': 'Notice: Go subscriptions are ending',
  'goPlanSunset.subtitle': 'We’ve heard your feedback and recognize that Go’s allowance rules and product experience need improvement. We’re sorry.',
  'goPlanSunset.decisionsAria': 'What’s changing',
  'goPlanSunset.decisionsIntro': 'What’s changing',
  'goPlanSunset.decisionStopSales': 'New Go subscriptions end today',
  'goPlanSunset.decisionRefund': 'Existing subscribers will receive full refunds by August 31; Go access ends after refund',
  'goPlanSunset.decisionUnaffected': 'Other plans are unaffected',
  'goPlanSunset.closing': 'Refunds return to the original payment method; timing depends on the provider. Thank you for your feedback and support.',
  'goPlanSunset.dismissError': 'Could not confirm. Please try again.',
  'goPlanSunset.viewSubscriptions': 'View other plans',
  'goPlanSunset.confirming': 'Confirming…',
  'goPlanSunset.acknowledge': 'Got it',
  'workspaceTabs.project': 'Progetto',
  'workspaceTabs.pluginDetails': 'Dettagli del plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Creiamo {word}',
  'homeHero.titleWords': 'prototipi,presentazioni,documenti',
  'homeHero.subtitle': 'Il bel lavoro inizia qui',
  'homeHero.startWithTemplate': 'Inizia con un modello…',
  'homeHero.startBlankProject': 'inizia un progetto vuoto',
  'homeHero.templatePicker.label': 'Tipo di creazione',
  'homeHero.templatePicker.searchPlaceholder': 'Cerca modelli',
  'homeHero.templatePicker.projectTypes': 'Tipi di progetto',
  'homeHero.subtitlePrefix': 'L\'alternativa a codice sorgente disponibile a Claude Design.',
  'homeHero.placeholder': 'Descrivi cosa vuoi generare…',
  'homeHero.placeholderActive': 'Modifica la query di esempio o scrivine una tua…',
  'homeHero.carousel.hint': 'Allega un file, collega il tuo design system o descrivi cosa vuoi creare',
  'homeHero.carousel.onePageBrief': 'Scrivere un brief di progetto di una pagina',
  'homeHero.carousel.notesToDeck': 'Trasformare i miei appunti in una presentazione',
  'homeHero.carousel.signupFlow': 'Creare il mockup di un flusso di registrazione',
  'homeHero.carousel.improveBrief': 'Migliorare un brief di progetto esistente',
  'homeHero.carousel.loadingAnimation': 'Creare un’animazione di caricamento',
  'homeHero.carousel.teamUpdateSlides': 'Progettare slide per un aggiornamento del team',
  'homeHero.carousel.ordersDashboard': 'Prototipare una dashboard per monitorare gli ordini',
  'homeHero.carousel.productDetail': 'Impaginare una pagina di dettaglio prodotto',
  'homeHero.carousel.caseStudy': 'Delineare un caso di studio',
  'homeHero.carousel.landingIntro': 'Progettare una breve intro per una landing page',
  'homeHero.carousel.pitchDeck': 'Creare un pitch deck per un nuovo prodotto',
  'homeHero.carousel.appIdea': 'Descrivere un’idea di app',
  'homeHero.carousel.landingLayout': 'Abbozzare il layout di una landing page',
  'homeHero.skills': 'Competenze',
  'homeHero.addMenu': 'Aggiungi contesto',
  'homeHero.addPlugin': 'Aggiungi plugin',
  'homeHero.addConnectors': 'Aggiungi connettori',
  'homeHero.addMcp': 'Aggiungi server MCP',
  'homeHero.noPlugins': 'Nessun plugin installato',
  'homeHero.noMcp': 'Nessun server MCP',
  'homeHero.noConnectors': 'Nessun connettore collegato',
  'homeHero.applying': 'Applicazione in corso…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Competenza: {title}',
  'homeHero.removePlugin': 'Rimuovi plugin',
  'homeHero.removePluginAria': 'Rimuovi plugin {title}',
  'homeHero.clearActivePlugin': 'Disattiva plugin attivo',
  'homeHero.clearActiveSkill': 'Disattiva competenza attiva',
  'homeHero.contextItemsResolved': '{n} elementi di contesto risolti',
  'homeHero.attachmentsScrollPrev': 'Scorri gli allegati a sinistra',
  'homeHero.attachmentsScrollNext': 'Scorri gli allegati a destra',
  'homeHero.removeFile': 'Rimuovi file',
  'homeHero.contextSearchResults': 'Risultati ricerca contesto',
  'homeHero.contextSurfaces': 'Aree di contesto',
  'homeHero.loadingContext': 'Caricamento del contesto…',
  'homeHero.noResults': 'Nessun risultato per "{query}".',
  'homeHero.searchPrompt': 'Cerca file, plugin, competenze, server MCP e connettori.',
  'homeHero.parameters': '{n} parametri',
  'homeHero.details': 'Dettagli',
  'homeHero.toRun': 'per eseguire',
  'homeHero.forNewLine': 'per andare a capo',
  'homeHero.run': 'Esegui',
  'homeHero.typeSomethingToRun': 'Scrivi qualcosa da eseguire',
  'homeHero.promptExamples': 'Esempi',
  'homeHero.footer.designSystem': 'Stile',
  'homeHero.footer.autoDesignSystem': 'Auto',
  'homeHero.footer.autoDesignSystemSummary': 'Abbina automaticamente il design system e lo stile visivo più adatti al prompt attuale.',
  'homeHero.footer.ratio': 'Rapporto',
  'homeHero.footer.duration': 'Durata',
  'homeHero.footer.resolution': 'Risoluzione',
  'homeHero.footer.speakerNotes': 'Note',
  'homeHero.footer.noSpeakerNotes': 'Senza note',
  'homeHero.footer.availableCount': '{n} disponibili',
  'homeHero.footer.noMatches': 'Nessuna corrispondenza',
  'homeHero.moreShortcuts': 'Altro',
  'homeHero.railAria': 'Scegli una categoria di progetto o una scorciatoia iniziale',
  'homeHero.subTypeAria': 'Scegli un sottotipo',
  'homeHero.subTypeMore': 'Altro',
  'homeHero.confirmReplaceTitle': 'Sostituire il prompt attuale?',
  'homeHero.confirmReplaceBody': 'L\'uso di {title} sostituirà il testo attualmente presente nell\'input.',
  'homeHero.confirmReplace': 'Sostituisci',
  'homeHero.chip.prototype': 'Prototipo',
  'homeHero.chip.webClone': 'Clone di sito web',
  'homeHero.chip.liveArtifact': 'Artefatto live',
  'homeHero.chip.deck': 'Presentazione',
  'homeHero.chip.image': 'Immagine',
  'homeHero.chip.video': 'Video',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Shader, 3D e visual GPU generativi',
  'homeHero.chip.worker': 'Visualizzatore Worker',
  'homeHero.chip.workerDesc': 'Sim fuori thread, particelle e data viz',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Crea kit del brand',
  'homeHero.chip.createPlugin': 'Crea plugin',
  'homeHero.chip.figma': 'Da Figma',
  'homeHero.chip.folder': 'Da cartella',
  'homeHero.chip.template': 'Da modello',
  'homeHero.chip.liveArtifactHint': 'Crea un artefatto HTML/CSS/JS interattivo con anteprima live.',
  'homeHero.chip.hyperframesHint': 'Crea animazioni basate su HTML: didascalie, elementi visivi reattivi all\'audio, transizioni tra scene.',
  'homeHero.chip.createBrandKitHint': 'Estrai un kit del brand da un sito web, poi applicalo in qualsiasi chat.',
  'homeHero.chip.createPluginHint': 'Crea un plugin OpenDesign riutilizzabile e aggiungilo a I miei plugin.',
  'homeHero.chip.figmaHint': 'Migra un frame di Figma nel design system attivo.',
  'homeHero.chip.folderHint': 'Importa una cartella locale esistente e continua a modificarla.',
  'homeHero.chip.templateHint': 'Inizia da un modello incluso.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'App mobile',
  'homeHero.chip.document': 'Documento',
  'homeHero.chip.prototypeDesc': 'Mockup di app interattivi',
  'homeHero.chip.webCloneDesc': 'Riproduzione di siti fedele al codice sorgente',
  'homeHero.chip.wireframeDesc': 'Schermate e flussi a bassa fedeltà',
  'homeHero.chip.mobileDesc': 'Schermate iOS e Android',
  'homeHero.chip.deckDesc': 'Presentazioni e pitch deck',
  'homeHero.chip.documentDesc': 'CV, report e PDF',
  'homeHero.chip.imageDesc': 'Poster, grafiche e arte',
  'homeHero.chip.videoDesc': 'Clip, reel e promo',
  'homeHero.chip.audioDesc': 'Voice-over, musica ed effetti sonori',
  'homeHero.chip.hyperframesDesc': 'Motion graphics e loop',
  'homeHero.chip.liveArtifactDesc': 'Dashboard live basate sui dati',
  'homeHero.chip.createBrandKitDesc': 'Estrai un design system del brand',
  'homeHero.chip.prototypeNext': 'Apre una chat che costruisce un prototipo web cliccabile ad alta fedeltà da rifinire passo dopo passo.',
  'homeHero.chip.webCloneNext': 'Apre una chat che chiede un URL di destinazione, ricostruisce il sito e verifica il clone.',
  'homeHero.chip.wireframeNext': 'Apre una chat che abbozza schermate e flussi a bassa fedeltà per validare prima la struttura.',
  'homeHero.chip.mobileNext': 'Apre una chat che progetta schermate mobile per iOS e Android.',
  'homeHero.chip.deckNext': 'Apre una chat che crea una presentazione da mostrare ed esportare.',
  'homeHero.chip.documentNext': 'Apre una chat che redige un documento curato — CV, report o PDF.',
  'homeHero.chip.imageNext': 'Apre una chat che genera immagini coerenti con il brand su cui puoi iterare.',
  'homeHero.chip.videoNext': 'Apre una chat che produce un breve video da rifinire.',
  'homeHero.chip.audioNext': 'Apre una chat che crea voice-over, musica o effetti sonori.',
  'homeHero.chip.webClonePromptSeed': 'URL del sito da clonare: ',
  'homeWorkingDir.trigger': 'Scegli la directory di lavoro',
  'homeWorkingDir.triggerShort': 'Directory di lavoro',
  'homeWorkingDir.pick': 'Scegli cartella',
  'homeWorkingDir.replace': 'Cambia directory di lavoro',
  'homeWorkingDir.recent': 'Cartelle recenti',
  'homeWorkingDir.clear': 'Rimuovi directory di lavoro',
  'homeWorkingDir.hint': 'Consenti all\'agente di leggere questa cartella locale (non viene importata in Design Files)',
  'homeWorkingDir.missing': 'Questa cartella di lavoro non esiste più — scegline un\'altra',
  'homeWorkingDir.applyFailed': 'Impossibile impostare la directory di lavoro — la cartella potrebbe non esistere più',
  'workingDirPicker.title': 'Cartella',
  'workingDirPicker.homeTitle': 'Salvato nella memoria locale — clicca per scegliere una cartella',
  'workingDirPicker.processing': 'Elaborazione in corso…',
  'workingDirPicker.select': 'Memoria locale',
  'workingDirPicker.clearAria': 'Cancella directory di lavoro',
  'workingDirPicker.replaceFailed': 'Impossibile sostituire la directory di lavoro',
  'workingDirPicker.unavailable': 'Il selettore di cartelle non è disponibile in questa build. Esegui l\'app desktop per scegliere una cartella.',
  'workingDirPicker.openUnavailable': 'Apri questo progetto nell\'app desktop per mostrare la cartella.',
  'workingDirPicker.openFailed': 'Impossibile mostrare questa cartella',
  'workingDirPicker.showInFileManager': 'Mostra nel file manager',
  'workingDirPicker.replace': 'Scegli cartella…',
  'workingDirPicker.recent': 'Directory recenti',
  'workingDirPicker.defaultLabel': 'Archiviazione locale',
  'handoff.toTarget': 'Passa a {target}',
  'handoff.openInTarget': 'Apri in {target}',
  'handoff.openAction': 'Apri',
  'handoff.menuTitle': 'In quale editor aprire?',
  'handoff.action': 'Passa il controllo',
  'handoff.fallbackTitle': 'Nessun editor trovato in $PATH - apre in {target}',
  'handoff.chooseTargetAria': 'Scegli la destinazione del passaggio',
  'handoff.optionsAria': 'Opzioni di passaggio',
  'handoff.editorSection': 'Apri con editor',
  'handoff.cliSection': 'Copia per CLI',
  'handoff.clickOpen': 'Clicca per aprire',
  'handoff.framework': 'Framework di codice',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML e CSS',
  'handoff.amrWebsite': 'Apri il sito OpenDesign Cloud',
  'handoff.copyPrompt': 'Copia prompt',
  'handoff.copyPromptForTarget': 'Copia prompt per {target}',
  'handoff.copied': 'Copiato',
  'handoff.projectPathUnavailable': 'Il percorso del progetto è ancora in caricamento. Riprova tra un momento.',
  'handoff.copyFailed': 'La scrittura negli appunti è stata bloccata. Riprova tra un momento.',
  'handoff.promptIntro': 'Continua da questa cartella di progetto locale di OpenDesign:',
  'handoff.promptTarget': 'Destinazione',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Stai subentrando in {cli}. Per favore:',
  'handoff.promptReadFiles': 'Entra o leggi prima questa directory. Dai priorità a DESIGN.md, README, HTML/CSS/JS esistenti, asset e package.json se presente.',
  'handoff.promptKeepDesign': 'Conserva il design visivo, il layout, le interazioni e gli asset attuali. Non fermarti a un piano.',
  'handoff.promptProduceCode': 'Genera o modifica codice {framework} reale ed eseguibile. Se il progetto ha già uno stack più chiaro, segnala il conflitto e mantieni il risultato eseguibile.',
  'handoff.promptVerify': 'Concludi indicandomi i comandi di esecuzione, anteprima e verifica.',
  'handoff.promptCommandHint': 'Per iniziare dalla directory del progetto, usa:',
  'handoff.promptProject': 'Progetto',
  'handoff.promptProjectId': 'ID progetto',
  'handoff.notInstalled': 'Non installato',
  'handoff.notDetectedTitle': '{target} - non rilevato in $PATH',
  'designSystemPicker.select': 'Scegli design system',
  'designSystemPicker.loading': 'Caricamento dei design system…',
  'designSystemPicker.searchPlaceholder': 'Cerca design system (titolo / categoria / riepilogo)',
  'designSystemPicker.searchCompactPlaceholder': 'Cerca design system',
  'designSystemPicker.noneTitle': 'Nessun design system',
  'designSystemPicker.noneSummary': 'Lascia scegliere liberamente al modello',
  'designSystemPicker.empty': 'Nessun design system corrispondente',
  'designSystemPicker.openPreview': 'Apri anteprima',
  'designSystemPicker.loadingPreview': 'Caricamento dell\'anteprima…',
  'designSystemPicker.noPreview': 'Nessuna pagina di anteprima. Apri i Design System per vedere l\'anteprima completa.',
  'designSystemPicker.previewHint': 'Passa il mouse su un design system per visualizzarne l\'anteprima',
  'designSystemPicker.fullscreenAria': 'Anteprima a schermo intero di {title}',
  'designSystemPicker.closeFullscreen': 'Chiudi anteprima a schermo intero',
  'designSystemPicker.closeEsc': 'Chiudi (Esc)',
  'designSystemPicker.previewFrameTitle': 'Anteprima di {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Anteprima a schermo intero di {title}',
  'recentProjects.title': 'Progetti recenti',
  'recentProjects.viewAll': 'Mostra tutti',
  'recentProjects.empty': 'Ancora nessun progetto — scrivi un prompt per iniziarne uno.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindDocument': 'Document',
  'recentProjects.kindImage': 'Immagine',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.collectionRecent': 'Recently viewed',
  'recentProjects.collectionPersonalProjects': 'Progetti personali',
  'recentProjects.collectionTeamProjects': 'Progetti del team',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.duplicateInProgress': 'Duplicazione…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Cancella filtri',
  'pluginsHome.title': 'Community',
  'pluginsHome.subtitle': 'Workflow di OpenDesign pronti all\'uso inclusi in questo runtime. Scegline uno per caricare un prompt iniziale oppure esplora il registry per altro.',
  'pluginsHome.browseRegistry': 'Esplora registry',
  'pluginsHome.count': '{filtered} di {total}',
  'pluginsHome.loadingCatalog': 'Caricamento del catalogo…',
  'pluginsHome.emptyCatalog': 'Il catalogo è vuoto. I plugin inclusi sono forniti con OpenDesign e dovrebbero comparire qui automaticamente — prova a riavviare il daemon se il problema persiste.',
  'pluginsHome.emptyFiltered': 'Nessun plugin corrisponde ai filtri attuali.',
  'pluginsHome.clearFilters': 'Cancella filtri',
  'pluginsHome.modeAria': 'Modalità plugin',
  'pluginsHome.featured': 'Salvato',
  'pluginsHome.totalInCatalog': '{n} nel catalogo',
  'pluginsHome.categoryFilterAria': 'Filtro categoria',
  'pluginsHome.subcategoryFilterAria': 'Filtro sottocategoria {label}',
  'pluginsHome.allCategory': 'Tutti {label}',
  'pluginsHome.searchPlaceholder': 'Cerca plugin…',
  'pluginsHome.searchAria': 'Cerca plugin',
  'pluginsHome.clearSearch': 'Cancella ricerca',
  'pluginsHome.sortAria': 'Ordinamento',
  'pluginsHome.sortHot': 'Di tendenza',
  'pluginsHome.sortNewest': 'Più recenti',
  'pluginsHome.facet.import': 'Importa',
  'pluginsHome.facet.create': 'Crea',
  'pluginsHome.facet.export': 'Esporta',
  'pluginsHome.facet.share': 'Condividi',
  'pluginsHome.facet.deploy': 'Distribuisci',
  'pluginsHome.facet.refine': 'Perfeziona',
  'pluginsHome.facet.extend': 'Estendi',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Codice / cartella',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Screenshot',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slide',
  'pluginsHome.facet.publicLink': 'Link pubblico',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboard',
  'pluginsHome.subfacet.app-prototypes': 'App',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Strumenti dev',
  'pluginsHome.subfacet.docs-reports': 'Doc / report',
  'pluginsHome.subfacet.brand-design': 'Brand / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / business',
  'pluginsHome.subfacet.course-training': 'Corsi / formazione',
  'pluginsHome.subfacet.reports-briefings': 'Report / briefing',
  'pluginsHome.subfacet.product-sales': 'Prodotto / vendite',
  'pluginsHome.subfacet.engineering-talks': 'Talk tecnici',
  'pluginsHome.subfacet.creative-decks': 'Deck creativi',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockup',
  'pluginsHome.subfacet.brand-visuals': 'Brand / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboard',
  'pluginsHome.subfacet.social-content': 'Social / contenuti',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / ritratto',
  'pluginsHome.subfacet.illustration-style': 'Illustrazione / stile',
  'pluginsHome.subfacet.motion-effects': 'Motion / effetti',
  'pluginsHome.subfacet.social-short-form': 'Social / short form',
  'pluginsHome.subfacet.marketing-product': 'Marketing / prodotto',
  'pluginsHome.subfacet.data-explainers': 'Dati / spiegazioni',
  'pluginsHome.subfacet.cinematic-story': 'Cinematico / storia',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Esplora i workflow installati, scopri le voci del registry, gestisci le sorgenti e prepara i plugin per la distribuzione al team.',
  'pluginsView.importPlugin': 'Importa plugin',
  'pluginsView.agentContext': 'Contesto Agent',
  'pluginsView.summaryAria': 'Riepilogo plugin',
  'pluginsView.areasAria': 'Aree dei plugin',
  'pluginsView.loading': 'Caricamento dei plugin…',
  'pluginsView.tab.installed': 'Installati',
  'pluginsView.tab.available': 'Disponibili',
  'pluginsView.tab.sources': 'Sorgenti',
  'pluginsView.tab.team': 'Team',
  'pluginsView.tabHint.installed': 'I tuoi plugin',
  'pluginsView.tabHint.available': 'Dalle sorgenti',
  'pluginsView.tabHint.sources': 'Cataloghi',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Plugin installati',
  'pluginsView.installedSubtitle': 'Plugin importati o installati da sorgenti del marketplace.',
  'pluginsView.installedEmpty': 'Ancora nessun plugin utente installato. Usa Crea / Importa oppure installa una voce Disponibile.',
  'pluginsView.availableTitle': 'Disponibili dalle sorgenti',
  'pluginsView.availableSubtitle': 'Voci del catalogo rilevate dai marketplace configurati.',
  'pluginsView.availableFiltersAria': 'Filtri plugin disponibili',
  'pluginsView.searchAvailableAria': 'Cerca plugin disponibili',
  'pluginsView.searchAvailablePlaceholder': 'Cerca plugin disponibili',
  'pluginsView.clearAvailableSearch': 'Cancella ricerca plugin disponibili',
  'pluginsView.source': 'Sorgente',
  'pluginsView.availableEmptyInstalled': 'Ancora nessuna voce disponibile. Le voci del catalogo installate vengono rimosse da Disponibili; disinstallane una per renderla nuovamente disponibile.',
  'pluginsView.availableEmptyFiltered': 'Nessuna voce disponibile corrisponde ai filtri.',
  'pluginsView.availableEmptyNoSources': 'Nessuna voce disponibile al momento. Aggiungi una sorgente nella scheda Sorgenti.',
  'pluginsView.installing': 'Installazione in corso…',
  'pluginsView.installWaiting': 'In attesa…',
  'pluginsView.installQueuedHint': 'È in corso l’installazione di un altro plugin. Le installazioni vengono eseguite una alla volta: questo pulsante sarà disponibile al termine.',
  'pluginsView.install': 'Installa',
  'pluginsView.sourcesTitle': 'Sorgenti del registro',
  'pluginsView.sourcesSubtitle': 'Cataloghi del marketplace che alimentano le voci dei plugin disponibili.',
  'pluginsView.sourceUrl': 'URL sorgente',
  'pluginsView.defaultTrust': 'Attendibilità predefinita',
  'pluginsView.trust.restricted': 'Limitato',
  'pluginsView.trust.trusted': 'Attendibile',
  'pluginsView.trust.official': 'Ufficiale',
  'pluginsView.adding': 'Aggiunta in corso…',
  'pluginsView.addSource': 'Aggiungi sorgente',
  'pluginsView.sourcesEmpty': 'Nessuna sorgente del registro ancora configurata.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'catalogo v{version}',
  'pluginsView.trustFor': 'Attendibilità per {name}',
  'pluginsView.refreshing': 'Aggiornamento in corso…',
  'pluginsView.removing': 'Rimozione in corso…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "WEBART official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.kind.slides": "Presentazioni",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.searchSlides": "Cerca modelli di presentazione...",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalSlidesTitle": "Nessun modello di presentazione personale",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialSlidesTitle": "Nessun modello di presentazione nel registro ufficiale",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Sincronizza con il team",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "L'ultima versione di \"{title}\" è stata sincronizzata con il team.",
  "pluginsView.syncUnavailable": "Impossibile sincronizzare \"{title}\" per ora. Verifica di trovarti in uno spazio di lavoro del team.",
  "pluginsView.syncFailed": "Sincronizzazione di \"{title}\" con il team non riuscita. Riprova più tardi.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplace privati del team',
  'pluginsView.teamBody': 'Quest\'area è riservata ai cataloghi aziendali e dei team, alle politiche di attendibilità private e ai controlli condivisi del ciclo di vita dei plugin.',
  'pluginCard.details': 'Dettagli',
  'pluginCard.use': 'Usa',
  'pluginCard.useWithQuery': 'Usa con query',
  'pluginCard.applying': 'Applicazione in corso…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remix in corso…',
  'pluginCard.duplicateFailed': 'Impossibile remixare questo modello.',
  'pluginCard.saved': 'Salvato',
  'pluginCard.publish': 'Pubblica',
  'pluginCard.contribute': 'Contribuisci',
  'pluginCard.starting': 'Avvio in corso…',
  'pluginCard.detailsAria': 'Visualizza i dettagli di {title}',
  'pluginCard.chooseUseAria': 'Scegli come usare {title}',
  'pluginCard.useOptionsAria': 'Opzioni d\'uso per {title}',
  'pluginCard.duplicateAria': 'Remixa {title} come nuovo progetto',
  'pluginCard.saveAria': 'Salva {title}',
  'pluginCard.savedAria': '{title} è salvato',
  'pluginCard.shareAria': 'Condividi {title}',
  'pluginCard.publishAria': 'Pubblica {title} come repository GitHub',
  'pluginCard.publishTitle': 'Pubblica il plugin come repository GitHub',
  'pluginCard.contributeAria': 'Contribuisci con {title} a OpenDesign',
  'pluginCard.contributeTitle': 'Contribuisci con il plugin a OpenDesign tramite una pull request',
  'integrations.kicker': 'Integrazione',
  'integrations.lede': 'Collega sistemi esterni, porta gli strumenti MCP nel loop del tuo agent e usa OpenDesign da altri IDE, script e automazioni.',
  'integrations.agentReady': 'Pronto per l\'agent',
  'integrations.areasAria': 'Aree di integrazione',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skill',
  'integrations.tabHint.mcp': 'Strumenti esterni',
  'integrations.tabHint.connectors': 'Account e API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Integrazioni Skill',
  'integrations.skillsBody': 'La gestione delle integrazioni a livello di Skill viene trasferita da un altro branch. Questa scheda è riservata affinché la configurazione di MCP, Connettori e future Skill risieda nello stesso percorso di Integrazione.',
  'mcpClient.title': 'Server MCP esterni',
  'mcpClient.subtitle': 'Strumenti di terze parti per il tuo agent di coding.',
  'mcpClient.addServer': 'Aggiungi server',
  'mcpClient.emptyTitle': 'Nessun server MCP configurato.',
  'mcpClient.emptyBody': 'Fai clic su "Aggiungi server" per iniziare — scegli un modello (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) oppure configura un server stdio / HTTP personalizzato.',
  'mcpClient.saveChanges': 'Salva modifiche',
  'mcpClient.storedAt': 'Memorizzato in',
  'mcpClient.daemonError': 'Impossibile raggiungere il daemon locale. Assicurati che OpenDesign sia in esecuzione, quindi riapri questo pannello.',
  'mcpClient.saveFailed': 'Salvataggio non riuscito. Verifica che il daemon sia in esecuzione e riprova.',
  'useEverywhere.modalAria': 'Usa OpenDesign ovunque',
  'useEverywhere.modalTitle': 'Usa OpenDesign ovunque',
  'useEverywhere.modalSubtitle': 'Integra OpenDesign in qualsiasi IDE, agent o script — CLI, HTTP, MCP e Skill. Usa “Copia la guida per un agent” e incollala in Claude Code, Codex, Cursor, openclaw o hermes per configurare tutto.',
  'useEverywhere.closeAria': 'Chiudi usa ovunque',
  'useEverywhere.closeTitle': 'Chiudi (Esc)',
  'useEverywhere.tabsAria': 'Superfici di integrazione',
  'useEverywhere.footStrong': 'Passaggio di consegne con un clic.',
  'useEverywhere.footBody': 'Copia una guida markdown strutturata su cui il tuo agent può agire immediatamente — installa, verifica e usa.',
  'useEverywhere.configureMcp': 'Configura server MCP',
  'useEverywhere.copyGuide': 'Copia guida per un agent',
  'useEverywhere.copy': 'Copia',
  'useEverywhere.copied': 'Copiato',
  'useEverywhere.copyFailed': 'Copia non riuscita',
  'useEverywhere.copySnippetAria': 'Copia snippet: {label}',
  'useEverywhere.section.overview.tab': 'Panoramica',
  'useEverywhere.section.overview.heading': 'OpenDesign funziona ovunque lavori il tuo agent',
  'useEverywhere.section.overview.intro': 'OpenDesign è molto più di una finestra — è un daemon locale con privilegi (`od`) più un registro di Skill + Design System + Atoms. Una volta in esecuzione sulla tua macchina, qualsiasi agent di codice (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, un tuo script) può avviare generazioni, ispezionare progetti e produrre artefatti di design attraverso quattro interfacce intercambiabili.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` per script headless, CI e automazione da shell.',
  'useEverywhere.section.overview.bullet2': 'Server MCP — collega OpenDesign come server Model Context Protocol così che qualsiasi agent compatibile con MCP possa elencare skill, eseguire scenari e leggere artefatti.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoint REST + SSE su `http://127.0.0.1:7456/api/*`; la stessa interfaccia usata dalla UI web.',
  'useEverywhere.section.overview.bullet4': 'Skill — pacchetti `SKILL.md` pronti all\'uso (compatibili con Claude) che qualsiasi agent già presente nel tuo PATH può invocare senza OpenDesign.',
  'useEverywhere.section.overview.bullet5': 'Artefatti standard — genera progetti HTML reali da Skill, plugin predefiniti inclusi ed esempi di plugin della community prima dell\'avvio del daemon.',
  'useEverywhere.section.overview.snippet1': 'Avvia il daemon (e la web UI) in locale',
  'useEverywhere.section.overview.snippet2': 'Conferma che sia raggiungibile',
  'useEverywhere.section.overview.snippet3': 'Importa gli artefatti standard prima dell\'avvio',
  'useEverywhere.section.overview.footer': 'Per impostazione predefinita, il daemon scrive in `./.od/` (locale al progetto). Imposta `OD_DATA_DIR=~/.open-design` per condividere i dati tra progetti.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Controlla OpenDesign da qualsiasi shell',
  'useEverywhere.section.cli.intro': 'Il binario `od` è incluso con il daemon ed è lo stesso binario usato da Claude Code / Codex quando eseguono una generazione. La maggior parte dei sottocomandi sono client leggeri che inviano POST al daemon locale, quindi funzionano allo stesso modo sia che tu l\'abbia avviato tramite `pnpm tools-dev` sia come app pacchettizzata.',
  'useEverywhere.section.cli.bullet1': '`od` (senza argomenti) — avvia il daemon e apre la UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produce byte di immagine / video / audio attraverso il protocollo media unificato.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — avvia l\'esecuzione di un progetto a partire da un prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — installa e applica plugin della community.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ispeziona ciò che è disponibile localmente.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — verifica lo stato del daemon e rileva le CLI degli agent nel tuo PATH.',
  'useEverywhere.section.cli.snippet1': 'Genera un\'immagine (delega al media provider configurato)',
  'useEverywhere.section.cli.snippet2': 'Esegui un plugin di scenario in modalità headless e trasmetti gli eventi come righe JSON',
  'useEverywhere.section.cli.snippet3': 'Elenca skill e design system disponibili in locale',
  'useEverywhere.section.cli.snippet4': 'Verifica gli artefatti precaricati tramite la CLI',
  'useEverywhere.section.cli.snippet5': 'Verifica l\'ambiente + gli agent rilevati (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Tutti i sottocomandi accettano `--daemon-url http://127.0.0.1:<port>` per puntare a uno specifico daemon in esecuzione — utile quando si esegue una seconda istanza in sandbox per i test.',
  'useEverywhere.section.mcp.tab': 'Server MCP',
  'useEverywhere.section.mcp.heading': 'Esponi OpenDesign come server MCP a qualsiasi coding agent',
  'useEverywhere.section.mcp.intro': 'OpenDesign include un server Model Context Protocol (`od mcp`) che consente a qualsiasi client compatibile con MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — di scoprire gli strumenti di OpenDesign (elenca skill, genera anteprime, genera media, esegui plugin) senza ricorrere manualmente alla shell. Il daemon pubblica uno snippet di installazione pronto da incollare tramite `GET /api/mcp/install-info` per ogni client principale.',
  'useEverywhere.section.mcp.bullet1': 'Trasporto stdio — nessuna porta aggiuntiva, il client avvia direttamente `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Rileva automaticamente l\'URL del daemon attivo tramite il socket di stato IPC locale quando viene avviato come sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Ripiega su `--daemon-url http://127.0.0.1:<port>` per le installazioni semplici, così il processo MCP trova sempre un daemon in esecuzione.',
  'useEverywhere.section.mcp.bullet4': 'Fissa `OD_DATA_DIR` in modo che il processo MCP generato scriva nello stesso percorso già usato dal daemon (evita EPERM nei bundle delle app macOS pacchettizzate).',
  'useEverywhere.section.mcp.snippet1': 'Configurazione generica del client MCP (funziona in Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Oppure: chiedi al daemon lo snippet personalizzato per la tua installazione',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP live-artifacts (leggi e aggiorna le dashboard)',
  'useEverywhere.section.mcp.footer': 'Nell\'app OpenDesign, apri Impostazioni → Integrazioni per copiare un comando di installazione specifico per il client (Cursor, Claude Code, Antigravity, VS Code) invece di modificare il JSON manualmente.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'Stessa superficie REST + SSE usata dalla web UI',
  'useEverywhere.section.http.intro': 'Il daemon locale serve un\'API HTTP su `http://127.0.0.1:7456` (porta configurabile). Ogni endpoint chiamato dalla web UI è utilizzabile anche dai tuoi script. Gli endpoint di streaming (turni di chat, esecuzioni di progetto) emettono Server-Sent Events con i tipi di contratto in `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — stato di attività del daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` e `GET /api/design-systems` — registri disponibili.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` e `POST /api/projects` — elenca e crea progetti (POST restituisce il progetto + la prima conversazione).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — stream SSE di eventi dell\'agent per una conversazione.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — collega un plugin installato e ottieni la sua query di esempio renderizzata + gli input.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLI di agent di codice rilevate nel tuo PATH.',
  'useEverywhere.section.http.snippet1': 'Elenca le skill installate (l\'agent le userà come template)',
  'useEverywhere.section.http.snippet2': 'Crea un progetto da un prompt (flusso completo lato server)',
  'useEverywhere.section.http.snippet3': 'Trasmetti in streaming un turno di chat (SSE — ogni riga è compatibile con JSON-Lines)',
  'useEverywhere.section.http.footer': 'I tipi TypeScript puri per ogni richiesta/risposta si trovano in `@open-design/contracts` — importali nel tuo script per il completamento automatico completo senza configurare un generatore.',
  'useEverywhere.section.skills.tab': 'Skill e headless',
  'useEverywhere.section.skills.heading': 'Skill pronte all\'uso per qualsiasi agent — anche senza OpenDesign in esecuzione',
  'useEverywhere.section.skills.intro': 'Una Skill è una directory con un file `SKILL.md` compatibile con Claude (front-matter YAML + corpo). OpenDesign estende il formato con il namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) così che lo stesso artefatto possa essere usato sia all\'interno di OpenDesign sia da un agent standard come Claude Code, Codex, openclaw o hermes. Il rilevamento segue una catena di precedenza così che i progetti possano sovrascrivere le proprie skill.',
  'useEverywhere.section.skills.bullet1': 'Rilevamento: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (vince il progetto).',
  'useEverywhere.section.skills.bullet2': 'Crea un collegamento simbolico di una skill in più progetti per condividerla senza copiarla.',
  'useEverywhere.section.skills.bullet3': 'Ogni skill può dichiarare connettori, atomi, requisiti di design system e un output di esempio `preview` per la galleria.',
  'useEverywhere.section.skills.bullet4': 'Headless: un agent con `od` nel suo PATH può chiamare `od skills list` e poi eseguire qualsiasi skill; il daemon è facoltativo per i flussi di sola lettura.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` mette alla prova la stessa struttura di artefatti con esempi di plugin predefiniti ed esempi di plugin della community, poi memorizza i progetti `index.html` risultanti come dati di test riutilizzabili.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md minimale (front matter compatibile con Claude + extra di OpenDesign)',
  'useEverywhere.section.skills.snippet2': 'Crea un collegamento simbolico di una skill condivisa in un progetto (stile cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: elenca le skill che il daemon vede in questo momento',
  'useEverywhere.section.skills.snippet4': 'Bundle di fixture di artefatti headless',
  'useEverywhere.section.skills.footer': 'Specifica: `docs/skills-protocol.md` e `docs/agent-adapters.md` coprono l\'intera superficie degli adapter (Claude Code, Codex, Cursor, agent compatibili con MCP, fallback API BYOK) e le strategie di iniezione delle skill per ciascun adapter.',
  'tasks.kicker': 'Spazio di lavoro per l\'automazione',
  'tasks.comingSoon': 'Prossimamente',
  'tasks.lede': 'Le automazioni trasformano i prompt in lavoro duraturo: Orbit le esegue, le routine le mantengono attive, le pianificazioni decidono quando si attivano e i live artifact mostrano cosa è cambiato.',
  'tasks.newAutomation': 'Nuova automazione',
  'tasks.previewNote': 'Solo superficie di anteprima. Le impostazioni di Orbit sono già disponibili oggi; routine, pianificazioni e il collegamento dei live artifact arriveranno con l\'unione dei branch di backend.',
  'tasks.primitivesAria': 'Primitive di automazione',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Un runtime persistente per il lavoro dell\'agent a lunga esecuzione o ricorrente.',
  'tasks.primitive.orbit.enabled': 'Riepilogo giornaliero attivato',
  'tasks.primitive.orbit.manualOnly': 'Solo manuale',
  'tasks.primitive.routines.title': 'Routine',
  'tasks.primitive.routines.body': 'Definizioni di attività durature che persistono dopo la fine di una singola chat.',
  'tasks.primitive.routines.meta': 'Shell del prodotto pronta',
  'tasks.primitive.schedules.title': 'Pianificazioni',
  'tasks.primitive.schedules.body': 'Trigger temporali o basati su eventi che decidono quando una routine deve essere eseguita.',
  'tasks.primitive.schedules.meta': 'Branch in sospeso',
  'tasks.primitive.liveArtifacts.title': 'Live artifact',
  'tasks.primitive.liveArtifacts.body': 'Report e note che continuano ad aggiornarsi mentre un agent lavora.',
  'tasks.primitive.liveArtifacts.meta': 'Modello di anteprima',
  'tasks.listAria': 'Elenco delle automazioni',
  'tasks.routinesAndRuns': '{n} routine ed esecuzioni',
  'tasks.filtersAria': 'Filtri di automazione',
  'tasks.filter.scheduled': 'Pianificato',
  'tasks.filter.running': 'In esecuzione',
  'tasks.filter.done': 'Completato',
  'tasks.configurationAria': 'Configurazione automazione',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Pattern',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Output',
  'tasks.liveArtifact': 'Artefatto live',
  'tasks.viewProgress': 'Visualizza avanzamento',
  'tasks.pause': 'Pausa',
  'tasks.runNow': 'Esegui ora',
  'tasks.openArtifact': 'Apri artefatto',
  'tasks.status.dailyAt': 'Giornaliero · {time}',
  'tasks.status.pausedManual': 'In pausa · solo manuale',
  'tasks.sample.orbit.title': 'Riepilogo connettori Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Il digest dei connettori è pianificato',
  'tasks.sample.orbit.metaDisabled': 'Apri le impostazioni di Orbit per abilitare',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefatto live',
  'tasks.sample.orbit.previewDisabled': 'Nessuna esecuzione pianificata',
  'tasks.sample.orbit.triggerEnabled': 'Pianificazione · ogni giorno alle {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuale · esegui su richiesta',
  'tasks.sample.orbit.pattern': 'Routine · digest connettori',
  'tasks.sample.orbit.runtime': 'Orbit · pianificato dal daemon',
  'tasks.sample.orbit.output': 'Artefatto live · report aggiornabile',
  'tasks.sample.orbit.artifactMetaEnabled': 'Si aggiorna dopo ogni esecuzione',
  'tasks.sample.orbit.artifactMetaDisabled': 'In attesa della pianificazione',
  'tasks.sample.orbit.body1': '# Riepilogo attività Orbit Daily',
  'tasks.sample.orbit.body2': 'Connettori verificati · successi, salti ed errori',
  'tasks.sample.orbit.body3': 'I punti salienti diventano un artefatto live aggiornabile.',
  'tasks.sample.mcp.title': 'Ricerca su alternative a MCP',
  'tasks.sample.mcp.status': 'In esecuzione in orbit · 2h 14m',
  'tasks.sample.mcp.meta': '14 / 30 fonti elaborate',
  'tasks.sample.mcp.preview': 'research_notes.md · live',
  'tasks.sample.mcp.trigger': 'Manuale · esecuzione singola',
  'tasks.sample.mcp.pattern': 'Prompt di ricerca approfondita',
  'tasks.sample.mcp.runtime': 'Remoto · persistente',
  'tasks.sample.mcp.output': 'Report live · aggiornamento automatico',
  'tasks.sample.mcp.artifactMeta': 'Aggiornato 12s fa',
  'tasks.sample.mcp.body1': '# Alternative a MCP - risultati preliminari',
  'tasks.sample.mcp.body2': '14 fonti esaminate · 3 candidati selezionati',
  'tasks.sample.mcp.body3': '## Selezione',
  'tasks.sample.mcp.body4': '- Schemi di chiamata strumenti tramite JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocolli Agent basati su gRPC...',
  'tasks.sample.weekly.title': 'Digest settimanale del team',
  'tasks.sample.weekly.status': 'Prossimo: lun 9:00',
  'tasks.sample.weekly.meta': 'Aggiorna il documento settimanale del Team',
  'tasks.sample.weekly.preview': 'team_weekly.md · prossimo artefatto',
  'tasks.sample.weekly.trigger': 'Pianificazione · settimanale',
  'tasks.sample.weekly.pattern': 'Routine · digest del team',
  'tasks.sample.weekly.runtime': 'Remoto · ricorrente',
  'tasks.sample.weekly.output': 'Artefatto live · markdown',
  'tasks.sample.weekly.artifactMeta': 'Ultimo aggiornamento 4g fa',
  'tasks.sample.weekly.body1': '# Settimanale del team',
  'tasks.sample.weekly.body2': '## In corso',
  'tasks.sample.weekly.body3': '- Passaggio di integrazione del design system',
  'tasks.sample.weekly.body4': '- Controllo qualità dei connettori',
  'tasks.sample.weekly.body5': '## Rischi',
  'tasks.sample.pr.title': 'Promemoria revisione PR',
  'tasks.sample.pr.status': 'Su nuova PR · attivato 23m fa',
  'tasks.sample.pr.meta': 'Invia un messaggio diretto su Slack',
  'tasks.sample.pr.preview': 'Ultima consegna riuscita',
  'tasks.sample.pr.trigger': 'Evento · nuova PR',
  'tasks.sample.pr.pattern': 'Routine · notifica',
  'tasks.sample.pr.runtime': 'Locale · esecuzione rapida',
  'tasks.sample.pr.output': 'Messaggio · DM Slack',
  'tasks.sample.pr.artifactMeta': 'Ultimo avvio 23m fa',
  'tasks.sample.pr.body1': 'Aperta la PR #184 per la revisione',
  'tasks.sample.pr.body2': 'Revisori abbinati: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Consegna: messaggio diretto Slack inviato',
  'tasks.sample.meeting.title': 'Preparazione pre-riunione',
  'tasks.sample.meeting.status': 'Domani · 10:00',
  'tasks.sample.meeting.meta': 'Esecuzione singola · invia riepilogo',
  'tasks.sample.meeting.preview': 'meeting_brief.md · in coda',
  'tasks.sample.meeting.trigger': 'Pianificazione · esecuzione singola',
  'tasks.sample.meeting.pattern': 'Prompt di briefing',
  'tasks.sample.meeting.runtime': 'Remoto · limitato',
  'tasks.sample.meeting.output': 'Artefatto + messaggio',
  'tasks.sample.meeting.artifactMeta': 'In coda per la generazione',
  'tasks.sample.meeting.body1': '# Brief riunione',
  'tasks.sample.meeting.body2': 'Fonte dell\'agenda: evento del calendario + documenti collegati',
  'tasks.sample.meeting.body3': 'L\'output includerà decisioni, blocchi e domande.',
  'tasks.sample.candidate.title': 'Monitoraggio candidati',
  'tasks.sample.candidate.status': 'Non riuscito · richiede attenzione',
  'tasks.sample.candidate.meta': 'Autenticazione scaduta',
  'tasks.sample.candidate.preview': 'Ricollega Greenhouse per riprendere',
  'tasks.sample.candidate.trigger': 'Pianificazione · giornaliera',
  'tasks.sample.candidate.pattern': 'Routine · sincronizzazione candidati',
  'tasks.sample.candidate.runtime': 'Remoto · ricorrente',
  'tasks.sample.candidate.output': 'Artefatto live · tabella',
  'tasks.sample.candidate.artifactMeta': 'In pausa fino al ripristino dell\'autenticazione',
  'tasks.sample.candidate.body1': '# Pipeline candidati',
  'tasks.sample.candidate.body2': 'Ultima sincronizzazione riuscita: 2g fa',
  'tasks.sample.candidate.body3': 'Azione richiesta: riconnetti l\'account di origine.',
  'routines.title': 'Automazioni',
  'routines.subtitle': 'Automazioni pianificate che vengono eseguite automaticamente.',
  'routines.newAutomation': 'Nuova automazione',
  'routines.loading': 'Caricamento…',
  'routines.empty': 'Nessuna automazione.',
  'routines.emptyHint': 'Fai clic su Nuova automazione per pianificare un\'esecuzione automatica dell\'Agent.',
  'routines.runHistoryLoading': 'Caricamento esecuzioni…',
  'routines.runHistoryEmpty': 'Nessuna esecuzione.',
  'routines.fieldName': 'Nome',
  'routines.fieldNamePlaceholder': 'Briefing mattutino',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Recupera l\'attività di ieri su GitHub + Linear e riassumi cosa è cambiato.',
  'routines.fieldSchedule': 'Pianificazione',
  'routines.fieldMinute': 'Minuto di ogni ora',
  'routines.fieldTime': 'Orario',
  'routines.fieldTimezone': 'Fuso orario',
  'routines.fieldsetProject': 'Progetto',
  'routines.kind.hourly': 'Ogni ora',
  'routines.kind.daily': 'Ogni giorno',
  'routines.kind.weekdays': 'Giorni feriali',
  'routines.kind.weekly': 'Ogni settimana',
  'routines.weekday.short.0': 'Dom',
  'routines.weekday.short.1': 'Lun',
  'routines.weekday.short.2': 'Mar',
  'routines.weekday.short.3': 'Mer',
  'routines.weekday.short.4': 'Gio',
  'routines.weekday.short.5': 'Ven',
  'routines.weekday.short.6': 'Sab',
  'routines.weekday.long.0': 'Domenica',
  'routines.weekday.long.1': 'Lunedì',
  'routines.weekday.long.2': 'Martedì',
  'routines.weekday.long.3': 'Mercoledì',
  'routines.weekday.long.4': 'Giovedì',
  'routines.weekday.long.5': 'Venerdì',
  'routines.weekday.long.6': 'Sabato',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Viene eseguita ogni ora al minuto :{minute}',
  'routines.describe.daily': 'Viene eseguita ogni giorno alle {time} {tz}',
  'routines.describe.weekdays': 'Viene eseguito da lun a ven alle {time} {tz}',
  'routines.describe.weekly': 'Viene eseguita ogni {day} alle {time} {tz}',
  'routines.modeCreate': 'Crea un nuovo progetto a ogni esecuzione',
  'routines.modeCreateHint': 'Uno spazio di lavoro nuovo e isolato a ogni attivazione.',
  'routines.modeReuse': 'Riutilizza un progetto esistente',
  'routines.modeReuseHint': 'Ogni esecuzione vive come una nuova conversazione all\'interno del progetto.',
  'routines.pickProject': '— Scegli un progetto —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nuovo progetto a ogni esecuzione',
  'routines.tagPaused': 'in pausa',
  'routines.metaNext': 'prossima: {when}',
  'routines.metaLast': 'ultima:',
  'routines.triggerManual': 'manuale',
  'routines.triggerScheduled': 'pianificata',
  'routines.openProject': 'Apri progetto',
  'routines.openProjectTitle': 'Apri il progetto su cui ha scritto questa esecuzione',
  'routines.runNow': 'Esegui ora',
  'routines.edit': 'Modifica',
  'routines.pause': 'Sospendi',
  'routines.resume': 'Riprendi',
  'routines.history': 'Cronologia',
  'routines.hideHistory': 'Nascondi cronologia',
  'routines.delete': 'Elimina',
  'routines.deleteTitle': 'Elimina questa automazione',
  'routines.cancel': 'Annulla',
  'routines.save': 'Salva',
  'routines.saving': 'Salvataggio…',
  'routines.create': 'Crea',
  'routines.creating': 'Creazione…',
  'routines.status.queued': 'in coda',
  'routines.status.running': 'in esecuzione',
  'routines.status.succeeded': 'completato',
  'routines.status.failed': 'non riuscito',
  'routines.status.canceled': 'annullato',
  'routines.confirmDelete': 'Eliminare questa automazione? Le esecuzioni precedenti e i relativi progetti vengono conservati.',
  'routines.errorPickProject': 'Scegli un progetto da riutilizzare oppure passa a “Crea nuovo a ogni esecuzione”',
  'routines.errorAgentEmptyOutput': 'L\'Agent è terminato senza produrre alcun output. Il modello o il provider potrebbe aver restituito una risposta vuota — controlla i log dell\'Agent per eventuali errori a monte.',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Fai clic per assegnarci una star su GitHub',
  'entry.githubStarAria': 'Assegna una star a OpenDesign su GitHub',
  'entry.tabImageTemplates': 'Modelli di immagine',
  'entry.tabVideoTemplates': 'Modelli di video',
  'promptTemplates.emptyNoMatch': 'Nessun modello corrisponde alla tua ricerca.',
  'promptTemplates.fetchError': 'Impossibile caricare il contenuto di questo modello.',
  'promptTemplates.promptLabel': 'Corpo del prompt',
  'promptTemplates.copyPrompt': 'Copia prompt',
  'promptTemplates.copyDone': 'Copiato!',
  'promptTemplates.allSources': 'Tutte le fonti',
  'promptTemplates.retry': 'Riprova',
  'connectors.title': 'Connettori',
  'connectors.subtitle': 'Fonti di dati locali e future che possono alimentare gli artefatti live.',
  'connectors.account': 'Account',
  'connectors.noAccount': 'Non connesso',
  'connectors.tools': 'Strumenti',
  'connectors.connect': 'Connetti',
  'connectors.disconnect': 'Disconnetti',
  'connectors.authorizationPending': 'In attesa di autorizzazione...',
  'connectors.authorizationPendingHint': 'Completa l\'autorizzazione nella finestra aperta.',
  'connectors.cancelAuthorization': 'Annulla',
  'connectors.configure': 'Configura',
  'connectors.unavailable': 'Non disponibile',
  'connectors.phaseStubTitle': 'Le API dei connettori arrivano nella fase 3; questa è un\'anteprima.',
  'connectors.statusAvailable': 'Disponibile',
  'connectors.statusConnected': 'Connesso',
  'connectors.statusError': 'Errore',
  'connectors.statusDisabled': 'Disabilitato',
  'connectors.gateTitle': 'Aggiungi la tua chiave API Composio per continuare',
  'connectors.gateBody': 'Incolla la tua chiave sopra, poi clicca su Salva chiave per caricare le integrazioni disponibili.',
  'connectors.aboutLabel': 'Informazioni',
  'connectors.detailsLabel': 'Dettagli',
  'connectors.statusLabel': 'Stato',
  'connectors.category.aiAgents': 'Agenti IA',
  'connectors.category.aiInfrastructure': 'Infrastruttura IA',
  'connectors.category.accounting': 'Contabilità',
  'connectors.category.admin': 'Amministrazione',
  'connectors.category.advertising': 'Pubblicità',
  'connectors.category.analytics': 'Analisi',
  'connectors.category.automation': 'Automazione',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendario',
  'connectors.category.commerce': 'Commercio',
  'connectors.category.communication': 'Comunicazione',
  'connectors.category.contacts': 'Contatti',
  'connectors.category.dataPlatform': 'Piattaforma dati',
  'connectors.category.database': 'Database',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Strumenti sviluppatore',
  'connectors.category.documentation': 'Documentazione',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Istruzione',
  'connectors.category.email': 'Email',
  'connectors.category.events': 'Eventi',
  'connectors.category.fieldService': 'Servizio sul campo',
  'connectors.category.finance': 'Finanza',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Moduli',
  'connectors.category.gaming': 'Giochi',
  'connectors.category.hr': 'Risorse umane',
  'connectors.category.hospitality': 'Ospitalità',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integrazione',
  'connectors.category.localization': 'Localizzazione',
  'connectors.category.logistics': 'Logistica',
  'connectors.category.maps': 'Mappe',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Riunioni',
  'connectors.category.nonprofit': 'No profit',
  'connectors.category.observability': 'Osservabilità',
  'connectors.category.payments': 'Pagamenti',
  'connectors.category.personal': 'Personale',
  'connectors.category.presentations': 'Presentazioni',
  'connectors.category.procurement': 'Approvvigionamento',
  'connectors.category.product': 'Prodotto',
  'connectors.category.productivity': 'Produttività',
  'connectors.category.projectManagement': 'Gestione progetti',
  'connectors.category.recruiting': 'Reclutamento',
  'connectors.category.research': 'Ricerca',
  'connectors.category.salesIntelligence': 'Intelligence vendite',
  'connectors.category.scheduling': 'Pianificazione',
  'connectors.category.search': 'Ricerca',
  'connectors.category.security': 'Sicurezza',
  'connectors.category.signing': 'Firma',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Fogli di calcolo',
  'connectors.category.storage': 'Archiviazione',
  'connectors.category.support': 'Supporto',
  'connectors.category.surveys': 'Sondaggi',
  'connectors.category.tasks': 'Attività',
  'connectors.category.timeTracking': 'Tracciamento tempo',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Lavagna',
  'connectors.categoryLabel': 'Categoria',
  'connectors.providerLabel': 'Provider',
  'connectors.toolsSection': 'Strumenti',
  'connectors.toolsLoading': 'Caricamento strumenti…',
  'connectors.noToolsAvailable': 'Nessuno strumento disponibile per ora. Connettiti per scoprire le capacità di questa integrazione.',
  'connectors.toolDetailsUnavailable': 'I dettagli degli strumenti non sono disponibili, ma questo connettore riporta {n} strumenti.',
  'connectors.loadMoreTools': 'Carica altri strumenti',
  'connectors.openDetailsAria': 'Apri dettagli di {name}',
  'connectors.toolsBadgeNone': 'Nessuno strumento',
  'connectors.toolsBadgeOne': '{n} strumento',
  'connectors.toolsBadgeMany': '{n} strumenti',
  'connectors.searchPlaceholder': 'Cerca connettori…',
  'connectors.searchAriaLabel': 'Cerca connettori per nome, provider o strumento',
  'connectors.searchClear': 'Cancella ricerca',
  'connectors.emptyNoMatchTitle': 'Nessun connettore corrisponde a « {query} »',
  'connectors.emptyNoMatchBody': 'Prova un\'altra parola chiave o cancella la ricerca per vedere il catalogo completo.',
  'connectors.emptyNoMatchAction': 'Cancella ricerca',
  'newproj.tabPrototype': 'Prototipo',
  'newproj.tabLiveArtifact': 'Artefatto live',
  'newproj.tabDeck': 'Presentazione',
  'newproj.tabTemplate': 'Da un modello',
  'newproj.tabMedia': 'Media',
  'newproj.tabOther': 'Altro',
  'newproj.titlePrototype': 'Nuovo prototipo',
  'newproj.titleLiveArtifact': 'Nuovo artefatto live',
  'newproj.titleDeck': 'Nuova presentazione',
  'newproj.titleTemplate': 'Partire da un modello',
  'newproj.titleImage': 'Nuova immagine',
  'newproj.titleVideo': 'Nuovo video',
  'newproj.titleAudio': 'Nuovo audio',
  'newproj.titleMedia': 'Nuovo media',
  'newproj.titleOther': 'Nuovo progetto',
  'newproj.namePlaceholder': 'Nome del progetto',
  'newproj.fidelityLabel': 'Fedeltà',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Alta fedeltà',
  'newproj.toggleSpeakerNotes': 'Usa note del relatore',
  'newproj.toggleSpeakerNotesHint': 'Meno testo sulle diapositive — mantieni i punti di discussione nelle note.',
  'newproj.toggleAnimations': 'Includi animazioni',
  'newproj.toggleAnimationsHint': 'Aggiungi movimento (entrata, hover, transizioni) oltre al modello.',
  'newproj.targetPlatformsLabel': 'Piattaforme di destinazione',
  'newproj.targetPlatformsHint': 'Scegline una o più. Il web responsive copre solo i breakpoint del browser; aggiungi iOS, Android, app per tablet o app desktop per le varianti native multipiattaforma.',
  'newproj.platform.responsive.label': 'Web responsive',
  'newproj.platform.responsive.hint': 'Un\'unica esperienza web adattata per browser desktop, tablet e mobile',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Prodotto o landing page browser-first',
  'newproj.platform.mobileIos.label': 'App iOS',
  'newproj.platform.mobileIos.hint': 'Frame iPhone e regole di interazione iOS',
  'newproj.platform.mobileAndroid.label': 'App Android',
  'newproj.platform.mobileAndroid.hint': 'Frame Pixel e regole di interazione Material',
  'newproj.platform.tablet.label': 'App per tablet',
  'newproj.platform.tablet.hint': 'Esperienza tablet in stile nativo con viste affiancate',
  'newproj.platform.desktopApp.label': 'App desktop',
  'newproj.platform.desktopApp.hint': 'Chrome dell\'app macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Superfici companion',
  'newproj.includeLandingPage': 'Includi landing page',
  'newproj.includeLandingPageHint': 'Aggiungi una pagina di marketing responsive per annunci, liste d\'attesa, campagne di lancio, download dell\'app o presentazione del prodotto.',
  'newproj.includeOsWidgets': 'Includi widget di sistema',
  'newproj.includeOsWidgetsHint': 'Aggiungi widget nativi della piattaforma per la schermata Home, la schermata di blocco o l\'accesso rapido per app mobile/tablet.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponibile quando un\'app iOS, Android o per tablet è selezionata come piattaforma di destinazione.',
  'newproj.templateLabel': 'Modello',
  'newproj.noTemplatesTitle': 'Nessun modello per ora',
  'newproj.noTemplatesBody': 'Apri un progetto, poi usa il menu Condividi nel visualizzatore di file per convertirlo in modello. I modelli appaiono qui.',
  'newproj.savedTemplate': 'Modello salvato',
  'newproj.fileSingular': 'file',
  'newproj.filePlural': 'file',
  'newproj.create': 'Crea',
  'newproj.locationLabel': 'Salva in',
  'newproj.locationDefault': 'Progetti OpenDesign',
  'newproj.locationExternalBase': 'Base esterna',
  'newproj.createLiveArtifact': 'Crea artefatto live',
  'newproj.createFromTemplate': 'Crea dal modello',
  'newproj.createDisabledTitle': 'Salva prima un progetto come modello (menu Condividi in un progetto).',
  'newproj.openFolder': 'Apri cartella',
  'newproj.openingFolder': 'Apertura…',
  'newproj.importClaudeZip': 'Importa un ZIP Claude Design',
  'newproj.importClaudeZipTitle': 'Importa un\'esportazione .zip Claude Design',
  'newproj.importingClaudeZip': 'Importazione…',
  'newproj.privacyFooter': 'Solo tu puoi vedere il tuo progetto per impostazione predefinita.',
  'newproj.designSystem': 'Design system',
  'newproj.dsNoneFreeform': 'Nessuno — libero',
  'newproj.dsNoneSubtitleEmpty': 'Nessun token di sistema, scegli la tua palette',
  'newproj.dsNoneSubtitleSelected': 'Ignora i token di sistema. L\'agente sceglie la propria palette.',
  'newproj.dsCategoryFallback': 'Design system',
  'newproj.dsSearch': 'Cerca design system…',
  'newproj.dsModeAria': 'Modalità di selezione',
  'newproj.dsModeSingle': 'Singolo',
  'newproj.dsModeMulti': 'Multiplo',
  'newproj.dsNoneTitle': 'Nessuno — libero',
  'newproj.dsNoneSub': 'Ignora i token di sistema. L\'agente sceglie la propria palette.',
  'newproj.dsEmpty': 'Nessun design system corrisponde a « {query} ».',
  'newproj.dsFootSingular': 'è solo a scopo di ispirazione.',
  'newproj.dsFootPlural': 'sono solo a scopo di ispirazione.',
  'newproj.dsFootClear': 'Cancella',
  'newproj.dsBadgeDefault': 'PREDEFINITO',
  'newproj.dsPrimaryFallback': 'Primario',
  'newproj.surfaceImage': 'Immagine',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modello',
  'newproj.modelSearch': 'Cerca modelli…',
  'newproj.modelEmpty': 'Nessun modello corrisponde a questa ricerca.',
  'newproj.modelRecommended': 'Consigliato',
  'newproj.modelMissingTitle': 'Scegli un modello',
  'newproj.modelMissingSub': 'Scegli quale modello gestisce questa superficie.',
  'newproj.aspectLabel': 'Formato',
  'newproj.videoLengthLabel': 'Durata',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Tipo di audio',
  'newproj.audioKindMusic': 'Musica',
  'newproj.audioKindSpeech': 'Voce / TTS',
  'newproj.audioKindSfx': 'Effetti sonori',
  'newproj.audioDurationLabel': 'Durata',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Voce',
  'newproj.voicePlaceholder': 'Identificatore voce del provider, opzionale',
  'newproj.connectorsLabel': 'Connettori',
  'newproj.connectorsHint': 'Fonti di dati che questo artefatto può interrogare.',
  'newproj.connectorsEmptyTitle': 'Nessun connettore configurato',
  'newproj.connectorsEmptyBody': 'Connetti una fonte di dati affinché l\'artefatto live utilizzi dati reali invece di segnaposto.',
  'newproj.connectorsEmptyCta': 'Configura connettori →',
  'newproj.connectorsLoading': 'Caricamento connettori…',
  'newproj.connectorsCountOne': '{n} connesso',
  'newproj.connectorsCountMany': '{n} connessi',
  'newproj.connectorsManage': 'Gestisci',
  'newproj.promptTemplateLabel': 'Modello di riferimento',
  'newproj.promptTemplateNoneTitle': 'Nessuno — scrivi il tuo',
  'newproj.promptTemplateNoneSub': 'Ignora la galleria, descrivi il tuo brief',
  'newproj.promptTemplateRefSub': 'Modello di riferimento',
  'newproj.promptTemplateSearch': 'Cerca modelli…',
  'newproj.promptTemplateEmpty': 'Nessun modello installato per questa superficie per ora.',
  'newproj.promptTemplateBodyLabel': 'Prompt (puoi modificarlo)',
  'newproj.promptTemplateOptimizeHint': 'Modifica ciò che vuoi — le tue modifiche vengono trasmesse al brief dell\'agente.',
  'newproj.promptTemplateBodyEmpty': 'Corpo vuoto — l\'agente non riceverà alcun riferimento di modello.',
  'newproj.deleteTemplateTitle': 'Elimina modello',
  'newproj.deleteTemplateConfirm': 'Eliminare « {name} » ? Questa operazione non può essere annullata.',
  'newproj.deleteTemplateConfirmCta': 'Elimina modello',
  'newproj.deleteTemplateError': 'Impossibile eliminare questo modello. Riprova.',
  'designs.subRecent': 'Recenti',
  'designs.subYours': 'I tuoi design',
  'designs.filterAria': 'Filtra progetti',
  'designs.searchPlaceholder': 'Cerca…',
  'designs.emptyNoProjects': 'Nessun progetto per ora.',
  'designs.emptyNoMatch': 'Nessun progetto corrisponde alla tua ricerca.',
  'designs.deleteTitle': 'Elimina progetto',
  'designs.deleteConfirm': 'Eliminare « {name} » ?',
  'designs.cardFreeform': 'libero',
  'designs.badgeLive': 'Attivo',
  'designs.liveArtifactBadgesAria': 'Badge artifact live',
  'designs.liveCount': '{n} attivi',
  'designs.statusLive': 'Artifact live',
  'designs.statusArchived': 'Archiviato',
  'designs.statusError': 'Errore',
  'designs.statusRefreshing': 'Aggiornamento…',
  'designs.statusRefreshFailed': 'Aggiornamento non riuscito',
  'designs.statusRefreshed': 'Aggiornato',
  'designs.status.notStarted': 'Non iniziato',
  'designs.status.queued': 'In coda',
  'designs.status.running': 'In corso',
  'designs.status.awaitingInput': 'Input richiesto',
  'designs.status.incomplete': 'Incompleto',
  'designs.status.succeeded': 'Completato',
  'designs.status.published': 'Pubblicato',
  'designs.status.failed': 'Fallito',
  'designs.status.canceled': 'Annullato',
  'designs.viewToggleAria': 'Modalità di visualizzazione',
  'designs.viewGrid': 'Vista griglia',
  'designs.viewKanban': 'Vista tabella',
  'designs.kanbanEmptyColumn': 'Nessun design',
  'designs.deleteAria': 'Elimina progetto {name}',
  'designs.menuMore': 'Altre azioni',
  'designs.menuRename': 'Rinomina',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Elimina',
  'designs.renamePrompt': 'Nuovo nome per "{name}"',
  'designs.selectMode': 'Seleziona',
  'designs.cancelSelect': 'Annulla',
  'designs.deleteSelected': 'Elimina selezionati',
  'designs.selectedCount': '{n} selezionati',
  'designs.deleteSelectedConfirm': 'Eliminare {n} progetto/i?',
  'designs.deleteSelectedSuccess': '{n} progetto/i eliminato/i con successo.',
  'designs.deleteSelectedPartial': '{deleted} progetto/i eliminato/i; {failed} non riusciti.',
  'designs.tagPrototype': 'Prototipo',
  'designs.tagLiveArtifact': 'Artifact live',
  'designs.tagWebClone': 'Clone di sito web',
  'designs.tagSlide': 'Diapositiva',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rinomina progetto',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Annulla',
  'examples.typeLabel': 'Tipo',
  'examples.surfaceLabel': 'Superficie',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Immagine',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Scenario',
  'examples.modeAll': 'Tutto',
  'examples.modePrototypeDesktop': 'Prototipi · Desktop',
  'examples.modePrototypeMobile': 'Prototipi · Mobile',
  'examples.modeDeck': 'Presentazioni',
  'examples.modeDocument': 'Documenti e modelli',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Attivo',
  'examples.scenarioGeneral': 'Generale',
  'examples.scenarioEngineering': 'Ingegneria',
  'examples.scenarioProduct': 'Prodotto',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Vendite',
  'examples.scenarioFinance': 'Finanza',
  'examples.scenarioHr': 'Risorse umane',
  'examples.scenarioOperations': 'Operazioni',
  'examples.scenarioSupport': 'Supporto',
  'examples.scenarioLegal': 'Legale',
  'examples.scenarioEducation': 'Istruzione',
  'examples.scenarioPersonal': 'Personale',
  'examples.searchPlaceholder': 'Cerca esempi…',
  'examples.searchAria': 'Cerca esempi per nome',
  'examples.emptyNoSkills': 'Nessuna competenza disponibile. Il daemon è in esecuzione?',
  'examples.emptyNoMatch': 'Nessun esempio corrisponde a questi filtri.',
  'examples.openPreview': '⤢ Apri anteprima',
  'examples.loadingPreview': 'Caricamento anteprima…',
  'examples.hoverPreview': 'Passa sopra per visualizzare l\'anteprima',
  'examples.usePrompt': 'Usa questo prompt',
  'examples.previewModalTitle': 'Apri anteprima completa (modale)',
  'examples.shareTitle': 'Condividi questo esempio',
  'examples.shareLoadFirst': 'Passa sopra per caricare prima l\'anteprima',
  'examples.unavailablePlaceholder': 'Nessuna anteprima {kind} fornita — apri per saperne di più',
  'examples.shareUnavailable': 'Nessuna anteprima {kind} fornita da condividere',
  'examples.shareMenu': 'Condividi ▾',
  'examples.exportPdfAllSlides': 'Esporta in PDF (tutte le diapositive)',
  'examples.exportPptxLocked': 'Esporta in PPTX… (apri prima il modello)',
  'examples.tagSlideDeck': 'Presentazione',
  'examples.tagTemplate': 'Modello',
  'examples.tagDesignSystem': 'Design system',
  'examples.tagMobilePrototype': 'Prototipo mobile',
  'examples.tagDesktopPrototype': 'Prototipo desktop',
  'examples.tagImage': 'Immagine',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Anteprima',
  'ds.surfaceLabel': 'Superficie',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Immagine',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Cerca design system…',
  'ds.emptyNoMatch': 'Nessun design system corrisponde alla tua ricerca.',
  'ds.badgeDefault': 'PREDEFINITO',
  'ds.preview': 'Anteprima',
  'ds.previewTitle': 'Anteprima del design system',
  'ds.categoryAll': 'Tutto',
  'ds.categoryUncategorized': 'Non categorizzato',
  'ds.showcase': 'Vetrina',
  'ds.tokens': 'Token',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Caricamento di DESIGN.md…',
  'avatar.title': 'Account e impostazioni',
  'avatar.localCli': 'CLI locale',
  'avatar.anthropicApi': 'API Anthropic',
  'avatar.useLocal': 'Usa CLI locale',
  'avatar.useApi': 'Usa API · BYOK',
  'avatar.codeAgent': 'Agente di codice',
  'avatar.rescan': 'Rianalizza il PATH',
  'avatar.amrConsole': 'Account OpenDesign Cloud',
  'avatar.amrConsoleMeta': 'Saldo e ricarica',
  'avatar.settings': 'Impostazioni',
  'avatar.backToProjects': 'Torna ai progetti',
  'avatar.metaActive': 'attivo',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'selezionato',
  'avatar.noAgentSelected': 'nessun agente selezionato',
  'avatar.modelSection': 'Modello',
  'avatar.modelLabel': 'Modello',
  'avatar.reasoningLabel': 'Ragionamento',
  'avatar.serviceTierLabel': 'Livello di servizio',
  'avatar.customSuffix': '(personalizzato)',
  'socialShare.openDesignSection': 'Condividi OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign su GitHub',
  'socialShare.openDesignText': 'OpenDesign è uno spazio di lavoro a codice sorgente disponibile per creare, modificare, distribuire e consegnare artifact di design.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'CONDIVISIONE SOCIAL',
  'socialShare.publishPageTitle': 'Pubblica pagina di condivisione',
  'socialShare.publishPageSubtitle': 'Pubblica questa anteprima per condividerla sulle piattaforme social.',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'Creato con OpenDesign: {title}. Visualizza l\'artifact distribuito e metti una stella al repo: {repo}',
  'socialShare.projectCopyText': 'Creato con OpenDesign: {title}\n{url}\nRepo di OpenDesign: {repo}',
  'socialShare.deployFirst': 'Pubblica e poi condividi…',
  'socialShare.copied': 'Copiato',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Cambia CLI / modello',
  'inlineSwitcher.chipCli': 'CLI locale',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'predefinito',
  'inlineSwitcher.noAgent': 'nessun agent',
  'inlineSwitcher.modeLabel': 'Modalità',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Provider',
  'inlineSwitcher.modelLabel': 'Modello',
  'inlineSwitcher.useCli': 'Usa CLI locale',
  'inlineSwitcher.useByok': 'Usa API key BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon offline — apri le impostazioni',
  'inlineSwitcher.noAgentsDetected': 'Nessuna CLI rilevata nel PATH',
  'inlineSwitcher.openSettingsForModel': 'Configura il provider nelle Impostazioni',
  'inlineSwitcher.missingApiKey': 'API key non impostata — apri le Impostazioni per aggiungerla.',
  'inlineSwitcher.openFullSettings': 'Apri impostazioni di esecuzione',
  'inlineSwitcher.customSuffix': '(personalizzato)',
  'inlineSwitcher.unlimitedBadge': 'Illimitato',
  'project.backToProjects': 'Torna ai progetti',
  'project.brandReadyTitle': 'Il design system {name} è pronto',
  'project.brandReadyTitleGeneric': 'Il tuo design system è pronto',
  'project.brandReadyCta': 'Anteprima in Design system',
  'project.brandReadyDismiss': 'Ignora',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Anteprima del design system aperta.',
  'project.previewCommentSaveFailed': 'Impossibile salvare il commento. Riprova.',
  'project.previewCommentSaveFailedTitle': 'Salvataggio del commento non riuscito',
  'project.previewCommentSaveFailedDescription': 'Questo commento non è stato salvato. Riprova.',
  'project.previewCommentReorderFailed': "Impossibile salvare l'ordine dei commenti: potrebbe essere ripristinato al prossimo caricamento.",
  'project.metaFreeform': 'libero',
  'project.typePrototype': 'Prototipo',
  'project.typeDeck': 'Diapositive',
  'project.typeTemplate': 'Modello',
  'project.typeImage': 'Immagine',
  'project.typeVideo': 'Video',
  'project.typeAudio': 'Audio',
  'project.customInstructions': 'Istruzioni del progetto',
  'project.customInstructionsPlaceholder': 'Istruzioni per questo progetto (inserite in ogni messaggio)…',
  'project.resizeChatPanel': 'Ridimensiona il pannello della chat',
  'project.instructionsActive': 'Attivo — incluso in ogni messaggio',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Commenti',
  'chat.commentsSoon': 'Commenti — presto disponibile',
  'chat.comments.attached': 'Allegato alla chat',
  'chat.comments.emptyAttached': 'Nessun commento allegato.',
  'chat.comments.saved': 'Commenti salvati',
  'chat.comments.emptySaved': 'Nessun commento salvato.',
  'chat.comments.add': 'Aggiungi',
  'chat.comments.addAll': 'Aggiungi tutto',
  'chat.comments.remove': 'Rimuovi',
  'chat.comments.placeholder': 'Commenta questo elemento…',
  'chat.comments.addSend': 'Aggiungi e invia',
  'chat.comments.updateSend': 'Aggiorna e invia',
  'chat.comments.removeAttachment': 'Rimuovi commento allegato',
  'chat.comments.removeAttachmentAria': 'Rimuovi commento allegato per {name}',
  'chat.comments.comment': 'Commento',
  'chat.comments.sendToChat': 'Invia alla chat',
  'chat.comments.viewAll': 'Vedi tutti i commenti',
  'chat.comments.sending': 'Invio…',
  'chat.comments.edit': 'Modifica',
  'chat.comments.select': 'Seleziona',
  'chat.comments.selectAll': 'Seleziona tutto',
  'chat.comments.deselect': 'Deseleziona',
  'chat.comments.nSelected': '{n} selezionati',
  'chat.comments.pin': 'Fissa',
  'chat.comments.addNote': 'Aggiungi nota',
  'chat.comments.savedToast': 'Commento salvato',
  'chat.comments.pinSavedToast': 'Elemento fissato salvato',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} elementi acquisiti',
  'chat.comments.clear': 'Cancella',
  'chat.comments.targetImage': 'Immagine',
  'chat.comments.targetControl': 'Controllo',
  'chat.comments.targetLink': 'Collegamento',
  'chat.comments.targetText': 'Testo',
  'chat.comments.targetSection': 'Sezione',
  'chat.comments.targetPage': 'Pagina',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Aggiungi una nota per questo contrassegno',
  'chat.annotationAttachImage': 'Allega immagine',
  'chat.annotationAttachedImages': 'Immagini allegate',
  'chat.annotationAttachedRemove': 'Rimuovi ultima immagine',
  'chat.annotationAddToInput': 'Aggiungi all\'input',
  'chat.annotationAddingToInput': 'Aggiunta in corso...',
  'chat.annotationQueue': 'Coda',
  'chat.annotationQueueing': 'Accodamento in corso...',
  'chat.annotationSubmitOptions': 'Opzioni di invio',
  'chat.annotationSending': 'Invio in corso...',
  'chat.annotationSendDisabledReason': 'È in esecuzione un\'attività',
  'chat.annotationPreviewMissing': 'Impossibile acquisire l\'anteprima. Riprova.',
  'chat.annotationPreviewMissingInk': 'Impossibile acquisire l\'anteprima. Riprova per evitare di inviare solo l\'inchiostro.',
  'chat.annotationSentWithoutScreenshot': 'Impossibile catturare l\'anteprima. L\'annotazione è stata inviata senza screenshot.',
  'chat.annotationTimeout': 'Invio dell\'annotazione scaduto. Riprova.',
  'chat.annotationFailed': 'Invio dell\'annotazione non riuscito. Riprova.',
  'chat.annotationProjectCreateFailed': 'Impossibile creare un progetto, quindi l\'annotazione non è stata inviata.',
  'chat.annotationUploadFailed': 'Caricamento dell\'allegato non riuscito. Riprova.',
  'chat.attachmentFolderUnsupported': 'Le cartelle non possono essere allegate qui. Allega invece i file al loro interno.',
  'chat.conversationsTitle': 'Conversazioni',
  'chat.conversationsAria': 'Cronologia delle conversazioni',
  'chat.newConversation': 'Nuova conversazione',
  'chat.newSession': 'Nuova conversazione',
  'chat.newConversationsTitle': 'Nuova conversazione',
  'chat.conversationsHeading': 'Conversazioni',
  'chat.emptyConversations': 'Nessuna conversazione per ora.',
  'chat.deleteConversation': 'Elimina conversazione',
  'chat.renameConversationLabel': 'Rinomina "{title}"',
  'chat.deleteConversationConfirm': 'Eliminare « {title} » ? Questo elimina i suoi messaggi.',
  'chat.untitledConversation': 'Conversazione senza titolo',
  'chat.forkConversationFailed': 'Impossibile avviare una nuova conversazione.',
  'chat.startTitle': 'Inizia una conversazione',
  'chat.startHint': 'Descrivi ciò che vuoi generare oppure parti da uno di questi esempi:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.memoryWrittenSummary': '{count} preferenze memorizzate',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "Ottimizzazione AI",
  'brandEnrichment.body': "OpenDesign eseguirà in background un’estrazione più profonda, applicherà automaticamente le skill di design system corrette e aggiornerà questo sistema sul posto. Può richiedere 10-20 minuti; puoi continuare a lavorare.",
  'brandEnrichment.cta': "Ottimizza con AI",
  'brandEnrichment.busy': "Avvio ottimizzazione AI...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md incollato',
  'brandExtractionTranscript.user': 'Estrai un design system da {source}.',
  'brandExtractionTranscript.doneTitle': 'L’estrazione programmatica di {name} è terminata.',
  'brandExtractionTranscript.doneBody': 'Ho creato e registrato il design system {designSystemId} da {source}. Ora è pronto per l’anteprima e può essere usato in nuovi design.',
  'brandExtractionTranscript.next': 'Ora puoi eseguire AI Optimize per un’estrazione più profonda oppure creare un nuovo design con questo sistema.',
  'chat.fillInputTitle': 'Clicca per riempire il campo',
  'chat.jumpToLatest': 'Vai al più recente',
  'chat.scrollToLatest': 'Scorri fino al più recente',
  'chat.messageRail.aria': 'Navigazione dei messaggi utente',
  'chat.messageRail.jumpAria': 'Vai al messaggio utente {index}',
  'chat.messageRail.empty': '(Nessun contenuto)',
  'chat.you': 'Tu',
  'chat.record.retryImage': '{count} illustrazioni non sono state generate: riprova',
  'chat.quote.add': 'Aggiungi alla chat',
  'chat.quote.count': '{count} note',
  'chat.quote.duplicate': 'Già aggiunto alla chat',
  'chat.quote.removeAria': 'Rimuovi note',
  'chat.support.title': 'Contatta il supporto',
  'chat.support.join': 'Unisciti',
  'chat.sendFailedRetryAria': 'Invio non riuscito — riprova',
  'chat.audio.play': 'Riproduci',
  'chat.audio.pause': 'Pausa',
  'chat.audio.download': 'Scarica {name}',
  'chat.upgrade.balance': 'Saldo residuo',
  'chat.upgrade.whyLow': 'Potrebbe non bastare per il prossimo compito: se si esaurisce a metà, resterà incompleto',
  'chat.upgrade.whyOut': 'Ora non puoi avviare un nuovo compito',
  'chat.openFile': 'Apri {name}',
  'chat.copyPrompt': 'Copia prompt',
  'chat.copyErrorDiagnostic': 'Copy error diagnostics',
  'chat.copyDone': 'Copiato!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Descrivi ciò che vuoi generare…',
  'chat.activeFileEditingLabel': 'Modifica',
  'chat.activeFilePlaceholder': 'Chiedi a OpenDesign di modificare {file}...',
  'chat.designArtifactsShowMore': 'Mostra altri {count} file di design',
  'chat.mode.chat.label': 'Chiedi',
  'chat.mode.chat.title': 'Modalità Ask',
  'chat.mode.chat.summary': 'Per risposte rapide, modifiche, pianificazione e discussione senza presumere che vada creato un artefatto di design.',
  'chat.mode.chat.solves': 'Usala per chiarire idee, migliorare prompt, confrontare opzioni o fare domande su un lavoro esistente.',
  'chat.mode.chat.query1': 'Riassumi questa bozza e indica le lacune.',
  'chat.mode.chat.query2': 'Aiutami a scegliere la struttura migliore per questa landing page.',
  'chat.mode.chat.query3': 'Rivedi questo design e suggerisci miglioramenti concreti.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Modalità Design',
  'chat.mode.design.summary': 'Per creare o modificare output concreti: pagine, prototipi, artefatti live, slide, immagini, video, HyperFrames, audio, dashboard e file di progetto.',
  'chat.mode.design.solves': 'Usala quando vuoi che OpenDesign generi file, aggiorni il workspace o trasformi un brief in deliverable multimodali.',
  'chat.mode.design.query1': 'Crea una landing page di lancio prodotto e un prototipo HyperFrames da questo brief.',
  'chat.mode.design.query2': 'Crea un deck investor di 10 slide con note per lo speaker.',
  'chat.mode.design.query3': 'Genera concept immagine, video e audio per questa campagna.',
  'chat.mode.cardBestFor': 'Ideale per',
  'chat.mode.cardTry': 'Prova a chiedere',
  'chat.mode.cardCost': 'Consumo tipico',
  'chat.mode.chat.cost': 'Basso',
  'chat.mode.chat.costNote': 'Solo una conversazione: non viene generato nulla, quindi consuma il minimo.',
  'chat.mode.plan.cost': 'Standard',
  'chat.mode.plan.costNote': 'Crea prima un documento di piano modificabile, poi passa alla generazione.',
  'chat.mode.design.cost': 'Alto',
  'chat.mode.design.costNote': 'Genera file e contenuti multimodali, quindi una sessione può consumare di più.',
  'chat.modePicker.choose': 'Scegli una modalità',
  'chat.modePicker.current': 'Modalità: {name}',
  'chat.modePicker.clear': 'Rimuovi modalità',
  'chat.modePicker.mode': 'Modalità',
  'chat.composerHint': '⌘/Ctrl + Invio per inviare · includi obiettivo, contenuto, stile e formato',
  'chat.cliSettingsTitle': 'Impostazioni CLI e modello',
  'chat.cliSettingsAria': 'Apri impostazioni CLI e modello',
  'chat.attachTitle': 'Allega file (o incolla / trascina)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Allega file',
  'chat.importTitle': 'Importa fonti (presto disponibile)',
  'chat.importLabel': 'Importa',
  'chat.importComingSoon': 'Presto disponibile',
  'chat.importSoon': 'Presto',
  'chat.importFig': 'Carica un file .fig',
  'chat.importGitHub': 'Connetti GitHub',
  'chat.importWeb': 'Cattura un elemento web',
  'chat.importFolder': 'Collega una cartella di codice',
  'chat.importSkills': 'Competenze e design system',
  'chat.importProject': 'Fai riferimento a un altro progetto',
  'chat.importDesignSystemHeader': 'Scegli un design system',
  'chat.importDesignSystemBack': 'Indietro',
  'chat.importDesignSystemSearch': 'Cerca design system…',
  'chat.importDesignSystemEmpty': 'Nessun design system corrisponde a "{query}"',
  'chat.importDesignSystemNone': 'Nessuno — formato libero',
  'chat.importDesignSystemNoneSub': 'Non ancorare a un sistema in questo turno',
  'chat.importDesignSystemActive': 'Attivo',
  'chat.importDesignSystemSwitched': 'Design system cambiato in {title}',
  'chat.importDesignSystemFailed': 'Impossibile cambiare design system. Riprova.',
  'chat.importDesignSystemLoadFailed': 'Impossibile caricare i design system.',
  'browserUse.title': 'Ispirazione',
  'browserUse.summary': '{count} azioni web, dando priorità a estrazione asset, linguaggio di design, motion, controlli visivi e struttura dei componenti.',
  'browserUse.searchAria': 'Cerca ispirazione',
  'browserUse.searchPlaceholder': 'Cerca screenshot, font, colori, a11y...',
  'browserUse.empty': 'Nessuna ispirazione corrispondente',
  'browserUse.unavailable': 'L\'ispirazione non è disponibile qui',
  'browserUse.added': 'Aggiunto al composer',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Interrompi caricamento',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Estrazione asset',
  'browserUse.category.tokens': 'Linguaggio di design',
  'browserUse.category.motion': 'Animazione',
  'browserUse.category.visual': 'Controlli visivi',
  'browserUse.category.structure': 'Componenti',
  'browserUse.category.project': 'Esecuzione progetto',
  'browserUse.category.general': 'Generale',
  'browserUse.input.none': 'Nessun input',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selettore opzionale',
  'browserUse.input.requirementSelector': 'Requisito, selettore opzionale',
  'browserUse.input.selectorOptional': 'Selettore opzionale',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selettore, scale=2',
  'browserUse.input.gridOverlay': '12 colonne, max 1200, gap 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, dominio o termini di ricerca',
  'browserUse.input.selector': 'Selettore',
  'browserUse.input.selectorText': 'Selettore e testo',
  'browserUse.input.scroll': 'Pixel, alto, basso o pagina',
  'browserUse.input.terminalRun': 'Comando, timeout 120s',
  'browserUse.input.command': 'Comando',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Migliori candidati per il logo da header, nav, nomi di classe, posizione, immagine OG e fallback sul favicon.',
  'browserUse.action.list_images.output': 'Tutte le immagini img, srcset, source e di sfondo CSS con dimensioni e testo alt.',
  'browserUse.action.download_assets.output': 'Cartella degli asset scaricati più _manifest.json con supporto per referer e cookie.',
  'browserUse.action.extract_svgs.output': 'SVG inline e file .svg collegati salvati come singoli file SVG.',
  'browserUse.action.optimize_svgs.output': 'File SVG ottimizzati più rapporto di compressione.',
  'browserUse.action.extract_colors.output': 'Palette ponderata più variabili colore CSS :root come palette.json e palette.html.',
  'browserUse.action.extract_fonts.output': 'Principali famiglie di font, dimensioni, pesi e regole @font-face come typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Raggio, ombra, spaziatura e variabili CSS come tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Scala tipografica per titoli, corpo e pulsanti con dimensione, peso, line-height e rapporti.',
  'browserUse.action.extract_buttons.output': 'Libreria di stili dei pulsanti deduplicata come buttons.html e buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Container grid e flex, direzione, gap, colonne e larghezze massime come layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoint responsive delle media query come breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Gradienti CSS come gradients.css, gradients.json e HTML di anteprima.',
  'browserUse.action.extract_shadows.output': 'Box shadow, text shadow e drop shadow come shadows.json più anteprima.',
  'browserUse.action.extract_easings.output': 'Funzioni di easing per transizioni e animazioni come easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js e style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, regole di transizione e transform, librerie di motion rilevate, motion.css e motion.json.',
  'browserUse.action.validate_view.output': 'Percorsi degli screenshot più problemi visivi e di layout strutturati.',
  'browserUse.action.audit_layout.output': 'Difetti di layout tra cui overflow, limiti, sovrapposizioni e testo troncato come audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problemi di a11y con selettori, etichette, ruoli, focus, contrasto e screenshot dove utile.',
  'browserUse.action.responsive_screenshots.output': 'Screenshot per mobile 390, tablet 834 e desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Screenshot dell\'intera pagina oltre il viewport.',
  'browserUse.action.screenshot_element.output': 'Screenshot di un singolo elemento a 2x per impostazione predefinita.',
  'browserUse.action.screenshot_with_grid.output': 'Screenshot con sovrapposizione della griglia di layout.',
  'browserUse.action.screenshot_dark_mode.output': 'Screenshot con prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guida di stile di una pagina con colori, scala tipografica, raggio e ombre.',
  'browserUse.action.extract_html.output': 'HTML pulito e autonomo, senza script, noscript o attributi di eventi inline.',
  'browserUse.action.extract_component_inventory.output': 'Pattern di componenti ricorrenti, selettori, conteggi e screenshot.',
  'browserUse.action.extract_copy.output': 'Titoli, CTA, testo del corpo e descrizioni come copy.md e copy.json.',
  'browserUse.action.extract_nav.output': 'Navigazione principale e link del footer come sitemap.md e nav.json.',
  'browserUse.action.extract_forms.output': 'Campi del modulo, etichette, suggerimenti di convalida e azioni di invio come forms.json.',
  'browserUse.action.run_project.output': 'URL del server di sviluppo rilevato aperto nella scheda Browser.',
  'browserUse.action.detect_project.output': 'Framework, package manager, comando di installazione, comando di sviluppo e porta.',
  'browserUse.action.page_info.output': 'URL, titolo, descrizione, immagine OG, colore del tema, favicon e viewport.',
  'browserUse.action.snapshot.output': 'Fino a 120 elementi interattivi e di testo visibili con tag, etichetta, href e coordinate.',
  'browserUse.action.navigate.output': 'Apri la pagina e restituisci page_info.',
  'browserUse.action.click.output': 'Clicca sul primo elemento corrispondente dopo averlo portato in vista con lo scorrimento.',
  'browserUse.action.type_text.output': 'Compila un campo di input e invia gli eventi input e change.',
  'browserUse.action.scroll.output': 'Posizione di scorrimento attuale e massima.',
  'browserUse.action.extract_og_metadata.output': 'Titolo meta, descrizione, URL canonico, card OG/Twitter, immagine social e colore del tema.',
  'browserUse.action.terminal_run.output': 'stdout, stderr e codice di uscita.',
  'browserUse.action.terminal_run_background.output': 'ID dell\'attività in background e output recente.',
  'browserUse.action.terminal_read.output': 'Output recente del terminale condiviso.',
  'chat.designToolbox.title': 'Strumenti di design',
  'chat.designToolbox.tooltip': 'Strumenti di design',
  'chat.designToolbox.aria': 'Apri strumenti di design',
  'chat.designToolbox.searchPlaceholder': 'Cerca skill / MCP / plugin / connettori / file di design...',
  'chat.designToolbox.searchAria': 'Cerca risorse degli strumenti di design',
  'chat.designToolbox.followupSection': 'Domanda di approfondimento',
  'chat.designToolbox.resourcesSection': 'Risorse globali',
  'chat.designToolbox.selected': 'Selezionato',
  'chat.designToolbox.noResources': 'Nessuna risorsa trovata per "{query}".',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Immagine',
  'chat.designToolbox.badge.motion': 'Animazione',
  'chat.designToolbox.badge.polish': 'Rifinitura',
  'chat.designToolbox.action.auto-match.title': 'Abbina al passaggio successivo',
  'chat.designToolbox.action.auto-match.badge': 'Abbina',
  'chat.designToolbox.action.auto-match.description': 'Definisci prima il livello di gusto, poi abbina skill, MCP, plugin, connettori e file.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Aggiungi animazione / movimento',
  'chat.designToolbox.action.motion.badge': 'Animazione',
  'chat.designToolbox.action.motion.description': 'Aggiungi movimenti di entrata, di scorrimento, di transizione di stato e micro-interazioni all\'HTML o all\'elemento di pagina attuale.',
  'chat.designToolbox.action.motion-polish.title': 'Rifinisci l\'animazione',
  'chat.designToolbox.action.motion-polish.badge': 'Tempistica',
  'chat.designToolbox.action.motion-polish.description': 'Esamina tempistica, easing, prestazioni e fallback per il movimento ridotto delle animazioni esistenti.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Rimuovi l\'aspetto da AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Gusto',
  'chat.designToolbox.action.anti-ai-polish.description': 'Rimuovi l\'aspetto da template, i gradienti da AI, le pile di card scadenti e i testi vaghi.',
  'chat.designToolbox.action.visual-polish.title': 'Rifinitura del design / pronto per la pubblicazione',
  'chat.designToolbox.action.visual-polish.badge': 'Rifinitura',
  'chat.designToolbox.action.visual-polish.description': 'Valuta gerarchia visiva, tipografia, spaziatura, comportamento responsive, accessibilità e qualità della consegna.',
  'chat.designToolbox.action.image-gen.title': 'Genera immagini / riferimenti visivi',
  'chat.designToolbox.action.image-gen.badge': 'Immagine',
  'chat.designToolbox.action.image-gen.description': 'Genera riferimenti di sezione, asset, icone, immagini social o una moodboard per la pagina attuale.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Genera video / script di animazione',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Trasforma il design in un breve video, uno storyboard Remotion / Hyperframes o un prompt pronto per la generazione.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Template MCP',
  'chat.designToolbox.kind.connector': 'Connettore',
  'chat.designToolbox.kind.designFile': 'File di design',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'File di design',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Cartella',
  'chat.designToolbox.context.terminal': 'Terminale',
  'chat.designToolbox.context.sideChat': 'Chat laterale',
  'chat.designToolbox.context.liveArtifact': 'Artefatto live',
  'chat.designToolbox.context.file': 'File',
  'chat.designToolbox.prompt.contextGeneric': 'Target corrente: il file HTML / file di design / elemento web attualmente aperto.',
  'chat.designToolbox.prompt.contextSpecific': 'Destinazione attuale: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Mantieni l\'intento già presente nel composer: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill selezionata: {skill}. Usala come flusso di lavoro principale per questo turno.',
  'chat.designToolbox.prompt.noSkill': 'Se nessuna skill specifica corrisponde, scegli prima la combinazione migliore tra skill, MCP, plugin, connettori e file di design disponibili.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Agisci come orchestratore Creative Director e completa un flusso di lavoro di design:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Definisci innanzitutto cosa significa “design accattivante”: pubblico, obiettivo di business, percezione del brand, riferimenti di stile, densità delle informazioni, standard di colore/tipografia/animazione/asset e pattern AI/template da evitare.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Cerca e abbina l\'intero indice di risorse qui sopra. Non usare solo i consigli del toolbox di design; combina skill, MCP, plugin, connettori e file di design quando è utile.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Completa il flusso in questo ordine: diagnosi -> direzione stilistica -> selezione delle risorse -> modifica/generazione concreta -> verifica. A ogni passaggio, spiega perché sono state scelte queste risorse e cosa serve confermare in seguito.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Rivedi e perfeziona timing, easing, prestazioni e accessibilità del movimento esistente. Rimuovi animazioni brusche, scadenti o che danneggiano la leggibilità; usa una timeline più raffinata quando serve.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Esegui un passaggio di rifinitura anti-effetto-AI: rimuovi layout da template, gradienti/bagliori scadenti, pile di card prive di senso e testi vaghi. Conserva le informazioni e fai in modo che sembri il lavoro di un vero designer.',
  'chat.designToolbox.prompt.visualPolish': 'Rifinisci questo design finché non è pronto per la pubblicazione: controlla gerarchia, tipografia, spaziatura, comportamento responsive, stati dei pulsanti, stati vuoto/caricamento/errore e accessibilità; correggi direttamente i problemi più importanti.',
  'chat.designToolbox.prompt.imageGen': 'Crea il prossimo piano di asset visivi per questo design: riferimenti per le sezioni, asset hero, illustrazioni, icone, immagini social o un moodboard. Decidi prima quale tipo di immagine manca, poi fornisci prompt di generazione eseguibili / piano dei file.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Orienta questo design verso il video: crea uno storyboard per un video breve, una struttura di frame Hyperframes / Remotion o un prompt pronto per Sora/fal. Preferisci far diventare naturalmente il contenuto HTML / della pagina esistente delle inquadrature.',
  'chat.designToolbox.prompt.useSkill': 'Usa {skill} sul design corrente.',
  'chat.designToolbox.prompt.skillInstruction': 'Decidi prima l\'obiettivo di follow-up migliore, poi completa un passaggio concreto. Se dipende da asset o API esterne, fornisci un fallback eseguibile o indica cosa devo fornire.',
  'chat.designToolbox.prompt.selectedResource': 'Risorsa selezionata: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Descrizione della risorsa: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Usa questo plugin come contesto principale per il flusso di design corrente. Se espone input o GenUI, guidami nella scelta quando serve; se non si adatta al target, scegli una risorsa globale migliore e spiega perché.',
  'chat.designToolbox.prompt.mcpResource': 'Preferisci questa capacità MCP per il prossimo passaggio di design. Quando servono asset esterni, acquisizione web, generazione di immagini/video o dati, decidi prima se può svolgere il compito, poi fornisci un piano eseguibile.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Questo MCP è un template configurabile. Se è lo strumento più utile per questo passaggio di design, guida prima la configurazione; se esiste un\'alternativa già configurata, continua con quell\'alternativa.',
  'chat.designToolbox.prompt.connectorResource': 'Usa questo connettore quando servono dati reali, asset, contenuti dell\'account o accesso a flussi di lavoro esterni. Prima di usarlo, spiega cosa verrà letto o scritto e chiedi conferma quando opportuno.',
  'chat.designToolbox.prompt.fileResource': 'Usa questo file di design come target di design corrente o asset di riferimento e completa il passaggio successivo a partire da esso. Se servono altri file per il confronto, continua a cercare tra tutti i file di design.',
  'chat.designToolbox.prompt.resourceIndex': 'Indice globale delle risorse: skill({skills}), plugin({plugins}), MCP({mcpEnabled} abilitati / {mcpTemplates} template), connettori({connectors} connessi), file di design({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skill ricercabili',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugin ricercabili',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponibili',
  'chat.designToolbox.prompt.connectedConnectors': 'Connettori connessi',
  'chat.designToolbox.prompt.referenceDesignFiles': 'File di design di riferimento',
  'chat.designToolbox.prompt.mcpTemplateName': 'Template {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} altri',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Superfici di menzione',
  'chat.mentionTabAll': 'Tutti',
  'chat.mentionTabTabs': 'Schede',
  'chat.mentionTabPlugins': 'Plugin',
  'chat.mentionTabSkills': 'Skill',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connettori',
  'chat.mentionTabFiles': 'File di design',
  'chat.mentionNoResults': 'Nessun risultato per “{query}”.',
  'chat.mentionSearchPrompt': 'Cerca tra file di design, schede, plugin, skill, server MCP e connettori.',
  'chat.mentionSectionTabs': 'Schede',
  'chat.mentionSectionPlugins': 'Plugin',
  'chat.mentionSectionSkills': 'Skill',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connettori',
  'chat.mentionSectionFiles': 'File di design',
  'chat.mentionActiveSkill': 'Attivo',
  'chat.mentionUseMcpTitle': 'Usa {name}',
  'chat.mentionUseConnectorTitle': 'Usa {name}',
  'chat.mentionPluginOfficial': 'Ufficiale',
  'chat.mentionPluginMine': 'Il mio plugin',
  'chat.linkedFolderRemoveAria': 'Rimuovi cartella collegata {path}',
  'chat.linkedFolderNotFound': 'La cartella non esiste',
  'chat.linkedFolderAlready': 'Questa cartella è già collegata',
  'chat.linkedFolderPickError': 'Impossibile aprire il selettore di cartelle',
  'chat.queuedEditQueuedTaskAria': 'Modifica attività in coda',
  'chat.queuedSave': 'Salva',
  'chat.queuedCancel': 'Annulla',
  'chat.queuedReorder': 'Trascina per riordinare',
  'chat.queuedEdit': 'Modifica',
  'chat.queuedHeader': 'In coda',
  'chat.queuedSteer': 'Guida questo turno',
  'chat.queuedSteerInterrupts': 'Guida questo turno — interrompe l’esecuzione in corso',
  'chat.queuedSteerUnsupported': 'Questo agente non può ricevere messaggi a metà turno',
  'chat.queuedSteerClosed': 'Questo turno ha smesso di leggere i messaggi',
  'chat.queuedSteerFailed': 'Impossibile guidare il turno',
  'chat.queuedSteerTextOnly': 'In un turno in corso entra solo testo: invia questo con i suoi allegati a parte',
  'chat.queuedFollowUpFallback': 'Follow-up in coda',
  'chat.send': 'Invia',
  'chat.stop': 'Ferma',
  'chat.removeAria': 'Rimuovi {name}',
  'chat.example1Title': 'Pitch deck editoriale',
  'chat.example1Tag': 'Rivista',
  'chat.example1Prompt': 'Un pitch deck editoriale di 10 diapositive per uno studio di design che raccoglie fondi — layout a griglia svizzera, titoli con serif sovradimensionati e capolettera, numeri di sezione in monospace, generosi spazi negativi e diapositive fotografiche a pagina intera intervallate da diapositive ricche di testo. Copertina, visione, mercato, prodotto, trazione, team, raccolta fondi, contatto.',
  'chat.example2Title': 'Dashboard SaaS analytics',
  'chat.example2Tag': 'Dati',
  'chat.example2Prompt': 'Una dashboard analytics densa per un SaaS di strumenti per sviluppatori — banner KPI con delta settimana su settimana, due grafici a linee sovrapposte (MRR e spazi di lavoro attivi), una mappa di calore mondiale dell\'utilizzo, una griglia di retention di coorte, una classifica dei migliori clienti e un feed di notizie in tempo reale. Tema scuro, numeri tabulari in monospace, accenti sparkline.',
  'chat.example3Title': 'Report annuale a scorrimento lungo',
  'chat.example3Tag': 'Editoriale',
  'chat.example3Prompt': 'Un report annuale interattivo per un\'ONG climatica — layout editoriale a scorrimento lungo che mescola grandi blocchi di citazioni, visualizzazioni di dati (barre sovrapposte, contatori animati, una mappa coropletica dei siti di progetto), separatori fotografici, un muro di donatori e una chiamata all\'azione finale. Testo in serif moderno, etichette di grafici in sans-serif, palette di carta dai toni terrosi.',
  'home.recommendation.eyebrow': 'Consigliato per te',
  'home.recommendation.primaryCta': 'Inizia a creare',
  'home.recommendation.change': 'Prova un altro',
  'home.recommendation.browseAll': 'Tutti i tipi',
  'home.recommendation.defaultProjectName': 'Nuovo progetto',
  'home.recommendation.startFailed': 'Impossibile avviare la creazione. Riprova.',
  'studio.firstArtifactHint.title': 'Il tuo primo design è pronto',
  'studio.firstArtifactHint.body': 'Prova a modificarlo e annotarlo direttamente: esporta o condividi quando sei soddisfatto.',
  'studio.firstArtifactHint.dismiss': 'Ho capito',
  'home.starter.product_ui_prototype.title': 'Inizia con un prototipo di prodotto modificabile',
  'home.starter.product_ui_prototype.desc': 'In base al tuo obiettivo, parti da un\'interfaccia cliccabile che puoi perfezionare.',
  'home.starter.product_ui_prototype.firstPrompt': 'Progetta un prototipo di prodotto modificabile per [il tuo prodotto] con le schermate chiave e un flusso principale chiaro.',
  'home.starter.product_ui_component.title': 'Inizia da un componente riutilizzabile',
  'home.starter.product_ui_component.desc': 'Costruisci prima un componente, poi assemblalo in schermate complete.',
  'home.starter.product_ui_component.firstPrompt': 'Progetta un componente riutilizzabile [nome del componente] con i suoi stati principali e le varianti.',
  'home.starter.product_ui_lowfi.title': 'Inizia con un prototipo a bassa fedeltà',
  'home.starter.product_ui_lowfi.desc': 'Abbozza prima la struttura, poi aumenta la fedeltà.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Crea un wireframe a bassa fedeltà delle schermate principali per [il tuo prodotto].',
  'home.starter.marketing_landing.title': 'Inizia con una landing page',
  'home.starter.marketing_landing.desc': 'Trasforma la tua campagna in una landing page pronta da pubblicare.',
  'home.starter.marketing_landing.firstPrompt': 'Progetta una landing page per [il tuo prodotto] con un hero, i vantaggi chiave e una chiara chiamata all\'azione.',
  'home.starter.marketing_multivariant.title': 'Inizia con più varianti di landing page',
  'home.starter.marketing_multivariant.desc': 'Genera alcune versioni da confrontare prima di decidere.',
  'home.starter.marketing_multivariant.firstPrompt': 'Crea 3 varianti di landing page per [il tuo prodotto] con messaggi hero diversi da confrontare.',
  'home.starter.internal_dashboard.title': 'Inizia con una dashboard interna',
  'home.starter.internal_dashboard.desc': 'Parti da un layout di dashboard per il tuo workflow.',
  'home.starter.internal_dashboard.firstPrompt': 'Progetta una dashboard interna che mostra [metriche chiave] con filtri e una tabella dati.',
  'home.starter.internal_report.title': 'Inizia con un report',
  'home.starter.internal_report.desc': 'Descrivi i dati e i campi che vuoi vedere.',
  'home.starter.internal_report.firstPrompt': 'Crea una pagina di report che riepiloga [descrivi i dati, i campi e le metriche che ti interessano].',
  'home.starter.general_menu.title': 'Inizia con il tuo primo progetto',
  'home.starter.general_menu.desc': 'Descrivi ciò che vuoi e genereremo una prima versione modificabile.',
  'home.starter.general_menu.firstPrompt': 'Crea una prima versione modificabile di [descrivi ciò che vuoi realizzare].',
  'chat.example4Title': 'Video motion prodotto',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Crea uno storyboard di video motion da 15 secondi per il lancio di una app di produttività: hook iniziale, close-up della UI, tipografia cinetica, transizioni delle funzioni, chiusura con logo e CTA. Includi timing, scene, camera move e testi in sovrimpressione.',
  'preview.usePlugin': 'Usa plugin',
  'preview.usePluginOnly': 'Usa senza prompt',
  'preview.usePluginOnlyDesc': 'Usa la struttura del plugin senza caricare il prompt di esempio',
  'preview.replicateContent': 'Usa',
  'preview.replicateContentDesc': 'Usa il prompt di esempio per ricreare la preview',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remixa questo esempio in un nuovo progetto modificabile',
  'preview.shareMenu': 'Condividi',
  'preview.exportMenu': 'Esporta',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copia link del template',
  'preview.copyShareText': 'Copia testo da condividere',
  'preview.shareSocialGroup': 'Condividi sui social',
  'preview.shareCopyGroup': 'Copia',
  'preview.shareExportGroup': 'Esporta file',
  'preview.shareCopied': 'Copiato',
  'preview.shareCopyFailed': 'Copia non riuscita',
  'preview.shareTextDefault': 'Template OpenDesign: {title}',
  'preview.openInNewTab': 'Apri in una nuova scheda',
  'preview.exit': '⤓ Esci',
  'preview.fullscreen': '⤢ Schermo intero',
  'preview.closeTitle': 'Chiudi (Esc)',
  'preview.loading': 'Caricamento di {label}…',
  'preview.errorTitle': 'Impossibile caricare questo esempio.',
  'preview.errorBody': 'Il caricamento dell\'HTML dell\'esempio è fallito. Verifica che OpenDesign sia in esecuzione e riprova.',
  'preview.retry': 'Riprova',
  'preview.unavailableTitle': 'Nessuna anteprima fornita per {noun}.',
  'preview.unavailableBody': 'Esegui il prompt nella chat per generare un risultato {kind}.',
  'preview.nounSkill': 'questa competenza',
  'preview.nounPlugin': 'questo plugin',
  'preview.nounTemplate': 'questo modello',
  'preview.showSidebar': 'Mostra {label}',
  'preview.hideSidebar': 'Nascondi {label}',
  'misc.savedTemplate': 'Modello salvato',
  'misc.primary': 'Primario',
  'misc.designSystem': 'Design system',
  'workspace.designFiles': 'File di design',
  'workspace.focusMode': 'Spazio di lavoro focus',
  'workspace.showChat': 'Mostra chat',
  'workspace.closeTab': 'Chiudi scheda',
  'workspace.fileSyncDownloading': 'Download dal team in corso…',
  'workspace.fileSyncUploading': 'Sincronizzazione con il team…',
  'workspace.deleteFileConfirm': 'Eliminare « {name} » dalla cartella del progetto?',
  'workspace.readonlyNotice': 'Questo è un progetto condiviso: puoi visualizzarlo e commentarlo, ma non modificare gli artefatti tramite Chat o gli strumenti di modifica.',
  'workspace.readonlyNoticeBy': 'Questo è un progetto condiviso creato da {owner}: puoi visualizzarlo e commentarlo, ma non modificare gli artefatti tramite Chat o gli strumenti di modifica.',
  'workspace.deleteSelectedFilesConfirm': 'Eliminare i {n} file selezionati dalla cartella del progetto?',
  'workspace.deleteSelectedFilesPartial': 'Impossibile eliminare {n} file.',
  'workspace.openFromDesignFiles': 'Apri un file da',
  'workspace.designFilesLink': 'File di design',
  'workspace.loadingSketch': 'Caricamento dello schizzo…',
  'workspace.newTab': 'Nuova scheda',
  'workspace.searchFilesPlaceholder': 'Cerca file…',
  'workspace.openTabs': 'Schede aperte',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Apri un file',
  'workspace.noFilesMatch': 'Nessun file corrispondente',
  'workspace.allFiles': 'Tutti',
  'workspace.createNew': 'Crea nuovo',
  'workspace.tabOpen': 'Aperto',
  'workspace.sideChatContextBanner': 'Contesto integrato dalla conversazione corrente',
  'workspace.sideChatDefaultTitle': 'Chat laterale',
  'workspace.newTerminal': 'Nuovo terminale',
  'workspace.newTerminalDescription': 'Apri una shell nella cartella del progetto in una nuova scheda',
  'workspace.newBrowser': 'Nuovo browser',
  'workspace.newBrowserDescription': 'Apri una scheda browser integrata per siti di riferimento e attività',
  'workspace.newSketchDescription': 'Disegna layout e note rapide come contesto di design per l’agente',
  'workspace.terminalStarting': 'Avvio del terminale…',
  'workspace.terminalStartingDescription': 'Preparazione della shell del progetto. Di solito richiede pochi secondi.',
  'workspace.terminalSessionEnded': 'Sessione terminata',
  'workspace.terminalReconnecting': 'Riconnessione…',
  'workspace.terminalStartFailed': 'Impossibile avviare la sessione del terminale',
  'workspace.terminalRestart': 'Riavvia',
  'designFiles.title': 'File di design',
  'designFiles.upload': 'Carica file',
  'designFiles.pasteText': 'Incolla come file di testo',
  'designFiles.newSketch': 'Nuovo schizzo',
  'designFiles.newDocument': 'Nuovo documento',
  'designFiles.newDocumentTitle': 'Crea un nuovo documento Markdown',
  'designFiles.empty': 'Le creazioni appariranno qui',
  'designFiles.buildingPreview': 'Anteprima intera',
  'designFiles.syncing': 'Sincronizzazione dei file condivisi dal team…',
  'designFiles.refresh': 'Aggiorna',
  'designFiles.delete': 'Elimina',
  'designFiles.searchPlaceholder': 'Cerca file…',
  'designFiles.up': 'Su',
  'designFiles.back': 'Indietro',
  'designFiles.crumbs': 'progetto',
  'designFiles.rowMenu': 'Menu di riga',
  'designFiles.openInTab': 'Apri in una scheda',
  'designFiles.download': 'Scarica',
  'designFiles.downloadSelected': 'Scarica {n} selezionati in ZIP',
  'designFiles.deleteSelected': 'Elimina {n}',
  'designFiles.clearSelection': 'Cancella selezione',
  'designFiles.selectPage': 'Seleziona tutto nella pagina',
  'designFiles.selectAll': 'Seleziona tutto',
  'designFiles.dropTitle': '⤓ Trascina i file qui',
  'designFiles.dropDesc': 'Immagini, documenti, riferimenti o cartelle — l\'agente li userà come contesto.',
  'designFiles.dropLabel': 'Trascina i file qui',
  'designFiles.upload.title': 'Carica file',
  'designFiles.paste.title': "Incolla testo come file",
  'designFiles.upload.label': 'Carica',
  'designFiles.paste.label': "Incolla",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Apri',
  'designFiles.previewClose': 'Chiudi anteprima',
  'designFiles.modified': 'Modificato {time} · {size}',
  'designFiles.weeksAgo': '{n} sett fa',
  'designFiles.groupBy': 'Raggruppa per',
  'designFiles.groupByKind': 'Tipo',
  'designFiles.groupByModified': 'Modifica',
  'designFiles.filterBy': 'Filtra per tipo',
  'designFiles.filterClear': 'Cancella',
  'designFiles.filterCount': '{n} tipi',
  'designFiles.expandGroup': 'Espandi',
  'designFiles.collapseGroup': 'Riduci',
  'designFiles.sectionPages': 'Pagine',
  'designFiles.sectionScripts': 'Script',
  'designFiles.sectionImages': 'Immagini',
  'designFiles.sectionSketches': 'Schizzi',
  'designFiles.sectionLiveArtifacts': 'Artifact live',
  'designFiles.sectionOther': 'Altro',
  'designFiles.modifiedToday': 'Oggi',
  'designFiles.modifiedYesterday': 'Ieri',
  'designFiles.modifiedPrevious7Days': 'Ultimi 7 giorni',
  'designFiles.modifiedPrevious30Days': 'Ultimi 30 giorni',
  'designFiles.modifiedOlder': 'Più vecchio',
  'designFiles.showMore': 'Mostra +{n} in più',
  'designFiles.kindHtml': 'Pagina HTML',
  'designFiles.kindImage': 'Immagine',
  'designFiles.kindSketch': 'Schizzo',
  'designFiles.kindText': 'Testo',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Documento',
  'designFiles.kindPresentation': 'Presentazione',
  'designFiles.kindSpreadsheet': 'Foglio di calcolo',
  'designFiles.kindLiveArtifact': 'Artifact live',
  'designFiles.kindBinary': 'Binario',
  'designFiles.kindFolder': 'Cartella',
  'designFiles.folderCount': '{n} file',
  'designFiles.newFolderTitle': 'Nuova cartella',
  'designFiles.newFolderLabel': 'Nome cartella',
  'designFiles.moveTitle': 'Sposta nella cartella',
  'designFiles.moveLabel': 'Cartella di destinazione',
  'designFiles.moveRoot': 'Radice del progetto',
  'designFiles.moveNewFolder': 'Nuova cartella…',
  'designFiles.move': 'Sposta',
  'designFiles.copyPath': 'Copia percorso',
  'designFiles.copiedPath': 'Percorso copiato',
  'designFiles.copyLocalPath': 'Copia percorso file locale',
  'designFiles.copiedLocalPath': 'Percorso file locale copiato',
  'designFiles.deleteFolderConfirm': 'Eliminare la cartella "{name}" e tutto il suo contenuto?',
  'designFiles.folderCreated': 'Cartella "{name}" creata',
  'designFiles.folderDeleted': 'Cartella "{name}" eliminata',
  'designFiles.filesMoved': '{n} spostati in {dest}',
  'designFiles.colName': 'Nome',
  'designFiles.colKind': 'Tipo',
  'designFiles.colModified': 'Modificato il',
  'designFiles.perPage': 'Mostra',
  'designFiles.all': 'Tutto',
  'designFiles.prev': 'Precedente',
  'designFiles.next': 'Successivo',
  'designFiles.jumpToPage': 'Vai alla pagina',
  'designFiles.pageInfo': '{start}–{end} su {total}',
  'designFiles.sectionFolders': 'Cartelle',
  'designFiles.sectionStylesheets': 'Fogli di stile',
  'designFiles.sectionDocuments': 'Documenti',
  'designFiles.kindStylesheet': 'Foglio di stile',
  'designFiles.modifiedExt': 'Modificato {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Informazioni utili',
  'designFiles.usefulInfoTip': 'Fai doppio clic su un file per aprirlo in una scheda completa.',
  'designFiles.usefulInfoTip2': 'Digita @ nella chat per usare un file come contesto.',
  'designFiles.usefulInfoTip4': 'Scegli un design system per risultati coerenti con il brand.',
  'designFiles.usefulInfoTip5': 'Senza idee? Prova un template plugin nella Community in Home.',
  'designFiles.usefulInfoTip6': 'Domande o suggerimenti? Unisciti al nostro Discord.',
  'designFiles.usefulInfoTip7': 'Ti piace OpenDesign? Lascia una stella su GitHub.',
  'designFiles.usefulInfoTip8': 'Segui @OpenDesignHQ su X per le ultime novità.',
  'designFiles.usefulInfoTip9': 'Trascina immagini, documenti o intere cartelle in questo pannello — l’agente li userà come contesto.',
  'designFiles.usefulInfoTip10': 'Clicca su «Nuovo schizzo», disegna un layout e lascia che l’agente lo generi.',
  'designFiles.usefulInfoTip11': 'Seleziona un elemento nell’anteprima per commentarlo — l’agente farà modifiche mirate.',
  'designFiles.usefulInfoTip12': 'Risultato non convincente? Cerchiarlo è più veloce che descriverlo di nuovo.',
  'designFiles.usefulInfoTip13': 'Esporta ogni design come PDF, immagine o HTML autonomo con un clic.',
  'designFiles.usefulInfoTip14': 'Soddisfatto di un progetto? Salvalo come template dal menu Condividi.',
  'designFiles.usefulInfoTip15': 'Dopo il deploy puoi generare subito le card per i social.',
  'designFiles.usefulInfoTip16': 'Segui @opendesign.ai su Threads per gli aggiornamenti dietro le quinte.',
  'designFiles.usefulInfoTip17': 'Segui @opendesign.ai su Instagram per ispirazione di design.',
  'designFiles.usefulInfoTip18': 'Iscriviti a OpenDesign su YouTube per tutorial e demo.',
  'designFiles.usefulInfoTip19': 'Segui OpenDesign su LinkedIn per le novità sul prodotto.',
  'designFiles.usefulInfoTip20': 'Segui OpenDesign su Xiaohongshu per consigli e ispirazione.',
  'quickSwitcher.placeholder': 'Apri un file…',
  'quickSwitcher.empty': 'Nessun file in questo progetto',
  'quickSwitcher.noMatches': 'Nessun risultato',
  'quickSwitcher.navigate': 'naviga',
  'quickSwitcher.open': 'apri',
  'quickSwitcher.close': 'chiudi',
  'sketch.save': 'Salva schizzo',
  'sketch.cancel': 'Annulla',
  'sketch.saving': 'Salvataggio…',
  'sketch.saved': 'Salvato',
  'sketch.tooltipMainMenu': 'Menu principale: salva, esporta, aiuto e impostazioni della tela',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Modifiche non salvate',
  'sketch.tooltipClean': 'Salvato',
  'fileViewer.empty': 'Seleziona un file da visualizzare.',
  'fileViewer.loading': 'Caricamento…',
  'fileViewer.exportPptx': 'Esporta in PPTX',
  'fileViewer.openInNewTab': 'Apri in una nuova scheda',
  'fileViewer.copyPath': 'Copia percorso',
  'fileViewer.copied': 'Copiato!',
  'fileViewer.share': 'Condividi',
  'fileViewer.binaryMeta': 'Binario · {size}',
  'fileViewer.binaryNote': 'File binario ({size} byte). Scarica o apri dal disco per ispezionare.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Documento',
  'fileViewer.presentationMeta': 'Presentazione',
  'fileViewer.spreadsheetMeta': 'Foglio di calcolo',
  'fileViewer.previewUnavailable': 'Anteprima non disponibile. Scarica o apri il file per ispezionare.',
  'fileViewer.download': 'Scarica',
  'fileViewer.open': 'Apri',
  'fileViewer.imageMeta': 'Immagine · {size}',
  'fileViewer.reactMeta': 'Componente React · {size}',
  'fileViewer.sketchMeta': 'Schizzo · {size}',
  'fileViewer.markdownStreamingMeta': 'Anteprima in streaming…',
  'fileViewer.markdownErrorMeta': 'L\'anteprima potrebbe essere incompleta (errore di generazione).',
  'fileViewer.markdownStreamingStatus': 'Streaming… visualizzazione del markdown parziale.',
  'fileViewer.markdownErrorStatus': 'Errore di generazione. Visualizzazione dell\'ultimo contenuto disponibile.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Ricarica',
  'fileViewer.reloadDisk': 'Ricarica dal disco',
  'fileViewer.copy': 'Copia',
  'fileViewer.copyTitle': 'Copia contenuto del file',
  'fileViewer.saveDisabled': 'Salva (visualizzatore in sola lettura)',
  'fileViewer.save': 'Salva',
  'fileViewer.preview': 'Anteprima',
  'fileViewer.source': 'Sorgente',
  'fileViewer.tweaks': 'Modifiche',
  'fileViewer.tweaksUnavailable': 'Nessun pannello di modifiche in questo artefatto',
  'fileViewer.jsxModuleTitle': 'Nessuna anteprima autonoma',
  'fileViewer.jsxModuleBody': 'Questo file è un modulo componente caricato da un’altra pagina.',
  'fileViewer.jsxModuleCta': 'Apri la pagina che lo visualizza:',
  'fileViewer.comment': 'Commenta',
  'fileViewer.edit': 'Modifica',
  'fileViewer.draw': 'Disegna',
  'fileViewer.mark': 'Contrassegna',
  'fileViewer.markTool': 'Strumento contrassegno',
  'fileViewer.boxSelect': 'Selezione a riquadro',
  'fileViewer.textTool': 'Testo',
  'fileViewer.textAnnotationRemove': 'Rimuovi testo',
  'fileViewer.screenshot': 'Screenshot',
  'fileViewer.versions.entry': 'Versioni',
  'fileViewer.versions.entryFull': 'Cronologia versioni',
  'fileViewer.versions.title': 'Versioni',
  'fileViewer.versions.countOne': '1 versione',
  'fileViewer.versions.countMany': '{count} versioni',
  'fileViewer.versions.current': 'Corrente',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Versione {version}',
  'fileViewer.versions.listAria': 'Versioni del file',
  'fileViewer.versions.loading': 'Caricamento versioni...',
  'fileViewer.versions.empty': 'Nessuna versione ancora.',
  'fileViewer.versions.loadFailed': 'Impossibile caricare le versioni.',
  'fileViewer.versions.previewFailed': 'Impossibile caricare l’anteprima di questa versione.',
  'fileViewer.versions.previewLoading': 'Caricamento anteprima versione...',
  'fileViewer.versions.noPrompt': 'Nessun prompt registrato',
  'fileViewer.versions.noPromptBody': 'Nessun prompt è stato registrato per questa versione.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Copia prompt',
  'fileViewer.versions.fullscreen': 'Anteprima a schermo intero',
  'fileViewer.versions.open': 'Apri anteprima in una nuova finestra',
  'fileViewer.versions.currentHelp': 'Questa è già la versione corrente.',
  'fileViewer.versions.restoreHelp': 'Il passaggio ripristina questo HTML come nuova versione corrente.',
  'fileViewer.versions.restore': 'Passa a questa versione',
  'fileViewer.versions.restoreConfirmTitle': 'Passare a questa versione?',
  'fileViewer.versions.restoreConfirmCta': 'Passa',
  'fileViewer.versions.restoring': 'Passaggio...',
  'fileViewer.versions.restoreFailed': 'Impossibile passare a questa versione.',
  'fileViewer.versions.restoreSuccess': 'Passato a questa versione.',
  'fileViewer.editScreenshotToChat': 'Screenshot in chat',
  'manualEdit.layers': 'Livelli',
  'manualEdit.editableCount': '{count} modificabile',
  'manualEdit.hiddenBadge': 'Nascosto',
  'manualEdit.title': 'Editor manuale',
  'manualEdit.fallbackTitle': 'Modifica',
  'manualEdit.movePanel': 'Sposta pannello di modifica',
  'manualEdit.editParams': 'Modifica parametri',
  'manualEdit.closePanel': 'Chiudi pannello di modifica',
  'manualEdit.selectLayer': 'Seleziona un livello',
  'manualEdit.empty': 'Clicca un elemento nell\'anteprima o scegli un livello.',
  'manualEdit.noEditableLayers': 'Nessun livello modificabile trovato.',
  'manualEdit.noClass': 'nessuna classe',
  'manualEdit.tabsAria': 'Schede di modifica manuale',
  'manualEdit.tabContent': 'Contenuto',
  'manualEdit.tabStyle': 'Stile',
  'manualEdit.tabAttributes': 'Attributi',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Sorgente',
  'manualEdit.attributesJson': 'JSON degli attributi',
  'manualEdit.selectedHtml': 'HTML dell\'elemento selezionato',
  'manualEdit.fullSource': 'Sorgente completo dell\'artefatto',
  'manualEdit.applyContent': 'Applica contenuto',
  'manualEdit.applyStyle': 'Applica stile',
  'manualEdit.applyAttributes': 'Applica attributi',
  'manualEdit.applyHtml': 'Applica HTML',
  'manualEdit.applySource': 'Applica sorgente',
  'manualEdit.invalidAttributes': 'JSON degli attributi non valido.',
  'manualEdit.changes': 'Modifiche',
  'manualEdit.undo': 'Annulla',
  'manualEdit.redo': 'Ripeti',
  'manualEdit.noChanges': 'Nessuna modifica manuale ancora.',
  'manualEdit.imageUrl': 'URL immagine',
  'manualEdit.altText': 'Testo alternativo',
  'manualEdit.label': 'Etichetta',
  'manualEdit.text': 'Testo',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Colore testo',
  'manualEdit.background': 'Sfondo',
  'manualEdit.fontSize': 'Dimensione carattere',
  'manualEdit.weight': 'Peso',
  'manualEdit.align': 'Allineamento',
  'manualEdit.textAlignLeft': 'Allinea a sinistra',
  'manualEdit.textAlignCenter': 'Centra',
  'manualEdit.textAlignRight': 'Allinea a destra',
  'manualEdit.padding': 'Padding',
  'manualEdit.margin': 'Margine',
  'manualEdit.radius': 'Raggio',
  'manualEdit.referenceValues': 'Valori di riferimento',
  'manualEdit.referenceValuesEmpty': 'Nessun valore di riferimento corrispondente',
  'manualEdit.referenceValuesLoading': 'Caricamento…',
  'manualEdit.lineHeight': 'Altezza riga',
  'manualEdit.letterSpacing': 'Spaziatura lettere',
  'manualEdit.borderStyle': 'Stile bordo',
  'manualEdit.borderStyleSolid': 'Continuo',
  'manualEdit.borderStyleDashed': 'Tratteggiato',
  'manualEdit.borderStyleDotted': 'Punteggiato',
  'manualEdit.borderStyleDouble': 'Doppio',
  'manualEdit.borderStyleNone': 'Nessuno',
  'manualEdit.border': 'Bordo',
  'manualEdit.width': 'Larghezza',
  'manualEdit.minHeight': 'Altezza minima',
  'manualEdit.deleteElement': 'Elimina elemento',
  'manualEdit.deleteElementConfirm': 'Eliminare l\'elemento selezionato? L\'operazione può essere annullata con Annulla.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Carica immagine',
  'manualEdit.uploadingImage': 'Caricamento immagine…',
  'manualEdit.uploadImageFailed': 'Impossibile caricare l\'immagine.',
  'manualEdit.focusSlides': 'Concentra sulle slide',
  'manualEdit.showPanels': 'Mostra pannelli',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Riduci zoom',
  'fileViewer.zoomIn': 'Aumenta zoom',
  'fileViewer.resetZoom': 'Reimposta zoom',
  'fileViewer.viewportAria': 'Viewport di anteprima',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Anteprima desktop a larghezza intera',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Anteprima tablet a 820 × 1180 (riferimento verticale moderno)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Anteprima mobile a 390 × 844',
  'fileViewer.reloadAria': 'Ricarica',
  'fileViewer.previousSlide': 'Diapositiva precedente',
  'fileViewer.nextSlide': 'Diapositiva successiva',
  'fileViewer.slideNavAria': 'Navigazione diapositive',
  'fileViewer.speakerNotes': 'Note del relatore',
  'fileViewer.speakerNotesSlide': 'Diapositiva {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Nessuna nota del relatore per questa diapositiva.',
  'fileViewer.speakerNotesEdit': 'Modifica',
  'fileViewer.speakerNotesSave': 'Salva note',
  'fileViewer.speakerNotesSaving': 'Salvataggio…',
  'fileViewer.speakerNotesSaved': 'Salvato',
  'fileViewer.speakerNotesSaveFailed': 'Impossibile salvare le note del relatore.',
  'fileViewer.speakerNotesPlaceholder': 'Aggiungi note del relatore per questa diapositiva…',
  'fileViewer.previewAssetBlockedTitle': 'Asset anteprima bloccato',
  'fileViewer.previewAssetBlockedDetail': 'Impossibile caricare {filePath}. Sostituisci i symlink esterni con file all’interno di questo progetto.',
  'fileViewer.presenterReset': 'Reimposta',
  'fileViewer.present': 'Presenta',
  'fileViewer.presentInTab': 'In questa scheda',
  'fileViewer.presentFullscreen': 'Schermo intero',
  'fileViewer.presentNewTab': 'Nuova scheda',
  'fileViewer.presentFromBeginning': 'Inizia dall’inizio',
  'fileViewer.presentFromCurrentSlide': 'Inizia dalla diapositiva corrente',
  'fileViewer.presenterMode': 'Modalità relatore',
  'fileViewer.exitPresentation': 'Esci dalla presentazione',
  'fileViewer.shareLabel': 'Condividi',
  'fileViewer.shareMenuShareLink': 'CONDIVIDI',
  'fileViewer.shareMenuPublishOnline': 'CONDIVIDI SUL TUO HOSTING',
  'fileViewer.shareMenuDownload': 'SCARICA',
  'fileViewer.shareMenuPresentation': 'Presentazione',
  'fileViewer.shareMenuSourceFiles': 'File sorgente',
  'fileViewer.shareMenuSave': 'SALVA',
  'fileViewer.shareMenuPublishViaOd': 'CONDIVISIONE RAPIDA · OPENDESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Ottieni un link di condivisione',
  'fileViewer.publishSingleFileDescription': 'Chiunque abbia il link può vederlo online. Per ora è possibile condividere solo un singolo file — le risorse locali incorporate come le immagini non sono ancora supportate.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Creazione del link…',
  'fileViewer.unpublishFile': 'Interrompi la condivisione',
  'fileViewer.shareEmptyStateTitle': 'Niente da condividere per ora',
  'fileViewer.shareEmptyStateDescription': 'Crea o unisciti a un team per condividere questo file con i colleghi',
  'fileViewer.shareEmptyStateCreateTeam': 'Crea team',
  'fileViewer.shareTeamMissingTitle': 'Nessun team con cui condividere, per ora',

  'fileViewer.publishFileRequiresTeam': 'La pubblicazione di un link pubblico richiede uno spazio di lavoro del team. Passa a uno spazio del team o usa Distribuisci per pubblicare questo file.',
  'fileViewer.publishFileRequiresWorkspace': 'Un link di condivisione richiede uno spazio di lavoro con accesso effettuato. Accedi a OpenDesign Cloud oppure condividi questo file tramite un deploy.',
  'fileViewer.publishFileFailed': 'Impossibile creare il link di condivisione. Riprova o usa un\'opzione di deploy qui sotto.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Copia link di condivisione',
  'fileViewer.openSharePage': 'Apri pagina condivisa',
  'fileViewer.shareLinkRequiresDeploy': 'Pubblica prima online per ottenere un link',
  'fileViewer.shareLinkPublishGuide': 'Pubblica online sopra per abilitare la condivisione ↑',
  'fileViewer.shareAfterGenerationComplete': 'Condivisione disponibile al termine della generazione',
  'fileViewer.copyProviderLink': 'Copia link {provider}',
  'fileViewer.copyCloudflareLink': 'Copia link Cloudflare',
  'fileViewer.screenshotCopying': 'Copia dello screenshot in corso...',
  'fileViewer.screenshotCopied': 'Screenshot copiato negli appunti',
  'fileViewer.screenshotClipboardDenied': 'Il browser ha bloccato l\'accesso agli appunti',
  'fileViewer.screenshotPreviewLoading': 'L\'anteprima si sta ancora caricando. Riprova tra un momento.',
  'fileViewer.screenshotCaptureFailed': 'Impossibile acquisire l\'anteprima. Riprova.',
  'fileViewer.exportPdf': 'Esporta in PDF',
  'fileViewer.exportPdfAllSlides': 'Esporta in PDF (tutte le diapositive)',
  'fileViewer.exportPptxBusy': 'Attendi la fine del turno in corso.',
  'fileViewer.exportPptxHint': 'Invia una richiesta all\'agente per convertire questo design in PPTX.',
  'fileViewer.exportPptxNa': 'L\'esportazione PPTX non è disponibile qui.',
  'fileViewer.exportDaemonUnreachable': 'Impossibile raggiungere il daemon. Riprova.',
  'fileViewer.exportZip': 'Scarica come .zip',
  'fileViewer.exportHtml': 'Esporta in HTML autonomo',
  'fileViewer.exportMd': 'Esporta in Markdown',
  'fileViewer.exportImage': 'Esporta come immagine',
  'fileViewer.exportPptxImages': 'Esporta come PPTX (immagini)',
  'fileViewer.exportPptxEditable': 'Esporta come PPTX (modificabile)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Esportazione…',
  'fileViewer.exportSlideProgress': 'Esportazione diapositiva {current}/{total}…',
  'fileViewer.exportingElapsed': 'Esportazione… {seconds}s',
  'fileViewer.exportSlideEta': 'Diapositiva {current}/{total} · ~{seconds}s rimanenti',
  'fileViewer.exportFailed': 'Esportazione non riuscita. Riprova.',
  'fileViewer.exportDone': 'Esportazione completata',
  'fileViewer.exportImageFailed': 'Acquisizione immagine non riuscita. Riprova o usa lo strumento screenshot del browser.',
  'fileViewer.exportImageModalSubtitle': 'Scegli un formato, poi scarica l\'anteprima corrente come immagine.',
  'fileViewer.exportImageFormatLabel': 'Formato',
  'fileViewer.exportImageSaving': 'Salvataggio immagine…',
  'fileViewer.exportImageSaved': 'Immagine salvata',
  'fileViewer.exportImageDownloadStarted': 'Download avviato',
  'fileViewer.exportImageDownloadDetails': '{filename} si trova nei download del browser se non è apparsa la finestra Salva con nome.',
  'fileViewer.exportJsx': 'Esporta in JSX',
  'fileViewer.exportReactHtml': 'Esporta anteprima in HTML',
  'fileViewer.exportStarted': 'Esportazione avviata',
  'fileViewer.saveAsTemplate': 'Salva come modello…',
  'fileViewer.savingTemplate': 'Salvataggio del modello…',
  'fileViewer.savedTemplate': 'Salvato come « {name} »',
  'fileViewer.savedTemplateFail': 'Impossibile salvare il modello — riprova.',
  'fileViewer.templateNamePrompt': 'Nome del modello',
  'fileViewer.templateNameDefault': 'Modello senza titolo',
  'fileViewer.templateDescPrompt': 'Breve descrizione (facoltativa — cosa rende utile questo modello?)',
  'liveArtifact.refresh.button': 'Aggiorna',
  'liveArtifact.refresh.buttonTitle': 'Aggiorna questo artefatto live',
  'liveArtifact.refresh.loadingTitle': 'Caricamento artifact live…',
  'liveArtifact.refresh.noSourceTitle': 'Nessuna origine di aggiornamento ancora disponibile.',
  'liveArtifact.refresh.running': 'Aggiornamento…',
  'liveArtifact.refresh.runningMessage': 'Aggiornamento di dati e anteprima in corso. Potrebbe richiedere un momento.',
  'liveArtifact.refresh.runningAction': 'L\'anteprima precedente resta visibile finché l\'aggiornamento non riesce.',
  'liveArtifact.refresh.successOne': 'Aggiornamento completato. Dati aggiornati.',
  'liveArtifact.refresh.successMany': 'Aggiornamento completato. Dati aggiornati.',
  'liveArtifact.refresh.successAction': 'L\'anteprima è stata ricaricata con i dati più recenti salvati.',
  'liveArtifact.refresh.previousFailure': 'Aggiornamento precedente non riuscito: {message}',
  'liveArtifact.refresh.failureAction': 'Controlla la cronologia degli aggiornamenti, risolvi il problema di origine o di autorizzazione, poi riprova.',
  'liveArtifact.refresh.networkFailure': 'Richiesta di aggiornamento non riuscita. Verifica la connessione e riprova.',
  'liveArtifact.refresh.genericFailure': 'Aggiornamento non riuscito.',
  'liveArtifact.refresh.statusNever': 'Non aggiornabile',
  'liveArtifact.refresh.statusReady': 'Pronto per l\'aggiornamento',
  'liveArtifact.refresh.statusSucceeded': 'Aggiornato',
  'liveArtifact.refresh.statusFailed': 'Aggiornamento non riuscito',
  'liveArtifact.refresh.statusRunning': 'Aggiornamento in corso',
  'liveArtifact.refresh.statusRunningDescription': 'Un\'esecuzione di aggiornamento è attualmente in corso.',
  'liveArtifact.refresh.statusSucceededDescription': 'L\'ultimo aggiornamento è terminato con successo.',
  'liveArtifact.refresh.statusFailedDescription': 'L\'ultimo tentativo di aggiornamento non è stato completato con successo.',
  'liveArtifact.refresh.statusReadyDescription': 'Le origini aggiornabili sono configurate ma nessuna esecuzione è in corso.',
  'liveArtifact.refresh.statusNeverDescription': 'Questo artefatto live non ha ancora un\'origine di aggiornamento.',
  'liveArtifact.refresh.eventStarted': 'Avviato',
  'liveArtifact.refresh.eventSucceeded': 'Riuscito',
  'liveArtifact.refresh.eventFailed': 'Non riuscito',
  'liveArtifact.refresh.eventStartedDetail': 'Aggiornamento avviato…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} origine aggiornata',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} origini aggiornate',
  'liveArtifact.refresh.timelineEmpty': 'Nessuna attività di aggiornamento in questa sessione. Avvia un aggiornamento per registrare una cronologia oppure attendi le esecuzioni automatiche.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Ultimo aggiornamento',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Mai',
  'liveArtifact.refresh.justNow': 'adesso',
  'liveArtifact.refresh.factCreated': 'Creato',
  'liveArtifact.refresh.factLastUpdated': 'Ultimo aggiornamento',
  'liveArtifact.refresh.factUnknown': 'Sconosciuto',
  'liveArtifact.refresh.persistedTitle': 'Cronologia aggiornamenti salvata',
  'liveArtifact.refresh.persistedHint': 'Voci caricate da refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Nessuna cronologia aggiornamenti salvata.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'riuscito',
  'liveArtifact.refresh.persistedStatusRunning': 'in esecuzione',
  'liveArtifact.refresh.persistedStatusFailed': 'non riuscito',
  'liveArtifact.refresh.persistedStatusCancelled': 'annullato',
  'liveArtifact.refresh.persistedStatusSkipped': 'saltato',
  'liveArtifact.refresh.sessionTitle': 'Attività della sessione',
  'liveArtifact.refresh.sessionHint': 'Eventi rilevati mentre questa scheda è aperta',
  'liveArtifact.refresh.docSourceTitle': 'Origine documento',
  'liveArtifact.refresh.docSourceHint': 'Origine configurata',
  'liveArtifact.refresh.docSourceType': 'Tipo',
  'liveArtifact.refresh.docSourceTool': 'Strumento',
  'liveArtifact.refresh.docSourceConnector': 'Connettore',
  'liveArtifact.refresh.debugSummary': 'Metadati di debug avanzati',
  'liveArtifact.refresh.debugNote': 'Può includere ID dei connettori, nomi di file, metadati delle origini e percorsi interni degli artefatti.',
  'liveArtifact.viewer.tabPreview': 'Anteprima',
  'liveArtifact.viewer.tabCode': 'Codice',
  'liveArtifact.viewer.tabData': 'Dati',
  'liveArtifact.viewer.tabRefreshHistory': 'Cronologia aggiornamenti',
  'liveArtifact.viewer.dataEmpty': 'Nessuna cache data.json disponibile.',
  'liveArtifact.viewer.code.templateHeading': 'HTML del modello',
  'liveArtifact.viewer.code.renderedHeading': 'HTML renderizzato',
  'liveArtifact.viewer.code.templateHelp': 'Il modello modificabile utilizzato con data.json per generare l\'anteprima.',
  'liveArtifact.viewer.code.renderedHelp': 'L\'index.html generato attualmente caricato dall\'anteprima.',
  'liveArtifact.viewer.code.variantAria': 'Variante del codice',
  'liveArtifact.viewer.code.variantTemplate': 'Modello',
  'liveArtifact.viewer.code.variantRendered': 'Renderizzato',
  'liveArtifact.viewer.code.loading': 'Caricamento codice…',
  'liveArtifact.viewer.code.unavailable': 'Il codice non è ancora disponibile.',
  'liveArtifact.viewer.code.empty': 'Questo file di codice è vuoto.',
  'fileViewer.deployToVercel': 'Distribuisci su Vercel',
  'fileViewer.redeployToVercel': 'Ridistribuisci',
  'fileViewer.deployingToVercel': 'Distribuzione su Vercel…',
  'fileViewer.deployProviderLabel': 'Provider',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Destinazione',
  'fileViewer.deployTargetPreview': 'Anteprima',
  'fileViewer.deployTargetProduction': 'Produzione',
  'fileViewer.deployToProvider': 'Distribuisci su {provider}',
  'fileViewer.redeployToProvider': 'Ridistribuisci su {provider}',
  'fileViewer.deployingToProvider': 'Distribuzione su {provider}…',
  'fileViewer.preparingPublicLink': 'Preparazione del link pubblico…',
  'fileViewer.copyDeployLink': 'Copia link',
  'fileViewer.deployModalTitle': 'Distribuisci',
  'fileViewer.deployModalSubtitle': 'Usa l\'account del provider selezionato per distribuire questa anteprima HTML.',
  'fileViewer.vercelToken': 'Token Vercel',
  'fileViewer.vercelTokenGetLink': 'Ottieni un token Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Incolla il tuo token Vercel',
  'fileViewer.vercelTokenReuseHint': 'Il token salvato verrà utilizzato. Inserisci un nuovo token per sostituirlo.',
  'fileViewer.vercelTokenRequired': 'Inserisci e salva prima un token Vercel.',
  'fileViewer.cloudflareApiToken': 'Token API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Ottieni token API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Incolla il tuo token API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Il token API Cloudflare salvato verrà utilizzato. Inserisci un nuovo token per sostituirlo.',
  'fileViewer.cloudflareApiTokenRequired': 'Inserisci e salva prima un token API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Seleziona Pages Edit durante la creazione del token API; i domini personalizzati richiedono Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID team',
  'fileViewer.vercelTeamSlug': 'Slug team',
  'fileViewer.cloudflareAccountId': 'ID account',
  'fileViewer.cloudflareAccountIdHint': 'Trova l’ID account nella dashboard Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Inserisci e salva prima un ID account Cloudflare.',
  'fileViewer.cloudflareZoneLabel': 'Dominio',
  'fileViewer.cloudflareZonePlaceholder': 'Salva le impostazioni Cloudflare per caricare i domini',
  'fileViewer.cloudflareZoneRequired': 'Seleziona prima un dominio Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Caricamento domini Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Aggiorna domini',
  'fileViewer.cloudflareZonesLoadFailed': 'Impossibile caricare i domini Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Nessun dominio Cloudflare completo attivo trovato per questo account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefisso sottodominio',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Usa solo un\'etichetta DNS: lettere minuscole, numeri e trattini.',
  'fileViewer.cloudflareHostnamePreview': 'Anteprima dominio personalizzato: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Facoltativo: collega un dominio personalizzato. Lasciando vuoto verrà comunque creato un link pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Dominio personalizzato',
  'fileViewer.optional': 'Facoltativo',
  'fileViewer.vercelPreviewOnly': 'Le distribuzioni sono in modalità Preview per ora.',
  'fileViewer.cloudflarePagesPreviewHint': 'Le distribuzioni Cloudflare Pages utilizzano Direct Upload.',
  'fileViewer.savingConfig': 'Salvataggio…',
  'fileViewer.deployConfigSaveFailed': 'Impossibile salvare le impostazioni Vercel.',
  'fileViewer.deployFailed': 'Distribuzione fallita. Controlla le impostazioni Vercel e riprova.',
  'fileViewer.deployProviderConfigSaveFailed': 'Impossibile salvare le impostazioni {provider}.',
  'fileViewer.deployProviderFailed': 'Distribuzione {provider} fallita. Controlla le impostazioni e riprova.',
  'fileViewer.deployResultLabel': 'URL distribuito',
  'fileViewer.deployLinkReady': 'Pronto',
  'fileViewer.deploySuccessToast': 'Distribuzione caricata correttamente',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link pubblico in attesa',
  'fileViewer.deployLinkDelayed': 'Il sito è distribuito. Il provider sta ancora preparando il link pubblico.',
  'fileViewer.deployLinkFailed': 'Il dominio personalizzato è fallito',
  'fileViewer.deployLinkProtectedLabel': 'Protezione della distribuzione attivata',
  'fileViewer.deployLinkProtected': 'Il sito è distribuito, ma questo link di anteprima richiede autenticazione. Disattiva Deployment Protection o usa un dominio personalizzato.',
  'fileViewer.retryLink': 'Riprova ora',
  'questionForm.submit': 'Invia',
  'questionForm.skip': 'Salta',
  'questionForm.locked': 'Risposto',
  'tool.openInTab': 'Apri {name} in una scheda',
  'tool.open': 'apri',
  'tool.todos': 'Attività',
  'tool.todosExpand': 'Mostra attività',
  'tool.todosCollapse': 'Nascondi attività',
  'tool.todosDone': 'Fatto',
  'tool.todosDismiss': 'Chiudi l\'elenco delle attività',
  'tool.write': 'Scrivi',
  'tool.edit': 'Modifica',
  'tool.read': 'Leggi',
  'tool.delete': 'Elimina',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Recupera',
  'tool.search': 'Cerca',
  'tool.lines': '{n} righe',
  'tool.changeSingular': 'modifica',
  'tool.changePlural': 'modifiche',
  'tool.in': 'in {path}',
  'tool.hide': 'nascondi',
  'tool.output': 'output',
  'tool.running': 'in corso…',
  'tool.error': 'errore',
  'tool.done': 'completato',
  'assistant.role': 'Assistente',
  'assistant.workingLabel': 'In corso',
  'assistant.doneLabel': 'Completato',
  'assistant.awaitingReplyLabel': 'In attesa di risposta',
  'assistant.canceledLabel': 'Interrotto manualmente',
  'assistant.copyMarkdown': 'Copia',
  'assistant.forkConversation': 'Nuova conversazione',
  'assistant.forkingConversation': 'Avvio nuova conversazione…',
  'assistant.forkNote': 'Seguito della conversazione',
  'assistant.shareToOpenDesign': 'Condividi su OpenDesign',
  'assistant.shareToOpenDesignBusy': 'Preparazione pacchetto…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Utile',
  'assistant.feedbackNegative': 'Non utile',
  'assistant.feedbackReasonTitle': 'Dicci perché',
  "assistant.feedbackReasonTitleNegative": "Cosa non va?",
  "assistant.feedbackDiscordNegative": "Condividi più contesto su {discord} così il team può capire cosa è andato storto e intervenire.",
  "assistant.feedbackDiscordPositive": "Condividi ciò che hai creato con la community {discord}, o manda uno screenshot e raccontaci cosa ha funzionato.",
  'assistant.feedbackReasonPositiveMatched': 'Ha compreso la mia richiesta',
  'assistant.feedbackReasonPositiveVisual': 'Sembra ottimo',
  'assistant.feedbackReasonPositiveUseful': 'Struttura utile',
  'assistant.feedbackReasonPositiveEasy': 'Facile da continuare a modificare',
  'assistant.feedbackReasonPositiveDesignSystem': 'Ha seguito il design system',
  'assistant.feedbackReasonNegativeMissed': 'Non ha seguito la mia richiesta',
  'assistant.feedbackReasonNegativeVisual': 'Incoerenza visiva',
  'assistant.feedbackReasonNegativeIncomplete': 'Output incompleto',
  'assistant.feedbackReasonNegativeHard': 'Difficile da usare',
  'assistant.feedbackReasonNegativeCouldNotRun': 'Non si avvia',
  'assistant.feedbackReasonNegativeTooSlow': 'Troppo lento',
  'assistant.feedbackReasonNegativeDesignSystem': 'Non ha seguito il design system',
  'assistant.feedbackReasonOther': 'Altro',
  'assistant.feedbackReasonPlaceholder': 'Aggiungi un dettaglio (facoltativo)',
  'assistant.feedbackReasonSubmit': 'Invia',
  "assistant.emptyResponseLabel": "Impossibile completare l’attività",
  "assistant.emptyResponseMessage": "L'esecuzione di questa attività non è riuscita. Riprova. Se non riesce di nuovo, contatta l'assistenza.",
  'assistant.unfinishedLabel': 'Fermato con lavoro non completato',
  'assistant.unfinishedSummary': '{n} attività rimanenti',
  'assistant.unfinishedMore': '+{n} in più',
  'assistant.continueRemaining': 'Continua le attività rimanenti',
  'chat.resumeRunCta': 'Riprendi l’esecuzione',
  'chat.runError.contactSupportCta': "Contattaci",
  'chat.runError.exportLogsCta': "Esporta i log",
  'chat.runError.switchModelCta': "Cambia modello",
  'chat.runError.openSettingsCta': 'Apri impostazioni',
  "chat.runError.title.readOnlyAccess": "Nessuna autorizzazione a modificare il progetto",
  "chat.runError.title.messagesUnavailable": "Impossibile caricare la conversazione",
  "chat.runError.actionBlocked.readOnly": "Al momento puoi solo visualizzare questo progetto e non puoi eseguire attività.",
  "chat.runError.actionBlocked.messagesUnavailable": "Al momento non è possibile leggere la conversazione. Riprova. Se il problema si ripresenta, contatta l’assistenza.",
  'chat.runError.actionBlocked.billing': "Stiamo ancora determinando quale spazio di lavoro paga questo progetto. Riprova tra poco.",
  'chat.runError.actionBlocked.busy': "In questa conversazione c'è ancora un'attività in corso. Potrai riprovare quando sarà terminata.",
  'chat.support.channel.feishu': "Community Feishu",
  'chat.support.channel.discord': "Discord",
  'chat.amrBalanceOwner.title': "Chiedi al proprietario del team di ricaricare",
  'chat.amrBalanceOwner.message': "Solo il proprietario del team può ricaricare il credito del team. Chiedi a «{name}» di completare la ricarica prima di continuare.",
  'chat.amrBalanceOwner.messageNoOwnerName': "Solo il proprietario del team può ricaricare il credito del team. Chiedi al proprietario del team di completare la ricarica prima di continuare.",
  'chat.amrBalanceOwner.dismissCta': "Ho capito",
  'assistant.outTokens': '{n} output',
  'assistant.producedFiles': 'File di questo turno',
  'assistant.openFile': 'Apri',
  'assistant.downloadFile': 'Scarica',
  "nextStep.imageContinue": "Continua a migliorare",
  "nextStep.imageVariants": "Genera varianti / un altro gruppo",
  "nextStep.imageStyle": "Modifica stile / composizione",
  'nextStep.title': 'Passo successivo',
  'nextStep.suggestionsLabel': 'Prossimi passi suggeriti',
  'nextStep.more': 'Altro',
  'nextStep.share': 'Condividi',
  'nextStep.download': 'Scarica',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Contribuisci',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Creazione design...',
  'assistant.thinking': 'Riflessione',
  'assistant.thought': 'Ha riflettuto',
  'assistant.thoughtFor': 'Ha riflettuto per {s}s',
  'assistant.designSystemDirectionLocked': 'Sistema di design attivo selezionato. La direzione visiva è già definita.',
  'assistant.waitingFirstOutput': 'In attesa del primo output',
  'assistant.statusBootingAgent': 'Avvio dell\'agente',
  'assistant.statusPreparing': 'Preparazione in corso...',
  'assistant.statusStarting': 'Avvio',
  'assistant.statusRequesting': 'Invio della richiesta',
  'assistant.statusThinking': 'Riflessione',
  'assistant.statusStreaming': 'Streaming',
  'assistant.statusCompactingContext': 'Compressione del contesto',
  'assistant.slowHint': 'Più lungo del solito. Il modulo si visualizza generalmente in 5–10s — puoi Fermare e riformulare.',
  'assistant.verbEditing': 'Modifica',
  'assistant.verbWriting': 'Scrittura',
  'assistant.verbReading': 'Lettura',
  'assistant.verbSearching': 'Ricerca',
  'assistant.verbRunning': 'Esecuzione',
  'assistant.verbTodos': 'Attività',
  'assistant.verbFetching': 'Recupero',
  'assistant.verbCalling': 'Chiamata',
  'qf.answered': 'risposto',
  "qf.unanswered": "Senza risposta",
  "qf.unansweredContinued": "Questa domanda non ha ricevuto risposta. La conversazione è proseguita.",
  'qf.answeredConfirmed': 'Confermato',
  'qf.answeredSkipped': 'Saltata',
  "chat.att.cancelUpload": "Annulla il caricamento di {name}",
  "chat.att.retry": "Riprova",
  "chat.attachments.scrollNext": "Mostra gli allegati successivi",
  "chat.attachments.scrollPrev": "Mostra gli allegati precedenti",
  "chat.input.collapse": "Comprimi",
  "chat.input.expandFull": "Mostra il messaggio completo",
  "chat.input.viewAll": "Mostra tutto",
  "chat.artifact.export": "Esporta",
  "chat.artifact.pending": "Generazione…",
  "chat.artifact.publish": "Condividi",
  "chat.edge.paused": "Attività messa in pausa manualmente",
  "chat.edge.reconnectCta": "Riconnetti",
  "chat.edge.reconnectDetail": "Visualizza dettagli",
  "chat.edge.reconnectFailed": "Connessione di rete non ripristinata",
  "chat.edge.reconnectFailedDescription": "Verifica la connessione di rete e riprova.",
  "chat.edge.reconnecting": "Ripristino della connessione di rete",
  "chat.edge.reconnectingDescription": "Tentativo di connessione {attempt}/{max} in corso. Attendi.",
  "chat.edge.retrying": "Nuovo tentativo",
  "qf.visualNext": "Stile successivo",
  "qf.visualPrev": "Stile precedente",
  "qf.visualRandom": "Casuale",
  "qf.visualReshuffle": "Altre proposte",
  "qf.visualViewFan": "Rimetti in pila",
  "qf.visualViewGrid": "Mostra a griglia",
  "qf.confirmed": "Confermato",
  "qf.picked": "{count} scelti",
  "qf.moreOptions": "Altre opzioni",
  "qf.colorPresets": "Colori predefiniti",
  "qf.colorCustom": "Colore personalizzato",
  "qf.colorPickerLabel": "Apri il selettore colore",
  "qf.colorHexLabel": "Valore colore esadecimale",
  "qf.colorPreview": "Anteprima: ecco come appare il colore d'accento nell'interfaccia.",
  "qf.colorInvalid": "Inserisci un colore esadecimale di 6 cifre, ad esempio #3b82f6",
  'qf.choose': 'Scegli…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Altro',
  'qf.ownAnswer': 'Scrivi la tua',
  'qf.required': 'richiesto',
  'qf.lockedSubmitted': 'Risposte inviate — l\'agente le usa per il resto della sessione.',
  'qf.lockedPrev': 'Questo modulo proviene da un turno precedente.',
  'qf.hint': 'Scegli ciò che conviene. Ignora i campi facoltativi che non ti interessano — l\'agente userà valori predefiniti ragionevoli.',
  'qf.submitDefault': "Avanti",
  'qf.submitDisabledTitle': 'Compila prima i campi richiesti',
  'qf.submitTitle': "Avanti",
  'questions.tabLabel': 'Domande',
  'questions.banner': 'Posso farti un paio di domande veloci?',
  'questions.bannerAnswered': 'Domande completate',
  'questions.strategyBlockedNotice': "Questa attività è stata fermata dal controllo qualità della strategia, quindi questo modulo non può più essere inviato. Avvia una nuova richiesta per continuare.",
  'questions.continue': 'Continua',
  'questions.generating': 'Generazione domande…',
  'questions.skipAll': "Salta · decidi tu",
  'questions.autoSkipHint': 'Continua automaticamente allo scadere del timer',
  'questions.submitting': 'Invio in corso…',
  'sketch.toolSelect': 'Selezione (senza effetto)',
  'sketch.toolPen': 'Penna',
  'sketch.toolText': 'Testo',
  'sketch.toolRect': 'Rettangolo',
  'sketch.toolArrow': 'Freccia',
  'sketch.toolEraser': 'Gomma',
  'sketch.color': 'Colore',
  'sketch.strokeSize': 'Dimensione tratto',
  'sketch.undo': 'Annulla',
  'sketch.clear': 'Cancella',
  'sketch.close': 'Chiudi',
  'sketch.closeConfirm': 'Chiudere lo schizzo e abbandonare le modifiche non salvate?',
  'sketch.textPrompt': 'Testo:',
  'sketch.textModalTitle': 'Aggiungi testo',
  'critiqueTheater.userFacingName': 'Giuria di design',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Critico',
  'critiqueTheater.roleBrand': 'Brand',
  'critiqueTheater.roleA11y': 'Accessibilità',
  'critiqueTheater.roleCopy': 'Copia',
  'critiqueTheater.roundLabel': 'Round {n} di {m}',
  'critiqueTheater.mustFix': '{n} da correggere assolutamente',
  'critiqueTheater.composite': 'Composito',
  'critiqueTheater.threshold': 'Soglia',
  'critiqueTheater.consensus': 'Consenso',
  'critiqueTheater.interrupt': 'Interrompi',
  'critiqueTheater.interrupting': 'Interruzione…',
  'critiqueTheater.interrupted': 'Interrotto',
  'critiqueTheater.degradedHeading': 'Panel offline durante questa esecuzione',
  'critiqueTheater.degradedReasonMalformed': 'Output del panel malformato (il parser ha rifiutato il blocco).',
  'critiqueTheater.degradedReasonOversize': 'L\'output del panel ha superato il limite di byte sicuro.',
  'critiqueTheater.degradedReasonAdapter': 'L\'adapter {adapter} non supportava il protocollo Critique.',
  'critiqueTheater.degradedReasonProtocol': 'L\'adapter {adapter} ha inviato una versione del protocollo non supportata.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Esecuzione terminata senza un artifact finale.',
  'critiqueTheater.replay': 'Riproduci di nuovo',
  'critiqueTheater.replaySpeed': 'Velocità di riproduzione',
  'critiqueTheater.readOnly': 'Sola lettura',
  'critiqueTheater.shippedSummary': 'Consegnato al round {round} · composito {composite}',
  'critiqueTheater.interruptedSummary': 'Interrotto al round {round} · miglior composito {composite}',
  'critiqueTheater.shippedBadge': 'Pubblicato',
  'critiqueTheater.belowThresholdBadge': 'Sotto la soglia',
  'critiqueTheater.timedOutBadge': 'Tempo scaduto',
  'critiqueTheater.failedHeading': 'Esecuzione non riuscita',
  'critiqueTheater.failedReasonCliExit': 'La CLI dell\'Agent è terminata con codice diverso da zero prima che il panel potesse completare.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Un round ha superato il proprio budget di tempo.',
  'critiqueTheater.failedReasonTotalTimeout': 'L\'esecuzione completa ha superato il budget di tempo totale.',
  'critiqueTheater.failedReasonOrchestrator': 'Errore interno dell\'orchestratore.',
  'critiqueTheater.transcriptEmpty': 'Nessuna trascrizione da riprodurre per ora. Esegui una critica per registrarne una.',
  'critiqueTheater.transcriptLoading': 'Caricamento trascrizione…',
  'critiqueTheater.transcriptError': 'Impossibile caricare la trascrizione: {error}',
  'critiqueTheater.replaySpeedPaused': 'In pausa',
  'critiqueTheater.replaySpeedInstant': 'Istantaneo',
  'critiqueTheater.replaySpeedLive': 'In diretta',
  'critiqueTheater.replaySpeedFast': 'Veloce',
  'critiqueTheater.settingsNav': 'Giuria di design',
  'critiqueTheater.settingsNavHint': 'Revisione del design a cinque panel per le tue esecuzioni',
  'critiqueTheater.settingsEnabledLabel': 'Mostra Design Jury durante le esecuzioni dell\'Agent',
  'critiqueTheater.settingsEnabledDescription': 'Se attivata, una revisione a cinque panel compare insieme alle generazioni dell\'Agent e valuta l\'output prima della pubblicazione. Puoi interrompere in qualsiasi momento.',
  'critiqueTheater.settingsEnabledProjectHint': 'Salvato per questo progetto. Le nuove esecuzioni in questo progetto verranno instradate tramite Design Jury lato server.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Apri un progetto per renderlo persistente lato server. Fino ad allora, questo modifica solo la preferenza nel browser.',
  'pet.title': 'Compagni',
  'pet.subtitle': 'Adotta un piccolo compagno che fluttua sopra il tuo spazio di lavoro.',
  'pet.navTitle': 'Compagni',
  'pet.navHint': 'Adotta o personalizza',
  'pet.tabBuiltIn': 'Integrati',
  'pet.tabBuiltInHint': 'Compagni forniti con OpenDesign — scegline uno e adottalo.',
  'pet.builtInEmpty': 'I compagni integrati non sono disponibili per ora. Prova ad aggiornare la scheda Comunità una volta che il daemon è online.',
  'pet.tabCustom': 'Personalizzato',
  'pet.tabCustomHint': 'Crea il tuo con un nome, un glifo, un colore o uno sprite.',
  'pet.tabCommunity': 'Comunità',
  'pet.tabCommunityHint': 'Compagni nati da Codex — adottane uno o generane uno nuovo.',
  'pet.tabsAria': 'Fonte del compagno',
  'pet.adopt': 'Adotta',
  'pet.adoptedBadge': 'Adottato',
  'pet.adoptCallout': 'Adotta un compagno',
  'pet.changePet': 'Cambia compagno',
  'pet.wake': 'Sveglia',
  'pet.tuck': 'Nascondi',
  'pet.wakeTitle': 'Sveglia il compagno — mostra l\'overlay fluttuante.',
  'pet.tuckTitle': 'Nascondi il compagno — nascondi l\'overlay fluttuante.',
  'pet.settingsTitle': 'Apri impostazioni del compagno',
  'pet.useCustom': 'Usa il mio compagno',
  'pet.customTitle': 'Crea il tuo',
  'pet.customHint': 'Scegli un nome, un glifo e un colore d\'accento — l\'overlay si aggiorna in tempo reale.',
  'pet.customGreetingPlaceholder': 'Fai dire ciao al tuo compagno…',
  'pet.fieldName': 'Nome',
  'pet.fieldGlyph': 'Glifo',
  'pet.fieldGlyphHint': 'Un singolo emoji funziona meglio (es. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Saluto',
  'pet.fieldAccent': 'Colore d\'accento',
  'pet.fieldAccentCustom': 'Colore personalizzato',
  'pet.fieldAccentDefault': 'Colore d\'accento predefinito',
  'pet.overlayAria': 'Compagno',
  'pet.spriteAria': '{name} — trascina per spostare, clicca per chattare',
  'pet.spriteTitle': 'Ciao da {name}! Clicca per chattare.',
  'pet.taskSummarySingle': '{count} attività dell\'Agent in esecuzione.',
  'pet.taskSummaryMultiple': '{count} attività dell\'Agent in esecuzione su {projects} progetti.',
  'pet.taskSummaryRecentSingle': '{count} attività dell\'Agent completata di recente.',
  'pet.taskSummaryRecentMultiple': '{count} attività dell\'Agent completate di recente.',
  'pet.taskListAria': 'Attività dell\'Agent attive',
  'pet.taskOpenProject': 'Apri {project}',
  'pet.taskGroup.running': 'In esecuzione',
  'pet.taskGroup.queued': 'In attesa',
  'pet.taskGroup.recent': 'Completate di recente',
  'pet.idleQuote.leonardo.text': 'L\'apprendimento non sfianca mai la mente.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Ho visto l\'angelo nel marmo e ho scolpito finché non l\'ho liberato.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Esistono due strumenti che possono aiutare lo scultore: la luce e l\'ombra.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Quando si dipinge, non si pensa.',
  'pet.idleQuote.raphael.author': 'Raffaello',
  'pet.idleQuote.caravaggio.text': 'Tutte le opere, qualunque cosa siano o da chiunque siano dipinte, non sono altro che bagattelle e sciocchezze infantili se non sono realizzate e dipinte dal vero.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'La cosa principale è emozionarsi, amare, sperare, tremare, vivere.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Compagni — sveglia, nascondi o scegli',
  'pet.composerMenuTitle': 'Compagni',
  'pet.composerMenuHint': 'suggerimento: digita /pet per alternare',
  'pet.composerOpenSettings': 'Gestisci animali',
  'pet.welcomeTeaserTitle': 'Adotta un compagno',
  'pet.welcomeTeaserBody': 'Un piccolo compagno fluttuante che sta con te.',
  'pet.welcomeTeaserCta': 'Scegline uno',
  'pet.imageUpload': 'Carica uno sprite',
  'pet.imageReplace': 'Sostituisci sprite',
  'pet.imageRemove': 'Usa un emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF o SVG. Caricamento di foglio? Trascina una striscia orizzontale e definisci il numero di frame.',
  'pet.imageHintActive': 'Visualizzazione del tuo sprite. Definisci frame > 1 per scorrere un foglio di sprite orizzontale.',
  'pet.fieldFrames': 'Frame',
  'pet.fieldFramesHint': '1 = statico. > 1 = foglio di sprite orizzontale.',
  'pet.fieldFps': 'Velocità (fps)',
  'pet.fieldFpsHint': 'A che velocità scorrono i frame.',
  'pet.atlasImport': 'Importa uno sprite Codex',
  'pet.atlasImportTitle': 'Importa un atlante di pet 8×9 / 192×208 (PNG o WebP).',
  'pet.atlasPickerTitle': 'Scegli una riga di animazione',
  'pet.atlasPickerHint': 'I pet Codex sono forniti con 9 righe di animazione. Per impostazione predefinita, manteniamo l\'atlante completo affinché il pet cambi riga al passaggio del mouse, al trascinamento e all\'inattività. Puoi anche bloccarlo su un singolo ciclo.',
  'pet.atlasCancel': 'Abbandona atlante',
  'pet.atlasAdopt': 'Blocca su questa riga',
  'pet.atlasAdoptFull': 'Usa atlante completo (animato)',
  'pet.atlasAdoptFullTitle': 'Mantieni ogni riga affinché il pet reagisca al passaggio del mouse, alla direzione del trascinamento e alle lunghe inattività.',
  'pet.atlasAdoptRowTitle': 'Ritaglia solo la riga selezionata in una singola striscia in ciclo.',
  'pet.atlasActiveHint': 'Atlante animato attivo — il pet sceglie una riga in base alla tua interazione (passaggio del mouse, trascinamento, inattività).',
  'pet.atlasRow.idle': 'Inattivo',
  'pet.atlasRow.running-right': 'Corre a destra',
  'pet.atlasRow.running-left': 'Corre a sinistra',
  'pet.atlasRow.waving': 'Saluto',
  'pet.atlasRow.jumping': 'Salto',
  'pet.atlasRow.failed': 'Fallito',
  'pet.atlasRow.waiting': 'Attesa',
  'pet.atlasRow.running': 'Corsa',
  'pet.atlasRow.review': 'Revisione',
  'pet.hatchTitle': 'Fai nascere un nuovo compagno con l\'IA',
  'pet.hatchHint': 'Usa la competenza hatch-pet integrata nella chat per generare un foglio di sprite in stile Codex, poi importalo qui.',
  'pet.hatchConcept': 'Concetto del compagno (facoltativo)',
  'pet.hatchConceptPlaceholder': 'es. un piccolo shiba pixel art in un maglione accogliente',
  'pet.hatchCopy': 'Copia prompt',
  'pet.hatchCopied': 'Copiato!',
  'pet.hatchFoot': 'Una volta che la competenza ha salvato il tuo compagno, torna e scegli "Importa uno sprite Codex".',
  'pet.slashPopoverAria': 'Comandi slash',
  'pet.slashPopoverTitle': 'Comandi',
  'pet.slashPopoverHint': '↑↓ naviga · invio per scegliere · esc per chiudere',
  'pet.slashPet': 'Alterna, adotta o vai alle impostazioni del compagno.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Sveglia l\'overlay fluttuante del compagno.',
  'pet.slashPetTuck': 'Nascondi il compagno per ora.',
  'pet.slashHatch': 'Genera un pet Codex tramite la competenza hatch-pet.',
  'pet.slashHatchArg': '<concetto>',
  'pet.slashSearch': 'Cerca sul web tramite il comando OD research.',
  'pet.slashSearchArg': '<query>',
  'pet.codexTitle': 'Nati di recente',
  'pet.codexSubtitle': 'I pet impacchettati dalla competenza hatch-pet appaiono qui per un\'adozione con un clic.',
  'pet.codexSubtitleWithDir': 'Analisi di {dir} per i pet impacchettati dalla competenza hatch-pet.',
  'pet.codexEmpty': 'Nessun pet nato per ora. Digita /hatch nella chat per generarne uno.',
  'pet.codexLoading': 'Ricerca di pet nati…',
  'pet.codexRefresh': 'Aggiorna',
  'pet.codexAdopt': 'Adotta',
  'pet.codexAdopting': 'Adozione…',
  'pet.communitySync': 'Scarica i pet della comunità',
  'pet.communitySyncing': 'Download…',
  'pet.communitySyncTitle': 'Sincronizza gli ultimi pet da Codex Pet Share + j20 Hatchery in ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} nuovi pet sincronizzati ({total} in totale).',
  'pet.communitySyncFailed': 'Sincronizzazione fallita: {error}',
  'pet.codexBundled': 'Fornito',
  'pet.codexBundledTitle': 'Fornito con OpenDesign — nessun download necessario.',
  'settings.systemPrefsTitle': 'Preferenze di sistema',
  'settings.systemPrefsHint': 'Suono di completamento, notifiche del browser e avvisi sullo stato delle attività.',
  'settings.notifications': 'Notifiche',
  'settings.notificationsHint': 'Suono e notifica desktop alla fine di un\'attività',
  'settings.notifyCompletionSound': 'Suono di fine',
  'settings.notifyCompletionSoundHint': 'Riprodotto quando un turno termina. Disabilitato per impostazione predefinita.',
  'settings.notifySuccessSound': 'Suono di successo',
  'settings.notifyFailureSound': 'Suono di fallimento',
  'settings.notifyDesktop': 'Notifica desktop',
  'settings.notifyDesktopHint': 'Inviata quando la finestra non è attiva.',
  'settings.notifyDesktopBlocked': 'Notifiche bloccate dal browser. Autorizzale nelle impostazioni del sito.',
  'settings.notifyDesktopUnsupported': 'Notifiche desktop non disponibili in questo ambiente.',
  'settings.notifyTest': 'Invia un test',
  'settings.notifyTestSent': 'Notifica di test inviata. Se non appare alcun banner, controlla le impostazioni di notifica del browser e del sistema.',
  'settings.notifyTestFailed': 'La chiamata di notifica è fallita. Controlla le impostazioni di notifica del browser e del sistema.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Campanello',
  'settings.notifySoundTwoToneUp': 'Bitonale ascendente',
  'settings.notifySoundPluck': 'Pizzicato',
  'settings.notifySoundBuzz': 'Buzz',
  'settings.notifySoundTwoToneDown': 'Bitonale discendente',
  'settings.notifySoundThud': 'Tonfo',
  'settings.skills': 'Competenze',
  'settings.skillsHint': 'Competenze che l\'agente può invocare durante l\'attività',
  'settings.skillsNew': 'Nuova competenza',
  'settings.skillsEmpty': 'Seleziona una competenza a sinistra, o creane una.',
  'settings.skillsEdit': 'Modifica',
  'settings.skillsDelete': 'Elimina',
  'settings.skillsDeleteConfirm': 'Conferma eliminazione',
  'settings.skillsName': 'Nome',
  'settings.skillsTriggers': 'Trigger (separati da virgole o ritorni a capo)',
  'settings.skillsDescription': 'Descrizione',
  'settings.skillsBody': 'Corpo SKILL.md',
  'settings.skillsCreate': 'Crea',
  'settings.skillsSave': 'Salva',
  'settings.skillsSaving': 'Salvataggio…',
  'settings.skillsOverrideCreate': 'Crea override utente',
  'settings.skillsOverrideSave': 'Salva come override utente',
  'settings.skillsBuiltInOverrideWarning': 'La modifica di questa competenza integrata crea un override utente. La voce integrata verrà nascosta dall\'elenco finché non elimini l\'override. Continuare?',
  'settings.skillsFiles': 'File',
  'settings.skillsNoFiles': 'Nessun file in questa cartella di competenza.',
  'settings.skillsNameRequired': 'Il nome dello skill è obbligatorio.',
  'settings.skillsBodyRequired': 'Il corpo dello skill è obbligatorio.',
  'settings.designSystems': 'Design system',
  'settings.designSystemsHint': 'Sfoglia e attiva i design system disponibili',
  'settings.designSystemsInstalled': 'Installati',
  'settings.designSystemsAdd': 'Aggiungi design system',
  'settings.designSystemsHiddenCount': '{count} nascosti dalla galleria iniziale',
  'settings.designSystemsShowAll': 'Mostra tutti',
  'settings.designSystemsShowHidden': 'Mostra nascosti',
  'settings.designSystemsSource': 'Origine',
  'settings.designSystemsSourceLocal': 'Locale',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Riferimento del registro shadcn',
  'settings.designSystemsImportShadcn': 'Importa da shadcn',
  'settings.designSystemsStructure': 'Struttura',
  'settings.designSystemsModeHybrid': 'Ibrido',
  'settings.designSystemsModeNormalized': 'Normalizzato',
  'settings.designSystemsModeVerbatim': 'Invariato',
  'settings.designSystemsCraft': 'Realizzazione',
  'settings.designSystemsCraftColor': 'Colore',
  'settings.designSystemsCraftAccessibility': 'Accessibilità',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Percorso progetto',
  'settings.designSystemsImportGithub': 'Importa da GitHub',
  'settings.designSystemsImportProject': 'Importa dal progetto',
  'settings.designSystemsImportedStatus': '{title} importato',
  'settings.designSystemsViewImported': 'Vedi design system importato',
  'settings.designSystemsCategory': 'Categoria',
  'settings.designSystemsAllCategories': 'Tutte le categorie',
  'settings.designSystemsShowInHomeGallery': 'Mostra nella galleria iniziale',
  'settings.projectLocations': 'Posizioni dei progetti',
  'settings.projectLocationsHint': 'Radici di archiviazione workspace',
  'settings.projectLocationsDescription': 'Aggiungi basi di lavoro che possono contenere più cartelle di progetti OpenDesign. I nuovi progetti vengono salvati come una cartella nella base selezionata.',
  'settings.projectLocationsSaveError': 'Impossibile salvare le posizioni dei progetti. Verifica che ogni percorso sia una cartella accessibile.',
  'settings.projectLocationsSaved': 'Posizioni dei progetti salvate.',
  'settings.projectLocationsScanError': 'Impossibile scansionare le posizioni dei progetti.',
  'settings.projectLocationsScanComplete': 'Scansione completata: {imported} importati, {existing} già registrati.',
  'settings.projectLocationsNoFolderSelected': 'Nessuna cartella selezionata.',
  'settings.projectLocationsDuplicate': 'Questa base di lavoro è già stata aggiunta.',
  'settings.projectLocationsWorkBaseMeta': 'Base di lavoro · i progetti vengono creati qui come sottocartelle',
  'settings.projectLocationsAddFolder': 'Aggiungi cartella…',
  'settings.projectLocationsDefaultBadge': 'Posizione predefinita',
  'settings.projectLocationsMakeDefault': 'Imposta come predefinita',
  'settings.projectLocationsDefaultSaved': 'Posizione progetto predefinita aggiornata.',
  'settings.librarySkills': 'Competenze',
  'settings.libraryDesignSystems': 'Sistemi di design',
  'settings.librarySearch': 'Cerca...',
  'settings.libraryAll': 'Tutto',
  'settings.libraryPreview': 'Anteprima',
  'settings.libraryPreviewClose': 'Chiudi',
  'settings.libraryLoading': 'Caricamento...',
  'settings.libraryNoResults': 'Nessun elemento corrisponde alla tua ricerca.',
  'settings.libraryEnabled': 'Abilitato',
  'settings.libraryDisabled': 'Disabilitato',
  'settings.connectorsNavHint': 'Connessioni ai sistemi esterni',
  'settings.connectorsHint': 'Gestisci le impostazioni dei connettori e dei provider di strumenti per questo dispositivo.',
  'settings.connectorsComposioApiKey': 'Chiave API Composio',
  'settings.connectorsSavedTitle': 'Salvata nel daemon locale',
  'settings.connectorsSavedWithTail': 'Salvata · ••••{tail}',
  'settings.connectorsSaved': 'Salvata',
  'settings.connectorsGetApiKey': 'Ottieni una chiave API',
  'settings.connectorsReplaceKeyPlaceholder': 'Incolla una nuova chiave per sostituire quella salvata',
  'settings.connectorsApiKeyPlaceholder': 'Incolla la chiave API Composio',
  'settings.connectorsClear': 'Cancella',
  'settings.connectorsClearConfirmTitle': 'Cancellare la chiave API Composio salvata?',
  'settings.connectorsClearConfirmBody': 'Rimuovere la chiave disconnette tutti i connettori Composio collegati a questo spazio. Gli account connessi, le autorizzazioni OAuth e gli accessi agli strumenti verranno tutti rimossi.',
  'settings.connectorsClearConfirmContinue': 'Continua',
  'settings.connectorsClearFinalTitle': 'Questa azione disconnetterà tutti i connettori',
  'settings.connectorsClearFinalBody': 'Azione irreversibile. Dovrai riconnettere ogni integrazione dall\'inizio dopo aver incollato una nuova chiave.',
  'settings.connectorsClearFinalConfirm': 'Rimuovi chiave e disconnetti',
  'settings.connectorsClearArming': 'Un momento…',
  'settings.connectorsClearCancel': 'Annulla',
  'settings.connectorsSaveKey': 'Salva chiave',
  'settings.connectorsSaveKeyTitle': 'Invia questa chiave al daemon locale',
  'settings.connectorsKeySaving': 'Salvataggio…',
  'settings.connectorsKeySaved': 'Salvato ✓',
  'settings.connectorsKeyError': 'Impossibile salvare la chiave. Verifica che il daemon locale sia avviato poi riprova.',
  'settings.connectorsHelpSaved': 'La tua chiave sblocca il catalogo qui sotto e rimane nel daemon locale. Incolla una nuova chiave per sostituirla o cancellala.',
  'settings.connectorsHelpUnsaved': 'Modifiche non salvate — clicca su Salva chiave per memorizzare questa informazione nel daemon locale e sbloccare il catalogo qui sotto.',
  'settings.connectorsHelpEmpty': 'Aggiungi una chiave per sbloccare il catalogo qui sotto. Le chiavi sono memorizzate localmente nel daemon e non vengono mai inviate tramite variabili d\'ambiente.',
  'settings.connectorsLoadingSavedKey': 'Ricerca di una chiave salvata nel daemon locale…',
  'settings.autosaveSaving': 'Salvataggio…',
  'settings.autosaveSaved': 'Tutte le modifiche salvate',
  'settings.autosaveError': 'Impossibile salvare le modifiche. Il daemon locale potrebbe essere offline.',
  'settings.libraryToggleLabel': 'Alterna',
  'settings.memory': 'Memoria',
  'settings.memoryHint': 'Fatti personali estratti automaticamente dalle conversazioni',
  'settings.customInstructionsTitle': 'Regole globali',
  'settings.customInstructionsHint': 'Istruzioni fisse che OpenDesign deve seguire in ogni chat. Salva fatti, preferenze e contesto del progetto come memorie.',
  'settings.customInstructionsPlaceholder': 'es. "Usa sempre TypeScript. Preferisci i componenti funzionali. Mantieni le risposte concise."',
  'settings.memoryDescription': 'Fatti sulle tue preferenze estratti automaticamente, salvati in Markdown e reinseriti in ogni chat.',
  'settings.memoryEnabled': 'Abilitata',
  'settings.memoryDisabled': 'Disabilitata',
  'settings.memoryEnableLabel': 'Abilita iniezione di memoria',
  'settings.memoryDisabledBanner': 'La memoria è attualmente disabilitata. I fatti esistenti rimangono su disco ma non verranno iniettati nelle nuove chat.',
  'settings.memoryNew': 'Nuova memoria',
  'settings.memoryEdit': 'Modifica',
  'settings.memoryDelete': 'Elimina',
  'settings.memoryPreview': 'Anteprima',
  'settings.memoryEmpty': 'Nessuna memoria per ora.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Preferisco la modalità scura',
  'settings.memoryName': 'Nome',
  'settings.memoryDesc': 'Descrizione in una riga',
  'settings.memoryBody': 'Corpo (Markdown supportato)',
  'settings.memoryBodyHint': 'Enuncia la regola, poi aggiungi Why e How to apply.',
  'settings.memoryStartersLabel': 'Hai bisogno di un punto di partenza? Clicca per compilare il modulo:',
  'settings.memoryStarterUserName': 'Il mio ruolo',
  'settings.memoryStarterUserDesc': 'Sono un ingegnere frontend che lavora su uno strumento di design SaaS',
  'settings.memoryStarterUserBody': '- Ruolo: ingegnere frontend senior\n- Stack: React, TypeScript, Vite\n- Dominio: strumenti di design / collaborazione\n- Fuso orario: GMT+8 (Asia/Shanghai)\n\nQuando applicare: qualsiasi chat — inquadra gli esempi attorno al frontend web.',
  'settings.memoryStarterFeedbackName': 'Preferenze UI',
  'settings.memoryStarterFeedbackDesc': 'Modalità scura, testo del corpo grande, bassa densità di informazioni',
  'settings.memoryStarterFeedbackBody': '- Tema: scuro per impostazione predefinita\n- Testo del corpo: ≥ 18px\n- Densità di informazioni: preferisci spazi bianchi, meno elementi per schermo\n\nPerché: meno affaticamento degli occhi durante lunghe sessioni.\nQuando applicare: ogni volta che generi UI, pagine web o diapositive.',
  'settings.memoryStarterProjectName': 'Progetto attuale',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — editor di design guidato da chat',
  'settings.memoryStarterProjectBody': '- Obiettivo: spedire l\'editor guidato da chat questo trimestre\n- Priorità: rendering in streaming, multimodale locale, offline-first\n- Stack: Next.js 16, daemon Express, SQLite\n\nQuando applicare: in qualsiasi conversazione su questo progetto.',
  'settings.memorySaveHint': 'Non salvato automaticamente — clicca su Crea / Salva per applicare.',
  'settings.memoryIndexSaveHint': 'Le modifiche all\'indice non vengono salvate automaticamente — clicca su Salva indice per applicare.',
  'settings.memoryIndexUnsaved': 'Modifiche non salvate',
  'settings.memoryFlashCreated': '✓ Memoria creata',
  'settings.memoryFlashSaved': '✓ Memoria salvata',
  'settings.memoryFlashDeleted': '✓ Memoria eliminata',
  'settings.memoryFlashIndexSaved': '✓ Indice salvato',
  'settings.memoryFlashPathCopied': '✓ Percorso copiato',
  'settings.memoryNameLabel': 'Titolo',
  'settings.memoryTypeLabel': 'Tipo',
  'settings.memoryDescLabel': 'Descrizione',
  'settings.memoryBodyLabel': 'Contenuto',
  'settings.memoryTypeUser': 'Utente',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Progetto',
  'settings.memoryTypeReference': 'Riferimento',
  'settings.memoryIndex': 'MEMORY.md (indice)',
  'settings.memoryIndexSave': 'Salva indice',
  'settings.memoryIndexReset': 'Reimposta',
  'settings.memoryToastChanged': 'Memoria aggiornata',
  'settings.memoryToastClickHint': 'Mostra',
  'settings.memoryAll': 'Tutto',
  'settings.memoryExtractions': 'Cronologia estrazione',
  'settings.memoryExtractionsHint': 'Tentativi di estrazione recenti supportati da LLM. L\'estrazione euristica regex viene sempre eseguita per prima; l\'estrazione LLM viene eseguita in background dopo ogni turno.',
  'settings.memoryExtractionsEmpty': 'Nessuna estrazione ancora. Il prossimo turno di chat popolerà questo elenco.',
  'settings.memoryExtractionsRefresh': 'Aggiorna',
  'settings.memoryExtractionsRefreshing': 'Aggiornamento…',
  'settings.memoryExtractionPhaseRunning': 'In esecuzione…',
  'settings.memoryExtractionPhaseSuccess': 'Successo',
  'settings.memoryExtractionPhaseSkipped': 'Saltato',
  'settings.memoryExtractionPhaseFailed': 'Fallito',
  'settings.memoryExtractionSkipNoProvider': 'Nessuna chiave API configurata per l\'estrazione di memoria LLM.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'La memoria è disabilitata.',
  'settings.memoryExtractionSkipEmpty': 'Messaggio utente vuoto — niente da estrarre.',
  'settings.memoryExtractionSkipNoMatch': 'Nessun pattern regex corrisponde a questo turno.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'impostazioni media',
  'settings.memoryExtractionProviderOverride': 'impostazioni memoria',
  'settings.memoryExtractionProposed': 'proposto',
  'settings.memoryExtractionWritten': 'scritto',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Elimina',
  'settings.memoryExtractionsClear': 'Cancella',
  'settings.memoryExtractionsClearTitle': 'Cancella tutta la cronologia di estrazione',
  'settings.memoryExtractionsClearConfirm': 'Cancellare tutta la cronologia di estrazione? Questa azione non può essere annullata.',
  'settings.memoryNoProviderBannerTitle': 'L\'estrazione di memoria LLM non è in esecuzione',
  'settings.memoryNoProviderBannerBody': 'Nessuna chiave API trovata per l\'estrattore di memoria. Aggiungi una chiave OpenAI sotto Provider di media, o imposta ANTHROPIC_API_KEY / OPENAI_API_KEY nell\'ambiente, per abilitare l\'estrazione guidata da LLM. L\'estrazione euristica regex è ancora attiva.',
  'settings.memoryTypeProfile': 'Profilo',
  'settings.memoryTypeRule': 'Regola',
  'settings.memoryTabMemories': 'Memorie',
  'settings.memoryTabMemoriesCaption': 'Visualizza e gestisci la memoria salvata',
  'settings.memoryTabHow': 'Come funziona',
  'settings.memoryTabHowCaption': 'I due cicli e i relativi controlli',
  'settings.memoryAddDisclosure': 'Aggiungi o importa memorie',
  'settings.memoryAddDisclosureHint': 'Profilo, inserimento manuale o app collegate',
  'settings.memoryProfileTab': 'Profilo di lavoro',
  'settings.memoryProfileTabCaption': 'Chi sei e i tuoi valori predefiniti',
  'settings.memoryProfileTitle': 'Il tuo profilo di lavoro',
  'settings.memoryProfileHint':
    'Alcuni dati su di te e sui tuoi valori predefiniti. La memoria li inietta prima di ogni attività, così l\'agente capisce cosa intendi da una richiesta breve.',
  'settings.memoryProfileName': 'Profilo di lavoro',
  'settings.memoryProfileDescription':
    'Ruolo, azienda, dominio, pubblico, gusto e valori predefiniti che l\'assistente dovrebbe riutilizzare.',
  'settings.memoryProfileSave': 'Salva profilo',
  'settings.memoryProfileSaving': 'Salvataggio…',
  'settings.memoryProfileSaved': 'Profilo salvato',
  'settings.memoryProfileRole': 'Ruolo',
  'settings.memoryProfileRolePlaceholder': 'es. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Azienda / Team',
  'settings.memoryProfileCompanyPlaceholder': 'es. Acme, growth team',
  'settings.memoryProfileDomain': 'Dominio',
  'settings.memoryProfileDomainPlaceholder': 'es. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Pubblico principale',
  'settings.memoryProfileAudiencePlaceholder': 'es. dirigenti, ingegneri, utenti finali',
  'settings.memoryProfileAesthetic': 'Estetica / gusto',
  'settings.memoryProfileAestheticPlaceholder':
    'es. pulito ed editoriale, sfondi chiari, spazi bianchi generosi',
  'settings.memoryProfileDeliverables': 'Deliverable predefiniti',
  'settings.memoryProfileDeliverablesPlaceholder': 'es. landing page, deck, one-pager',
  'settings.memoryProfileLocale': 'Locale / Lingua',
  'settings.memoryProfileLocalePlaceholder': 'es. Inglese (USA), Cinese semplificato',
  'settings.memoryProfileGoals': 'Obiettivi attuali',
  'settings.memoryProfileGoalsPlaceholder':
    'es. pubblicare la nuova pagina prezzi, aumentare le conversioni del flusso di prova',
  'settings.memoryHooksTitle': 'Hook di memoria',
  'settings.memoryHooksHint':
    'Scegli quali parti della memoria vengono eseguite automaticamente. L\'interruttore principale qui sopra le disattiva tutte.',
  'settings.memoryHooksProfileLabel': 'Usa il mio profilo',
  'settings.memoryHooksProfileDesc': 'Inietta il tuo profilo di lavoro in ogni attività.',
  'settings.memoryHooksRewriteLabel': 'Riscrivi richieste brevi',
  'settings.memoryHooksRewriteDesc': 'PRE: espande una richiesta breve in un brief completo dell\'attività.',
  'settings.memoryHooksVerifyLabel': 'Auto-verifica output',
  'settings.memoryHooksVerifyDesc': 'POST: confronta il risultato con le tue regole, poi mostra una scorecard.',
  'settings.memoryHooksExtractionLabel': 'Impara dalle chat',
  'settings.memoryHooksExtractionDesc': 'Cattura fatti e preferenze utili dai turni di chat.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Installa',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Percorso locale',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/percorso/alla/cartella-skill',
  'settings.libraryInstallButton': 'Installa',
  'settings.libraryUninstall': 'Disinstalla',
  'settings.libraryBuiltIn': 'Integrato',
  'settings.libraryInstalled': 'Installato',
  'notify.successTitle': 'Attività completata',
  'notify.failureTitle': 'Attività fallita',
  'notify.successBody': 'Un turno è completato.',
  'notify.failureBody': 'L\'attività si è conclusa con un errore.',
  'updater.available': 'Aggiornamento disponibile',
  'updater.activeRunsTitle': 'OpenDesign sta ancora lavorando',
  'updater.activeRunsBody': '{count} attività sono ancora in esecuzione. Il riavvio le interromperà.',
  'updater.activeRunsUnknownBody': 'OpenDesign non ha potuto verificare se ci sono attività in corso. Il riavvio potrebbe interrompere il lavoro attivo.',
  'updater.availableBody': 'OpenDesign {version} è disponibile. Verrà scaricato prima di aprire il programma di installazione.',
  'updater.checking': 'Controllo aggiornamenti',
  'updater.download': 'Scarica aggiornamento',
  'updater.downloading': 'Download aggiornamento',
  'updater.downloadingPercent': 'Download aggiornamento {percent}%',
  'updater.done': 'Fatto',
  'updater.failed': 'Aggiornamento non riuscito',
  'updater.installerOpenBody': 'Il programma di installazione è aperto. OpenDesign si sta chiudendo per consentirti di completare l’aggiornamento.',
  'updater.installerOpened': 'Programma di installazione aperto',
  'updater.later': 'Più tardi',
  "updater.allowSilentUpdates": "Consenti l’installazione automatica dei futuri aggiornamenti in-app",
  'updater.openFailedFallback': 'Impossibile aprire il programma di installazione.',
  'updater.installRestart': 'Installa e riavvia',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Installa aggiornamento',
  'updater.opening': 'Apertura del programma di installazione...',
  'updater.dialogAvailableGeneric': 'È disponibile una nuova versione.\nScaricala per installare l’aggiornamento.',
  'updater.dialogAvailableVersion': 'La v{version} è disponibile.\nScaricala per installare l’aggiornamento.',
  'updater.dialogCheckFailed': 'Impossibile controllare gli aggiornamenti.\nLe informazioni sulla versione sono temporaneamente non disponibili. Verifica la connessione di rete e riprova.',
  'updater.dialogReadyGeneric': 'È pronta una nuova versione.\nEsperienza migliore, design più intelligente.',
  'updater.dialogReadyVersion': 'v{version} è pronta.\nEsperienza migliore, design più intelligente.',
  'updater.dialogUnsupported': 'Gli aggiornamenti in-app non sono disponibili qui.\nScarica l’ultima versione dalla pagina delle release.',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'Esci da OpenDesign',
  'updater.quitFailedBody': 'Il programma di installazione è aperto, ma OpenDesign non è riuscito a uscire. Esci da OpenDesign prima di sostituire l’app.',
  'updater.quitFailedTitle': 'Impossibile uscire',
  'updater.quitting': 'Uscita...',
  'updater.ready': 'Aggiornamento pronto',
  'updater.readyGeneric': 'È pronta una nuova versione. OpenDesign si chiuderà e aprirà il programma di installazione.',
  'updater.readyVersion': 'OpenDesign {version} è pronto. OpenDesign si chiuderà e aprirà il programma di installazione.',
  'updater.reinstallLearnMore': 'Scopri di più',
  'updater.reinstallReadyGeneric': 'Questo aggiornamento richiede una reinstallazione completa. OpenDesign si chiuderà e aprirà il programma di installazione.',
  'updater.reinstallReadyVersion': 'OpenDesign {version} richiede una reinstallazione completa. OpenDesign si chiuderà e aprirà il programma di installazione.',
  'updater.restartAnyway': 'Riavvia comunque',
  'updater.upToDate': 'Hai già la versione più recente.',
  'updater.viewVersionFeatures': 'Scopri le novità',
  'updater.manualDownload': 'Scarica manualmente',
  'whatsNew.updatedTitle': 'OpenDesign {version} è arrivato',
  'whatsNew.cta': 'Vedi le note di rilascio',
  'newsletter.label': 'Newsletter (opzionale)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Modello di memoria',
  'settings.memoryModelInlineSameAsChat': 'Stesso della chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Stesso della chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Stesso della chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Facoltativo. L\'estrattore di memoria usa una chiave API env-var o media-providers su questo provider; fissare un modello qui sovrascrive solo la scelta automatica.',
  'settings.memoryModelInlineHintCliConstrained': 'Facoltativo. La memoria chiamerà {provider}; necessita di una chiave API env-var o media-providers per quel provider, o scegli un modello sotto per sovrascrivere.',
  'settings.memoryModelInlineHintByok': 'Facoltativo. Riutilizza la tua chiave API di chat sullo stesso provider — scegliere un modello diverso (di solito più economico) cambia solo il corpo della richiesta.',
  'settings.memoryModelInlineFlashSaved': 'Salvato',
  'settings.memoryModelInlineFlashCleared': 'Cancellato',
  'settings.orbit.eyebrow': 'Automazione',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Riepilogo giornaliero dei connettori',
  'settings.orbit.lede': 'Raccoglie l\'attività dei connettori secondo una pianificazione e pubblica il risultato come artefatto live aggiornabile.',
  'settings.orbit.statusOnTitle': 'Le esecuzioni giornaliere pianificate sono attive',
  'settings.orbit.statusOffTitle': 'Le esecuzioni giornaliere pianificate sono disattivate',
  'settings.orbit.statusActive': 'Attivo',
  'settings.orbit.statusOff': 'Disattivato',
  'settings.orbit.runTitle': 'Avvia un\'esecuzione Orbit e apri la conversazione live',
  'settings.orbit.running': 'Esecuzione in corso…',
  'settings.orbit.runOpen': 'Esegui ora',
  'settings.orbit.dailySummaryTitle': 'Riepilogo giornaliero',
  'settings.orbit.dailySummarySub': 'Viene eseguito una volta al giorno all\'ora locale pianificata.',
  'settings.orbit.on': 'Attivo',
  'settings.orbit.off': 'Disattivato',
  'settings.orbit.runTimeTitle': 'Ora di esecuzione',
  'settings.orbit.runTimeSub': 'Predefinito 08:00. Salva per applicare alla pianificazione del daemon.',
  'settings.orbit.runTimeAria': 'Ora di esecuzione giornaliera di Orbit',
  'settings.orbit.nextRun': 'Prossima esecuzione',
  'settings.orbit.nextRunScheduledAfterSave': 'Pianificata dopo il salvataggio',
  'settings.orbit.schedule': 'Pianificazione',
  'settings.orbit.pausedManualOnly': 'In pausa — solo esecuzioni manuali',
  'settings.orbit.templateTitle': 'Modello di prompt',
  'settings.orbit.templateMissing': 'Il modello {id} non è installato.',
  'settings.orbit.templateMissingOption': '{id} (mancante)',
  'settings.orbit.templateMissingInstall': 'Installa una skill Orbit per guidare il prompt.',
  'settings.orbit.templateMissingPickAnother': 'Scegli un altro modello dall\'elenco.',
  'settings.orbit.templateResetTitle': 'Ripristina su {id}',
  'settings.orbit.templateReset': 'Ripristina',
  'settings.orbit.templateHelp': 'Guida Orbit con una skill — il prompt di esempio del modello selezionato viene iniettato in ogni esecuzione Orbit affinché i riepiloghi seguano questa forma.',
  'settings.orbit.templateAria': 'Modello di prompt Orbit',
  'settings.orbit.templatesLoading': 'Caricamento modelli…',
  'settings.orbit.templatesOptgroup': 'Modelli di skill Orbit',
  'settings.orbit.lastRun': 'Ultima esecuzione',
  'settings.orbit.triggerManual': 'Manuale',
  'settings.orbit.triggerScheduled': 'Pianificata',
  'settings.orbit.meterAria': '{succeeded} riusciti, {skipped} saltati, {failed} falliti su {checked} verificati',
  'settings.orbit.countChecked': 'Verificati',
  'settings.orbit.countSucceeded': 'Riusciti',
  'settings.orbit.countSkipped': 'Saltati',
  'settings.orbit.countFailed': 'Falliti',
  'settings.orbit.runError': 'Impossibile eseguire Orbit. Verifica che il daemon locale sia in esecuzione e che i connettori siano configurati.',
  'settings.orbit.gateAriaLabel': 'Sono richiesti connettori per utilizzare Orbit',
  'settings.orbit.gateEyebrow': 'Configurazione richiesta',
  'settings.orbit.gateTitle': 'Connetti uno strumento per alimentare Orbit',
  'settings.orbit.gateBody': 'Orbit riepiloga l\'attività dei tuoi connettori. Non hai ancora connesso nulla — aggiungi almeno un\'integrazione affinché Orbit abbia qualcosa da riportare.',
  'settings.orbit.gateBodyNoKey': 'Orbit riepiloga l\'attività dei tuoi connettori, e i connettori passano attraverso Composio. Aggiungi una chiave API Composio in Connettori per sbloccare il catalogo e scegliere la tua prima integrazione.',
  'settings.orbit.gateAction': 'Apri Connettori',
  'settings.orbit.gateActionNoKey': 'Configura Composio',
  'settings.orbit.gateLoading': 'Verifica dei tuoi connettori…',
  'settings.orbit.controlsLockedBadge': 'Bloccato',
  'settings.orbit.controlsLockedHint': 'Connetti uno strumento per sbloccare la pianificazione e il modello di Orbit.',
  'settings.orbit.artifactKickerLive': 'artefatto live',
  'settings.orbit.artifactKickerLegacy': 'Riepilogo legacy',
  'settings.orbit.artifactTitle': 'Riepilogo giornaliero dell\'attività Orbit',
  'settings.orbit.artifactMetaLive': 'Artefatto HTML aggiornabile generato dall\'attività dei connettori.',
  'settings.orbit.artifactMetaLegacy': 'Generato prima dell\'attivazione del supporto per artefatti live — riesegui Orbit per pubblicarne uno.',
  'settings.orbit.copyMarkdownTitle': 'Copia il riepilogo Markdown negli appunti',
  'settings.orbit.copied': 'Copiato',
  'settings.orbit.copy': 'Copia',
  'settings.orbit.openArtifact': 'Apri artefatto',
  'settings.orbit.sourceMarkdown': 'Markdown sorgente',
  'settings.memoryModelInlineHintByokNeutral': 'La memoria usa un modello separato da quello della chat. Per impostazione predefinita usa il modello della chat.',
  'diagnostics.exportTitle': 'Esporta diagnostica',
  'diagnostics.exportButton': 'Esporta diagnostica',
  'diagnostics.exportHint': 'Raccoglie i log recenti dell\'app e le informazioni sulla macchina in un file zip che puoi condividere con il team.',
  'diagnostics.exporting': 'Esportazione…',
  'diagnostics.exportSuccess': 'Diagnostica salvata in {path}',
  'diagnostics.exportFailed': 'Impossibile esportare la diagnostica: {message}',
  'automations.eyebrow': 'Sessioni agent pianificate',
  'automations.title': 'Automazioni',
  'automations.lede': 'Pianifica conversazioni ricorrenti per il lavoro sui progetti, i digest Orbit e gli artefatti live.',
  'automations.summaryAria': 'Riepilogo automazioni',
  'automations.metricActive': 'Attive',
  'automations.metricPaused': 'In pausa',
  'automations.metricTemplates': 'Template',
  'automations.newAutomation': 'Nuova automazione',
  'automations.yourAutomations': 'Le tue automazioni',
  'automations.loading': 'Caricamento',
  'automations.emptyTitle': 'Nessuna automazione',
  'automations.emptyBody': 'Creane una da un template o parti da una pianificazione vuota.',
  'automations.targetNewEachRun': 'Nuovo progetto a ogni esecuzione',
  'automations.targetCreateEachRun': 'Nuovo progetto a ogni esecuzione',
  'automations.lastRun': 'Ultima esecuzione {time}',
  'automations.openResult': 'Apri risultato',
  'automations.run': 'Esegui',
  'automations.runNowTitle': 'Esegui ora e apri la conversazione',
  'automations.history': 'Cronologia',
  'automations.hideHistory': 'Nascondi cronologia',
  'automations.edit': 'Modifica',
  'automations.pause': 'Metti in pausa',
  'automations.resume': 'Riprendi',
  'automations.deleteAria': 'Elimina automazione',
  'automations.deleteTitle': 'Elimina questa automazione',
  'automations.deleteConfirm': 'Eliminare questa automazione? Le esecuzioni passate e i relativi progetti vengono conservati.',
  'automations.proposalsTitle': 'Proposte di evoluzione',
  'automations.proposalsSub': 'Esamina l\'output dell\'automazione prima che modifichi memoria, skill o design system.',
  'automations.proposalsPending': '{n} in attesa',
  'automations.apply': 'Applica',
  'automations.reject': 'Rifiuta',
  'automations.proposalsDismissReason': 'Ignorata in Automazioni',
  'automations.templatesTitle': 'Template',
  'automations.templatesSub': 'Orbit e gli artefatti live sono template all\'interno dello stesso flusso di automazione.',
  'automations.templatesCount': '{filtered} di {total}',
  'automations.templateFiltersAria': 'Filtri template',
  'automations.templatesEmptyTitle': 'Nessun template in questa categoria.',
  'automations.templatesEmptyBody': 'Prova un filtro diverso o parti da un\'automazione vuota.',
  'automations.useTemplate': 'Usa template',
  'automations.runHistoryLoading': 'Caricamento cronologia esecuzioni...',
  'automations.runHistoryEmpty': 'Nessuna esecuzione.',
  'automations.runHistoryTitle': 'Cronologia esecuzioni',
  'automations.runHistoryLatest': 'Ultime 10',
  'automations.crystallize': 'Cristallizza',
  'automations.crystallizing': 'Cristallizzazione',
  'automations.crystallizeTitle': 'Crea bozze di proposte di skill e memoria da questa esecuzione',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Apri conversazione',
  'automations.runHistoryAria': 'Cronologia esecuzioni automazione',
  'automations.proposalsAria': 'Proposte di evoluzione automazione',
  'automations.templatesAria': 'Template automazione',
  'automations.runInProgress': 'In corso',
  'automations.promptPlaceholder': 'Recupera l\'attività di ieri su GitHub + Linear e riassumi cosa è cambiato.',
  'automations.scheduleStatusPaused': 'In pausa',
  'automations.nextRunManualOnly': 'Solo manuale',
  'automations.nextRunScheduled': 'Pianificata',
  'automations.nextRunAt': 'Prossima {time}',
  'automations.statusSucceeded': 'Completata',
  'automations.statusFailed': 'Non riuscita',
  'automations.statusRunning': 'In esecuzione',
  'automations.statusQueued': 'In coda',
  'automations.statusCanceled': 'Annullata',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefatto live',
  'automations.kindAutomation': 'Automazione',
  'automations.proposalTargetMemory': 'Memoria',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Template automazione',
  'automations.proposalActionCreate': 'Crea',
  'automations.proposalActionUpdate': 'Aggiorna',
  'automations.proposalActionMerge': 'Unisci',
  'automations.proposalActionMove': 'Sposta',
  'automations.proposalActionDelete': 'Elimina',
  'automations.proposalActionPromote': 'Promuovi',
  'automations.filterAll': 'Tutte',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefatti live',
  'automations.filterMemory': 'Memoria',
  'automations.filterDesignSystems': 'Design system',
  'automations.filterSkills': 'Skill',
  'automations.filterConnectors': 'Connettori',
  'automations.filterCompression': 'Compressione',
  'automations.filterRelease': 'Rilascio',
  'automations.filterQuality': 'Qualità',
  'automations.tpl.memoryRefresh.title': 'Aggiorna la memoria del progetto a partire dal lavoro recente.',
  'automations.tpl.memoryRefresh.desc': 'Trasforma decisioni, preferenze e feedback ricorrenti in aggiornamenti di memoria riutilizzabili.',
  'automations.tpl.designSystemRefresh.title': 'Aggiorna i design system a partire dagli artefatti rilasciati.',
  'automations.tpl.designSystemRefresh.desc': 'Individua token, componenti e regole riutilizzabili nel lavoro di design recente.',
  'automations.tpl.liveArtifactRegistry.title': 'Verifica gli artefatti live e aggiorna le versioni obsolete.',
  'automations.tpl.liveArtifactRegistry.desc': 'Mantiene aggiornati dashboard, report e anteprime persistenti invece di duplicarli.',
  'automations.tpl.orbitDashboard.title': 'Crea una dashboard di attività dei connettori.',
  'automations.tpl.orbitDashboard.desc': 'Aggrega i connettori selezionati in una dashboard live in stile Orbit.',
  'automations.tpl.releaseNotes.title': 'Redigi le note di rilascio dal lavoro di design rilasciato.',
  'automations.tpl.releaseNotes.desc': 'Collega PR uniti, artefatti e modifiche rivolte al prodotto in note di rilascio.',
  'automations.tpl.qualityRegressionWatch.title': 'Monitora le regressioni di design e implementazione.',
  'automations.tpl.qualityRegressionWatch.desc': 'Confronta le modifiche recenti con benchmark, trace e riferimenti accettati.',
  'automations.tpl.orbitDaily.title': 'Digest giornaliero dei connettori.',
  'automations.tpl.orbitDaily.desc': 'Aggiorna un digest di attività dei connettori secondo una pianificazione.',
  'automations.tpl.liveStatusBoard.title': 'Mantieni aggiornato un artefatto di stato live.',
  'automations.tpl.liveStatusBoard.desc': 'Aggiorna un unico artefatto persistente invece di creare un nuovo report a ogni esecuzione.',
  'dsManager.areaAria': 'Area design system',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Modello',
  'dsManager.sourceAria': 'Origine design system',
  'dsManager.templateSourceAria': 'Origine template',
  'dsManager.yourSystems': 'I tuoi sistemi',
  'dsManager.officialPresets': 'Preset ufficiali',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Sincronizza con il team',
  'dsManager.syncToTeamFailed': 'Sincronizzazione con il team non riuscita',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'I tuoi template',
  'dsManager.yourSystemsAria': 'I tuoi design system',
  'dsManager.eyebrowDesignSystems': 'Design System',
  'dsManager.yourSystemsHeading': 'I tuoi sistemi',
  'dsManager.filterAria': 'Filtra i design system',
  'dsManager.filterAll': 'Tutti',
  'dsManager.filterPublished': 'Pubblicati',
  'dsManager.filterDraft': 'Bozza',
  'dsManager.createTitle': 'Crea nuovo design system',
  'dsManager.createBody': 'Insegna a OpenDesign il tuo brand, prodotto, codice, asset e riferimenti di design.',
  'dsManager.createAction': 'Crea',
  'dsManager.emptyMine': 'Nessun design system. Creane uno dal contesto reale del prodotto, esamina la bozza e poi pubblicalo per i progetti futuri.',
  'dsManager.badgeDefault': 'Predefinito',
  'dsManager.rowMetaUpdated': 'Tu · aggiornato {date}',
  'dsManager.edit': 'Modifica',
  'dsManager.openSystem': 'Apri',
  'dsManager.editWithAgent': 'Modifica con Agent',
  'dsManager.downloadTitle': 'Scarica design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Scarica {title} come .zip',
  'dsManager.downloadFailed': 'Impossibile scaricare il design system. Riprova.',
  'dsManager.deleteConfirm': 'Eliminare "{title}"? Questa operazione rimuove la bozza del design system da questo dispositivo.',
  'dsManager.makeDefault': 'Imposta come predefinito',
  'dsManager.statusPublished': 'Pubblicato',
  'dsManager.statusDraft': 'Bozza',
  'dsManager.openSystemAria': 'Apri {title}',
  'dsManager.deleteSystemAria': 'Elimina {title}',
  'dsManager.deletePermissionDenied': 'Non hai l’autorizzazione per eliminare questo design system.',
  'dsManager.presetsAria': 'Preset ufficiali dei design system',
  'dsManager.eyebrowLibrary': 'Libreria',
  'dsManager.eyebrowTemplates': 'Template',
  'dsManager.yourTemplatesAria': 'I tuoi template',
  'dsManager.emptyTemplates': 'Nessun template. Creane uno da qualsiasi progetto generato tramite Condividi, una volta abilitata la pubblicazione dei template.',
  'dsManager.templateDescFallback': 'Creato da un progetto',
  'dsManager.comingSoonBadge': 'Prossimamente',
  'dsManager.enterpriseDsTitle': 'Design system enterprise',
  'dsManager.enterpriseDsBody': 'I design system condivisi del team e le librerie di brand governate arriveranno presto.',
  'dsManager.enterpriseTplTitle': 'Template enterprise',
  'dsManager.enterpriseTplBody': 'I template approvati dal team e la pubblicazione a livello di organizzazione arriveranno presto.',
  'settings.instructionsTitle': 'Istruzioni e regole',
  'settings.instructionsSubtitle': 'Comportamento fisso che l\'assistente deve seguire',
  'settings.instructionsNavSub': 'Comportamento fisso dell\'assistente',
  'settings.customInstructionsDesc': 'Istruzioni fisse che OpenDesign segue in ogni chat. Non sono memorie salvate; usa Memoria per fatti, preferenze e contesto del progetto.',
  'mcpClient.forwardedToLabel': 'Inoltrato a:',
  'mcpClient.notForwardedToLabel': 'Non inoltrato a:',
  'mcpClient.forwardedAcpNote': 'Gli adattatori ACP contrassegnati come stdio ricevono da questo elenco solo i server MCP stdio; le voci HTTP e SSE vengono scartate all\'avvio.',
  'mcpClient.notForwardedNote': 'Per quegli agent, configura i server MCP nel file di configurazione dell\'agent stesso (ad es. ~/.codex/config.toml, ~/.gemini/settings.json); i server seguenti vengono ignorati silenziosamente in quel contesto.',

  // Brands library + extraction
  'brand.libraryTitle': 'Kit del brand',
  'brand.librarySubtitle': 'Teach OpenDesign your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Incolla un sito web, o scegli un brand qui sotto, ed estrarremo i suoi colori, font e logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Kit del brand',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Svuota cache aggiornamenti',
  'settings.clearUpdaterCacheHint': 'Rimuove gli aggiornamenti scaricati e le cache obsolete, quindi reimposta lo stato di aggiornamento. Da usare quando gli aggiornamenti sembrano bloccati.',
  'settings.clearUpdaterCacheButton': 'Svuota cache',
  'settings.clearUpdaterCacheConfirmButton': 'Conferma svuotamento',
  'settings.clearUpdaterCacheSuccess': 'Cache aggiornamenti svuotata.',
  'settings.clearUpdaterCacheFailed': 'Impossibile svuotare la cache aggiornamenti.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Crea una volta, costruisci ovunque',
  'onboarding.buildBody': 'OpenDesign trasforma il tuo brand in un design system riutilizzabile e mantiene tutto ciò che crei coerente e fedele al brand.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Crea un design system',
  'onboarding.buildHome': 'Vai alla home',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Parti da un brand che ami',
  'brandPicker.subtext': 'Clicca su un brand per estrarne il kit direttamente dal suo sito web.',
  'brandPicker.quickPicksLabel': 'Brand popolari — clicca per estrarre',
  'brandPicker.searchPlaceholder': 'Cerca brand…',
  'brandPicker.allCategories': 'Tutti',
  'brandPicker.extractAction': 'Estrai',
  'brandPicker.showMore': 'Mostra altro',
  'brandPicker.opening': 'Avvio dell\'estrazione — apertura di {brand}…',
  'ds.kitVisualize': 'Visualizza',
  'ds.kitEdit': 'Modifica',
  'ds.kitSource': 'Sorgente',
  'ds.saveDesignMd': 'Salva DESIGN.md',
  'ds.saving': 'Salvataggio…',
  'ds.copyDesignMd': 'Copia DESIGN.md',
  'ds.editDesignMd': 'Modifica DESIGN.md',
  'ds.openDesignMd': 'Apri DESIGN.md',
  'ds.copyDesignMdModule': 'Copia sezione {module}',
  'ds.editDesignMdModule': 'Modifica sezione {module}',
  'ds.openDesignMdModule': 'Apri sezione {module}',
  'ds.uploadMd': 'Carica MD',
  'ds.uploadFont': 'Aggiungi file font',
  'ds.pasteImage': 'Incolla immagine',
  'ds.refresh': 'Aggiorna',
  'ds.download': 'Scarica',
  'ds.importFolder': 'Importa cartella',
  'ds.reset': 'Reimposta',
  'ds.editingDesignMdHint': 'La modifica di questo Markdown aggiorna i moduli renderizzati del kit.',
  'ds.editingModuleHint': 'Stai modificando solo il modulo {module}.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Salva modulo',
  'ds.uploadLogo': 'Carica logo',
  'ds.uploadImage': 'Carica immagine',
  'ds.uploading': 'Caricamento…',
  'ds.moduleEmptyLogo': 'Nessun logo ancora',
  'ds.moduleEmptyFonts': 'Nessun font acquisito.',
  'ds.actionDone': 'Fatto',
  'ds.actionFailed': 'Qualcosa è andato storto. Riprova.',
  'ds.uploadDone': 'Caricato',
  'ds.uploadFailed': 'Caricamento non riuscito. Riprova.',
  'ds.deleteLogo': 'Elimina logo',
  'ds.deleteImage': 'Elimina {caption}',
  'ds.deleteProjectConfirm': 'Eliminare "{title}"? Questa operazione rimuove definitivamente questo design system e il suo progetto da questo dispositivo.',
  'ds.deleteProjectAction': 'Elimina {title}',
  'ds.editColor': 'Modifica {name}',
  'ds.colorLabel': 'Colore',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Valore Hex',
  'ds.saveColor': 'Salva colore',
  'ds.invalidHexColor': 'Inserisci un colore Hex valido, ad esempio #FF6A3D.',
  'ds.colorSaveFailed': 'Impossibile salvare questo colore.',
  'ds.colorResetFailed': 'Impossibile reimpostare questo colore.',
  'ds.designMdSectionLabel': 'Sezione {module} di DESIGN.md',
  'ds.kitErrorTitle': 'Questa vista ha riscontrato un problema.',
  'ds.kitErrorRetry': 'Ricarica',
  'ds.shortcutsLabel': 'Scorciatoie da tastiera',
  'ds.shortcutsHint': 'Scorciatoie: E modifica · C copia · U carica · R aggiorna · ⌫ elimina logo',
  'ds.moduleEmptyImages': 'Nessuna immagine ancora',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Punto di partenza',
  'newproj.startBlank': 'Vuoto',
  'newproj.startBlankHint': 'Parti da zero',
  'workspace.pages': 'Pagine',
  'workspace.allProjectFiles': 'Tutti i file del progetto',
  'workspace.newBlankPage': 'Nuova pagina vuota',
  'workspace.noPagesYet': 'Ancora nessuna pagina',
  'workspace.pageCreateFailed': 'Impossibile creare la pagina.',
  'workspace.pageCreatorTitle': 'Crea pagina',
  'workspace.pageCreatorSearch': 'Cerca modelli',
  'workspace.pageCreatorCategoryAll': 'Tutti gli scenari',
  'workspace.pageCreatorEmpty': 'Nessun tipo di pagina corrisponde alla ricerca.',
  'workspace.pageCreatorPreview': 'Anteprima',
  'workspace.pageCreatorUse': 'Usa',
  'fileViewer.presentInTabDeckHint': 'Note del relatore in una finestra popup',
  'fileViewer.presentEscHint': 'Premi Esc per uscire',
  'fileViewer.presenterPause': 'Pausa',
  'fileViewer.presenterResume': 'Riprendi',
  'fileViewer.presenterPrevious': 'Precedente',
  'fileViewer.presenterNext': 'Successiva',
  'questions.uploadingFiles': 'Caricamento dei file…',
  'questions.uploadNeedsProject': 'Il caricamento dei file richiede un progetto attivo.',
  'questions.uploadPartialFailed': '{uploaded} file caricati, ma {failed} non riusciti.',
  'questions.uploadFailed': 'Caricamento non riuscito per {failed} file.',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeDocument': 'Document',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': 'Provalo ora',
  'community.emptyTitle': 'Nessun modello {type} per ora',
  'community.emptyBody': 'I modelli pubblicati nella community appariranno qui.',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'WEBART official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'Questa volta, intelligenza di alto livello. Senza limiti.',
  'campaign.deepseekV4Flash.description': 'Landing, siti, deck e immagini — quanto ti serve, fino a quando è a posto.',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro e V4 Flash illimitati',
  'campaign.deepseekV4Flash.timing': '13–27 ago: gratis durante la campagna',
  'campaign.deepseekV4Flash.ruleSummary': 'Dal 13 al 27 ago, gli utenti a pagamento possono usare DeepSeek V4 Pro e V4 Flash gratis in OpenDesign. Abusi su larga scala possono sospendere l’accesso alla campagna.',
  'campaign.deepseekV4Flash.windowLabel': '13–27 ago',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'due settimane gratis',
  'campaign.deepseekV4Flash.boundary': 'La quota illimitata del modello e le generazioni gratuite del piano valgono solo in OpenDesign — non via MCP, CLI, API o altre superfici. L’interpretazione finale spetta a OpenDesign. Alcuni modelli potrebbero richiedere una coda nelle ore di punta.',
  'campaign.deepseekV4Flash.countdownLabel': 'Conto alla rovescia',
  'campaign.deepseekV4Flash.countdownEnded': 'Campagna terminata',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}g {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Chiudi',
  'campaign.deepseekV4Flash.unlocked': 'Sbloccato',
  'campaign.deepseekV4Flash.locked': 'Bloccato',
  'campaign.deepseekV4Flash.later': 'Più tardi',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Due settimane gratis',
  'campaign.deepseekV4Flash.paid.status': 'Sbloccato · 13–27 ago',
  'campaign.deepseekV4Flash.paid.cta': 'Usa ora',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Illimitato',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Gratis per i piani a pagamento',
  'campaign.deepseekV4Flash.unpaid.status': 'Upgrade per sbloccare · fino al 27 ago',
  'campaign.deepseekV4Flash.unpaid.cta': 'Fai upgrade e usa',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Serve upgrade',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Abbonati durante la campagna per usarlo gratis; termina il 27 ago.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'In pausa',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Rilevato uso anomalo ad alto volume: accesso campagna in pausa. Contatta il supporto se serve aiuto.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash illimitati e gratis',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro e V4 Flash illimitati e gratis — vedi i prezzi',

  'experienceSurvey.tag': "Il tuo parere ci serve: aiutaci a migliorare OpenDesign",
  'experienceSurvey.close': "Chiudi",
  'experienceSurvey.recommendation': "Quanto è probabile che consigli OpenDesign a un collega o a un amico?",
  'experienceSurvey.recommendationLow': "Per niente probabile",
  'experienceSurvey.recommendationHigh': "Estremamente probabile",
  'experienceSurvey.improvement': "Cosa dovremmo migliorare per primo?",
  'experienceSurvey.improvement.wrongOutput': "Non è quello che avevo chiesto",
  'experienceSurvey.improvement.falseDone': "Dice fatto ma non cambia nulla",
  'experienceSurvey.improvement.hardToUse': "Scomodo da usare",
  'experienceSurvey.improvement.upgradePrompts': "Troppi avvisi di abbonamento",
  'experienceSurvey.improvement.stuck': "Si blocca o fallisce",
  'experienceSurvey.improvement.slow': "Troppo lento",
  'experienceSurvey.improvement.looks': "Il risultato non è bello",
  'experienceSurvey.improvement.regression': "Rompe altre cose",
  'experienceSurvey.improvement.other': "Altro",
  'experienceSurvey.otherPlaceholder': "Raccontacelo con parole tue",
  'experienceSurvey.submit': "Invia",
  'experienceSurvey.skip': "Salta",
  'experienceSurvey.thanksTitle': "Grazie!",
  'experienceSurvey.thanksBody': "Il tuo feedback arriva direttamente al team.",
  'chat.record.verb.read': "Letto",
  'chat.record.verb.write': "Creato",
  'chat.record.verb.edit': "Modificato",
  'chat.record.verb.search': "Cercato",
  'chat.record.verb.exec': "Eseguito",
  'chat.record.failed': "Errore",
  'chat.record.hits': "{count} risultati",
  'chat.record.slowUpstream': 'Il provider risponde lentamente — {seconds}s di attesa',
  'chat.record.running': "In corso",
  'chat.record.thinking': "Sta pensando",
  'chat.record.thinkingTokens': "{count} token",
  'chat.record.thoughts': "Ragionamento",
  'chat.record.done': "Completato",
  'chat.record.failedTurn': "Esecuzione fallita",
  'chat.record.plan': "Piano · {count} passi",
  'chat.record.planStep': "Passaggio {current} di {total}",
  'chat.record.imageBatch': "Generazione illustrazioni",
  'chat.record.imageCount': "{count} immagini",
  'chat.record.retry': "Riprova",
  'chat.record.viewImage': "Vedi immagine {index}",
  'chat.record.viewLarge': "Ingrandisci",
  'chat.record.imagePending': "Generazione illustrazione…",
  'chat.record.audioBatch': "Generazione audio",
  'chat.record.videoBatch': "Generazione video",
  'chat.record.audioCount': "{count} clip",
  'chat.record.videoCount': "{count} video",
  'chat.record.audioPending': "Generazione audio…",
  'chat.record.videoPending': "Generazione video…",
  'chat.record.viewAudio': "Apri audio {index}",
  'chat.record.viewVideo': "Apri video {index}",
  'chat.designSystemStatus.title': "Creazione del workspace del design system",
  'chat.designSystemStatus.description': "Open Design sta usando le fonti di configurazione per generare questo progetto.",
  'labs.title': "Open Design Labs",
  'labs.itemAbout': "Informazioni su {name}",
  'labs.navHint': "Prova le funzionalità prima del rilascio.",
  'labs.pageDesc': "Accedi in anteprima a funzionalità non ancora rilasciate. Di solito sono migliori del comportamento attuale e disattivarle ripristina subito lo stato corrente.",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "Se attivo, la prossima generazione usa la strategia più recente di OpenDesign, con risultati molto più curati (beta)",
  'labs.harnessTooltip': "Passa all harness dell agente che Open Design ha creato per il lavoro di design. Impaginazione, struttura e livello di completezza migliorano in modo evidente.",
  'labs.harnessScope': "Oggi copre prototipi, slide, materiali di marketing e Hyperframes. Alcuni agenti non sono ancora supportati.",
  'labs.envOverrideNotice': "Una variabile d ambiente controlla questa impostazione, quindi non può essere modificata qui.",
  'labs.loadFailedNotice': "Impossibile leggere questa impostazione. Verifica che il daemon locale sia in esecuzione.",
  'labs.optOutPrompt': "Tornato al metodo precedente. Cosa non ha funzionato?",
  'labs.optOutWorseOutput': "Risultati peggiori",
  'labs.optOutTooSlow': "Troppo lento",
  'labs.optOutNotWhatIWanted': "Non è quello che volevo",
  'labs.optOutOther': "Altro",
  'labs.optOutSkip': "Salta",
  'labs.optOutOtherPlaceholder': "Cosa non ha funzionato esattamente?",
  'labs.optOutSubmit': "Invia",
  'chat.conversationsSearchPlaceholder': "Cerca conversazioni",
  'chat.conversationsNoMatches': "Nessuna conversazione corrispondente.",
  'chat.attachments.preview': "Anteprima di {name}",
  'chat.record.canceled': "Annullato",
  'chat.record.pending': "Non avviato",
  'chat.record.unfinished': "Non completato",
};
